import { Power0, TweenMax } from "gsap";
import * as PIXI from 'pixi.js';
import { ITimeout } from "../../multigame/Context/Timeout";
import { Help, HelpPagePayTable } from "../../multigame/help/Help";
import { HelpFactory } from "../../multigame/help/HelpFactory";
import { IHelpFactory } from "../../multigame/help/IHelpFactory";
import { FontResource } from "../../multigame/ResourceManager/FontResource";
import { DecodedImageResource, ImageResource } from "../../multigame/ResourceManager/ImageResource";
import { Resourceful2 } from "../../multigame/ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../multigame/ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../multigame/ResourceManager/ResourceManager";
import { SpriteResource } from "../../multigame/ResourceManager/SpriteResource";
import { RobotPlay } from "../../multigame/RobotPlay";
import { JackpotValuesPause, JackpotValuesResume, ScreenProtocol, ScreenProtocolScope } from "../../multigame/ScreenProtocol";
import { FillingPotFeature, FruitGames, JackpotDisplayType, MenuType, PanelType, Settings } from "../../multigame/Settings";
import { SlotGameInitData } from "../../multigame/SlotGameInitData";
import { AddMouseDownListener, Color, Compare, CreateElement, Delay, Filter, Geometry, IsDebug, Log, LogGroup, MakeColorGradient, NextTaskAsync, now, Rect, Scale, SetStyles, Size, Timing } from ".././MyHelpers";
import { AwardOptionPosition, BasegameSpinAction, BetConfig, BetRequest, BetType, BigSymbolFreegamesCommonConfiguration, CelebrationType, DoubleUpGameState, ExpandingWildReelConfiguration, ExtendedSpinAndHoldCommonConfiguration, FrontendErrorCode, IPublicSimpleBonusTrigger, ISimpleBonusAction, LineWin, MultiBonusCommonConfiguration, PlayWindow, Position, ScatterRandomAwardConfiguration, ScatterRandomAwardResult, ScatterResult, SharedJackpotGameState, SharedJackpotWin, SimpleSlotGameState, SimpleTriggerResult, SlotGameBet, SpinAndHoldCommonConfiguration, SpinAndHoldStartAction, SpinSuccess, SymbolType } from "../api";
import { AudioManager, ITrack, Track } from "../AudioManager";
import { ISystemContext } from "../Context/SystemContext";
import { GameViewAppPixi } from "../engine/gameViewAppPixi";
import { Button, Light, OutputState } from "../IO";
import { JackpotSharedShow } from "../JackpotSharedShow";
import { Money } from "../Money";
import { PressButtons } from "../MultigameAvailableButtons";
import { MultigameParams } from "../MultigameParams";
import { JSONResource } from "../ResourceManager/JSONResource";
import { service } from "../services";
import { availableSpinParams, ChangeSpeedFactor, ChangeSpeedSpine, SpeedManager, SpinAnimParams } from "../SpeedManager";
import { TranslatedLocation, Translator } from "../Translator";
import { ZIndex } from "../ZIndex";
import { AnticipacionPIXIAPP } from "./AnticipacionPIXIAPP";
import { BigWinCountAnimationPIXIAPP } from "./BigWinCountAnimationPIXIAPP";
import { BigSymbolFreegamesBonusFactory, IBigSymbolFreegamesBonusFactory } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesFactory";
import { BigSymbolFreegamesBonusParams } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesParams";
import { BigSymbolSpinAndHoldBonusFactory, IBigSymbolSpinAndHoldBonusFactory } from "./Bonus/BigSymbolSpinAndHold/BigSymbolSpinAndHoldFactory";
import { Bonus } from "./Bonus/Bonus";
import { ExtendedSpinAndHoldBonusFactory, IExtendedSpinAndHoldBonusFactory } from "./Bonus/ExtendedSpinAndHold/ExtendendSpinAndHoldFactory";
import { BonusLoadingItem } from "./Bonus/LoadingItem";
import { SlotBonus } from "./Bonus/SlotBonus";
import { ISpinAndHoldBonusFactory, SpinAndHoldBonusFactory } from "./Bonus/SpinAndHold/SpinAndHoldFactory";
import { SpinAndHoldParams } from "./Bonus/SpinAndHold/SpinAndHoldParams";
import { BonusMultiplier, BonusMultiplierResponsive } from "./BonusMultiplier";
import { DenomMenuPIXIAPP } from "./DenomMenuPIXIAPP";
import { DoubleUp, DoubleUpParams } from "./DoubleUp";
import { ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam, IExpandingWildsBulkFactory } from "./ExpandingWildBulk";
import { ExpandingWildsBulkPIXIAPP } from "./ExpandingWildBulkPIXIAPP";
import { ExpandingWildsReelParam } from "./ExpandingWildReel";
import { ExpandingWildsReelPIXIAPP } from "./ExpandingWildReelPIXIAPP";
import { FillingPotGeneric, OnDestroyCallbackHandler } from "./FillingPot/FillingPotGeneric";
import { BonusWillUpdateFillingPotFeature } from "./FillingPot/IFillingPotIncrement";
import { FreegameBonusFactory, FreegameBonusParams, IFreegameBonusAndPickElementFactory } from "./FreegameBonus/FreegameBonus";
import { GamePresentation } from "./GamePresentation";
import { GameState } from "./GameState";
import { ActionStats } from "./IHistoyGame";
import { IPanelFactory } from "./panel/IPanelFactory";
import { ButtonColors, Panel } from "./panel/panel";
import { PanelFactory } from "./panel/PanelFactory";
import { PopUpSettingsParams, PopUpSettingsResponsive } from "./panel/PopUpSettings";
import { IPayTableFactory, IPaytableParams } from "./Paytable/IPayTableFactory";
import { PayTable } from "./Paytable/Paytable";
import { PickBonusFactory } from "./PickBonus/PickBonus";
import { PickBonusParams } from "./PickBonus/PickBonusParams";
import { ReplayMessage } from "./ReplayMessage";
import { RewardColor } from "./ScatterRandomAward/RewardOptionFactory";
import { ScatterRandomAwardCreateParams, ScatterRandomAwardResults } from "./ScatterRandomAward/ScatterRandomAward";
import { ScatterRandomAwardPIXI } from "./ScatterRandomAward/ScatterRandomAwardPIXI";
import { ShakeAnimation } from "./ShakeAnimation";
import { SlotFeature, SlotFeaturePIXI } from "./SlotFeature";
import { BonusFinish, BonusPickElement, BonusPickReveal, BonusRevealRemaining, BonusStartConfigMessage, BonusTotalResult, CashInParams, CashOutParams, IBonusStartConfig, RunResultMessage, SlotGame, SymbolPosition } from "./SlotGame";
import { SlotGameMessages } from "./SlotGameScreenMessages";
import { SlotGameState } from "./SlotGameState";
import { SlotGameType1Shared } from "./SlotGameType1Shared";
import { SlotSymbol } from "./SlotSymbol";
import { SlotSymbolSprite } from "./SlotSymbolSprite";
import { ReelMapper, ReelSymbolsToDisplay } from "./SpinAnimation/ReelMapper";
import { ReelSetMapper } from "./SpinAnimation/ReelSetMapper";
import { OnDeccelerationParams, ReelSpinAnimation } from "./SpinAnimation/ReelSpinAnimation";
import { SpinAnimation } from "./SpinAnimation/SpinAnimation";
import { SpinnableReels, SpinnableReelsParams } from "./SpinAnimation/SpinnableReels";
import { SpinnableReelsBigCanvas } from "./SpinAnimation/SpinnableReelsBigCanvas";
import { SpinTargetParams } from "./SpinAnimation/SpinTargetParams";
import { AnticipationType, GameConfigurationJson, SymbolCollection, SymbolTypeAnim } from "./SpineSymbols/SymbolsCollection";
import { ChangeStateType, StateChange, StateMachine } from "./StateMachine";
import { ICanDrawSymbol, SpecificSymbolsAnimation, SymbolPositionToAnimate } from "./SymbolsAnimation";
import { MarkersInfoColors } from "./WinLineInfoMarkers";
import { GenericWinLinesAnimationPIXIAPP, WinLinesAnimationParams, WinLinesDrawOrder } from "./WinLines/GenericWinLinesAnimation";
import { IWinLinesFactoryPIXIAPP } from "./WinLines/IWinLinesFactoryPIXIAPP";
import { WinLineTypeFactoryPIXIAPP } from "./WinLines/WinLineTypeFactoryPIXIAPP";
import { IWinMessage } from "./WinMessage";
import { WinMessageAnimationPIXIAPP } from "./WinMessagePIXIAPP";


//import { SelectedBetInfo } from './SelectedBetInfo';
import { assertNotNullish, assertTrue } from "../debug";
import { BuyBonusMenu, BuyBonusMenuResponsive } from "./BuyBonusMenu";
import { IMultiBonusFactory, MultiBonusFactory } from "./Bonus/MultiBonus/MultiBonusFactory";
import { FreegameBonusPIXIAPP } from "./FreegameBonus/FreegameBonusPIXIAPP";
import { isThisSecond, set } from "date-fns";
import { GameViewAppPixiResponsive } from "../engine/gameViewAppPixiResponsive";
import { IJackpotDisplayResponsive } from "../IJackpotDisplayPIXIAPPResponsive";
import { FreeRoundsStats, JackpotValue2, RedundantData, SinglegameServerHub } from "../../singlegame/singlegame_api";
import { FountainPIXI } from "./FountainAnimationPIXI";
import { DenomMenuPIXIAPP_Responsive } from "./DenomMenuPIXIAPP_Responsive";
import { GetOrientation, Orientation } from "../FitScreen";
import { IPaytable } from "./Paytable/IPayTable";
import { PayTableFactory } from "./Paytable/PayTableFactory";
import { JackpotDisplayParams } from "../JackpotDisplayParams";
import { PanelOnlineResponsive } from "./panel/panelOnlineResponsive";
import { ChangeSpeedParams, CollectValues, TriggerZoomAnim, } from "./SlotGameType1";
import { FreegameBonusPIXIAPPResponsive } from "./FreegameBonus/FreegameBonusPIXIAPPResponsive";
import { serviceProvider } from "../../singlegame/SinglegameServiceMap";
import { AnticipationFactory, IAnticipation, IAnticipationFactoryParams } from "./AnticipationFactory/AnticipationFactory";
import { PaytableFactoryPIXIApp } from "./Paytable/PaytableFactoryPIXIApp";
import { IUniReelPIXIAPP } from "./UniReel/IUniReelPIXIPP";
import { FixedSizeFitContainer } from "../../singlegame/ResponsiveHelpers";
import { SingleFillingPotFeature } from "./OnlinePuppet/SingleFillingPot";
import { UniReelPIXIAPP } from "./UniReel/UniReelPIXIAPP";
import { FakeUniReelPIXIAPP } from "./UniReel/FakeUniReelPIXIAPP";
import { IInterval } from "../Context/Interval";

export abstract class SlotGameType1_ResponsivePIXIApp extends SlotGame implements Resourceful2, ICanDrawSymbol {
	protected systemContext: ISystemContext;
	protected gameName: string = "GenericGame";

	protected pressButton: PressButtons = new PressButtons();

	public playlines: number[][] = [[]];
	public reelset: number[][] = [[]];
	public startPositions: number[] = [];

	protected windowSymbolSize: PlayWindow = null;
	protected windowRectangle: Rect = new Rect(135, 73, 1010, 482);
	protected spinnableReels: SpinnableReelsBigCanvas = null;
	protected spinnableReelsParams: SpinnableReelsParams = {};
	protected spinAnimation: SpinAnimation = null;
	protected reelSetMapper: ReelSetMapper = null;
	protected popUpMenuAnim: PopUpSettingsResponsive;
	protected speedManager: SpeedManager;
	//protected betType: BetType = BetType.Normal;

	protected buyBonusMenu: BuyBonusMenuResponsive = null;


	protected readonly basepath: string; //./multigame/slot/" + this.gameName + "/";
	protected readonly commonpath: string;
	protected helppath: string = "";
	public view: HTMLElement = null;
	public backgroundBaseGame: HTMLElement = null;
	public helpElement: HTMLElement = null;
	public basegameElement: HTMLElement = null;

	//protected freegameContainer: HTMLElement = null;

	protected multigameParams: MultigameParams = null;
	// protected multigame: Multigame = null; 

	protected symbols: SlotSymbol[] = [];
	protected symbolsMap: Map<string, SlotSymbol> = new Map<string, SlotSymbol>();
	protected symbolSpriteAnims: SlotSymbolSprite[] = [];
	protected symbolSpriteAnimsByName: Map<string, SlotSymbolSprite> = new Map<string, SlotSymbolSprite>();
	public panel: Panel = null;

	//protected lineMessageLeftContainer: HTMLElement = null;
	//protected lineMessageLeft: TranslatedLocation = null;

	//protected lineMessageRightContainer: HTMLElement = null;
	//protected lineMessageRight: TranslatedLocation = null;

	protected _lastSpinResult: SimpleSlotGameState = null;
	public showFreeRoundsPopUpCallBack: ShowPopUpFreeRoundsCallback = null;


	public get lastSpinResult(): SimpleSlotGameState {
		return this._lastSpinResult
	}

	public set lastSpinResult(value: SimpleSlotGameState) {
		//Log.Error(this.logGroup, "Setting lastSpinResult", value);
		this._lastSpinResult = value;
	}

	// protected _jackpotDisplay: IJackpotDisplayResponsive;

	// protected get jackpotDisplay() : IJackpotDisplayResponsive {
	// 	return this._jackpotDisplay
	// }
	// protected set jackpotDisplay(val: IJackpotDisplayResponsive) {
	// 	this._jackpotDisplay = val
	// }



	protected bonusStartConfig: IBonusStartConfig = null;

	public stateMachine: StateMachine<SlotGameState> = new StateMachine<SlotGameState>(SlotGameState.Loading, this.logGroup, (state: SlotGameState) => SlotGameState[state]);

	// protected paytable: PayTable = null;
	protected helpFactory: IHelpFactory = new HelpFactory();

	protected help: Help = null;
	protected autoPlay: boolean = false;
	protected autoPlayTimer: ITimeout = null;
	//protected winLines: WinLines = null;
	protected winLinesAnimation: GenericWinLinesAnimationPIXIAPP = null;
	protected winLinesFactory: IWinLinesFactoryPIXIAPP = new WinLineTypeFactoryPIXIAPP();
	//protected winLineMarkers: WinLineMarkers = null;

	//protected expandingWildsBulk: ExpandingWildsBulk = null;
	protected features: Map<string, SlotFeaturePIXI> = new Map<string, SlotFeaturePIXI>();
	protected scatterRandomAwardFeature: ScatterRandomAwardPIXI;
	//SEND COLOR 
	protected color: RewardColor = {
		color: "white",
		coloroutherStroke: "black",
		colorinnerStroke: "#00AAE4"
	};


	//protected freegameBonus: FreegameBonus = null;
	protected bonusTriggerAnimation: SpecificSymbolsAnimation = null;
	public ChangeSpeedCallback: (speed: number, celeb: CelebrationType) => void = null;

	// use DefaultSlotBonus by default, to not have to do null checks
	protected bonus: SlotBonus = null;

	protected previewElement: HTMLElement = null;

	protected collectCreditAnimation: any = null;

	//protected collectValues: any = {balance:0 , win:0};

	protected winCreditAnimation: TweenMax = null;
	protected fadeoutWinlinesSound: TweenMax = null;
	//protected fadeinWinlinesSound: TweenMax = null;
	protected winValues: any = { balance: 0, win: 0 };
	protected scatterWinValues: any = { balance: 0, win: 0 };

	//protected symbolsAnimation: SymbolsAnimation = null;
	//protected symbolsAnimation: SpecificSymbolsAnimation = null;

	protected winMessageAnimation: WinMessageAnimationPIXIAPP = null;
	protected shakeAnimation: ShakeAnimation = null;
	protected bigWinCountAnimation: BigWinCountAnimationPIXIAPP = null;

	protected audio: AudioManager = null;

	protected anticipationStarted: boolean = false;

	protected screenProtocol: ScreenProtocol = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	protected denomMenu: DenomMenuPIXIAPP_Responsive = null;

	//protected pickBonus: PickBonus = null;

	protected bonusList: Map<Bonus, SlotBonus> = new Map<Bonus, SlotBonus>();

	responsivePanel: HTMLElement;
	responsivePanelFit: HTMLElement;

	protected _currentBonus: SlotBonus = null;
	protected get currentBonus(): SlotBonus {
		return this._currentBonus;
	}

	protected set currentBonus(value: SlotBonus) {
		//Log.Error(this.logGroup, "Setting current bonus", value);

		this._currentBonus = value;
	}

	protected wins: IWinMessage[] = [
		{ name: "big", winMultiplier: 10, file: "big_win_966x185_half" },
		{ name: "great", winMultiplier: 20, file: "great_win_1013x277_half" },
		{ name: "huge", winMultiplier: 30, file: "huge_win_966x202_half" },
		{ name: "awesome", winMultiplier: 40, file: "awesome_win_1119x213_half" },
		{ name: "amazing", winMultiplier: 50, file: "amazing_win_1185x252_half" }
	];

	// BONUS FACTORIES
	protected freegameBonusFactory: FreegameBonusFactory = new FreegameBonusFactory();
	protected spinAndHoldBonusFactory: SpinAndHoldBonusFactory = new SpinAndHoldBonusFactory();
	protected bigSymbolSpinAndHoldBonusFactory: IBigSymbolSpinAndHoldBonusFactory = new BigSymbolSpinAndHoldBonusFactory();
	protected pickBonusFactory: PickBonusFactory = new PickBonusFactory();
	//protected diamondSpinFactory: IDiamondSpinFactory = new DiamondSpinFactory();
	protected bigSymbolFreegameBonusFactory: IBigSymbolFreegamesBonusFactory = new BigSymbolFreegamesBonusFactory();
	protected extendedSpinAndHoldBonusFactory: IExtendedSpinAndHoldBonusFactory = new ExtendedSpinAndHoldBonusFactory();
	protected multiBonusFactory: IMultiBonusFactory = new MultiBonusFactory();

	// FEATURE FACTORIES
	protected expandingWildsFactory: IExpandingWildsBulkFactory = new ExpandingWildsBulkFactory();

	public translator: Translator;

	protected creditButtonLabel: TranslatedLocation = null;

	protected presentation: GamePresentation = null;

	protected gameSelected: boolean = false;
	protected robotPlay: RobotPlay = null;
	protected demoMessage: HTMLElement = null;

	protected panelColor: ButtonColors = {
		backgroundButtonColor: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206), rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		linearColor: "linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%"
	};
	//protected bigSymbolAnim: BigSymbolAnim = null;

	protected bonusLoadSequence: BonusLoadingItem[] = [
		{ Bonus: Bonus.FreeGameBonus, Prepare: (s, r) => this.FreegamesPrepare(s, r), Loaded: (s, r) => this.FreegamesLoaded(s, r) },
		{ Bonus: Bonus.PickBonus, Prepare: (s, r) => this.PickBonusPrepare(s, r), Loaded: (s, r) => this.PickBonusLoaded(s, r) },
		{ Bonus: Bonus.SpinAndHold, Prepare: (s, r) => this.SpinAndHoldPrepare(s, r), Loaded: (s, r) => this.SpinAndHoldLoaded(s, r) },
		{ Bonus: Bonus.BigSymbolFreegames, Prepare: (s, r) => this.BigSymbolFreegamesPrepare(s, r), Loaded: (s, r) => this.BigSymbolFreegamesLoaded(s, r) },
		{ Bonus: Bonus.BigSymbolSpinAndHold, Prepare: (s, r) => this.BigSymbolSpinAndHoldPrepare(s, r), Loaded: (s, r) => this.BigSymbolSpinAndHoldLoaded(s, r) },
		{ Bonus: Bonus.ExtendedSpinAndHold, Prepare: (s, r) => this.ExtendedSpinAndHoldPrepare(s, r), Loaded: (s, r) => this.ExtendedSpinAndHoldLoaded(s, r) },
		{ Bonus: Bonus.MultiBonus, Prepare: (s, r) => this.MultiBonusPrepare(s, r), Loaded: (s, r) => this.MultiBonusLoaded(s, r) },
	];


	//CREATE SOME STRING FOR CHANGE LEDS COLOR
	protected ColorLed: string = "255,255,255\n";

	protected readonly availableDenoms: number[];

	protected changeBetUpdateDelay: ITimeout;

	public readonly gameStartTimeout: ITimeout;
	protected replayMessage: ReplayMessage;

	protected doubleUpView: DoubleUp = null;

	protected scatterAndBonusTriggerSymbols: number[] = [];


	//create FillingPot
	protected fillingPotFeature: SingleFillingPotFeature = null;


	protected autoPlaySkipWinLines: boolean = false;
	protected jackpotSharedShow: JackpotSharedShow = null;

	//symbolsCollection Spine 
	protected symbolCollection: SymbolCollection = null;
	protected bonusMultiplier: BonusMultiplierResponsive = null;

	protected anticipationFactory: AnticipationFactory = null;
	protected anticipationAnimation: IAnticipation = null;

	protected popUpResponsiveContainer: HTMLElement = null;
	protected popUpResponsiveContainerFit: HTMLElement = null;

	protected helpResponsiveContainer: HTMLElement = null;
	protected helpResponsiveContainerFit: HTMLElement = null;

	protected gameViewAppPixi: GameViewAppPixiResponsive = null;
	protected uniReel: IUniReelPIXIAPP = null;

	gameView: HTMLElement;

	public constructor(
		multigameParams: MultigameParams,
		initData: SlotGameInitData,
		gameName: string,
	) {
		super(initData, multigameParams);

		this.systemContext = multigameParams.systemContext.CreateSubContext("SlotGameType1");
		this.gameName = initData?.Meta?.onlineParams?.original ?? gameName;
		this.bonus = null;
		this.audio = multigameParams.audio;
		this.screenProtocol = multigameParams.screenProtocol;
		this.screenProtocolScope = new ScreenProtocolScope(["SlotGame", this.name]);
		this.speedManager = multigameParams.speedManager;

		this.commonpath = Settings.ResourcesFolder + "multigame/slot/common/";
		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/";
		// this.uniReel = new UniReelPIXIAPP({ basePath: this.basepath, gameName: this.gameName });

		this.helppath = Settings.ResourcesFolder + "multigame/help/";
		this.translator = multigameParams.translator;
		this.multigameParams = multigameParams;
		this.symbols = initData.Symbols;
		this.symbols.forEach(s => this.symbolsMap.set(s.ID, s));

		const bonusTriggers: number[] = initData.BonusTriggers
			.map(b => b.RequiredSymbols)
			.flat();

		const specialSymbols: number[] = this.symbols
			.filter(s => s.SymbolType != SymbolType.Regular)
			.map(s => s.Index);

		this.scatterAndBonusTriggerSymbols = [
			...bonusTriggers,
			...specialSymbols
		].filter(Filter.UniqueItem);


		this.playlines = initData.Playlines;
		this.reelset = initData.ReelSet;

		this.robotPlay = multigameParams.robotPlay;


		this.SetWindowsView();

		// REELS
		this.startPositions = [];
		for (let i = 0; i < this.initData.PlayWindow.Width; i++) {
			this.startPositions.push(0);
		}

		//change position
		//this.ConstructReels();

		// WIN LINES AND MARKERS


		// EXPANDING WILD FEATURE
		// ...constructed when resources are loaded

		// FREEGAME BONUS

		this.view = CreateElement("div", {
			classes: [this.resid.Scope(), this.gameName + "SlotGameType1_ResponsivePIXIAPP"],
			style: {
				position: "absolute",
				width: "100%",
				height: "100%"
			}
		});

		document.body.appendChild(this.view);

		this.backgroundBaseGame = CreateElement("div", {
			classes: [this.resid.Scope(), "BackgroundBaseGame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: Scale.Hpx(1080 * Settings.Screens),
				position: "absolute",
				bottom: Scale.Ypx(0),
				zIndex: ZIndex.backgroundBaseGame.toString(),
			}
		});



		if (initData.Meta.Demo == true) {
			//demo message
			this.demoMessage = document.createElement("div");
			this.demoMessage.classList.add("demo-message");
			SetStyles(this.demoMessage,
				{
					position: "absolute",
					top: Scale.Ypx(86),
					left: Scale.Xpx(1651),
					width: Scale.Wpx(307),
					height: Scale.Hpx(86),
					fontSize: Scale.fhpx(99),
					letterSpacing: Scale.fhpx(5),
					fontFamily: "NotoSansDisplay-ExtraBold",
					color: "rgba(255, 0, 0, 1)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					transform: "rotate(45deg)",
					zIndex: ZIndex.DemoMessage.toString(),
				})

			this.demoMessage.innerHTML = "DEMO";
		}

		this.autoPlayTimer = this.systemContext.TimingContext().CreateTimeout("autoPlayTimer", IsDebug() ? 2000 : 500, () => this.Spin());

		// left column line message
		/* this.lineMessageLeftContainer = document.createElement("div");
		this.lineMessageLeftContainer.classList.add("line-message-left");
		SetStyles(this.lineMessageLeftContainer, {left:"2px", width:"60px", textAlign:"center"/*whiteSpace:"nowrap", transform:"rotate(90deg)"});
		// SetStyles(this.lineMessageLeftContainer, {left:"2px", width:"206px", textAlign:"center"});

		this.lineMessageLeft = this.translator.Translate(() => this.translator.t.selectedLines(this.lines[this.selectedLineIndex]));
		this.lineMessageLeftContainer.appendChild(this.lineMessageLeft.location);

		// right column line message
		this.lineMessageRightContainer = document.createElement("div");
		this.lineMessageRightContainer.classList.add("line-message-right");
		//SetStyles(this.lineMessageRightContainer, {right:"2px", width:"206px", textAlign:"center"});
		SetStyles(this.lineMessageRightContainer, {right:"2px", width:"60px", textAlign:"center"/*whiteSpace:"nowrap", transform:"rotate(90deg)"});

		this.lineMessageRight = this.translator.Translate(() => this.translator.t.selectedLines(this.lines[this.selectedLineIndex]));
		this.lineMessageRightContainer.appendChild(this.lineMessageRight.location); */

		this.stateMachine.SetStateChangeCallback((oldState, newState, stateNameCallback) => {
			// // Log.Debug(this.logGroup, "Changing state from " + SlotGameState[oldState] + " to " + SlotGameState[newState]);
			console.log(`Changing state from ${oldState} to ${newState}`);
			this.screenProtocol?.Send(new SlotGameMessages.StateChange<SlotGameState>(oldState, newState, stateNameCallback), this.screenProtocolScope);
		});

		this.stateMachine.SetCallback(SlotGameState.Idle, StateChange.Begin, () => this.OnIdleBegin());
		this.stateMachine.SetCallback(SlotGameState.Idle, StateChange.End, () => this.OnIdleEnd());

		this.stateMachine.SetCallback(SlotGameState.WaitGameStart, StateChange.Begin, () => this.OnWaitGameStartBegin());
		this.stateMachine.SetCallback(SlotGameState.WaitGameStart, StateChange.End, () => this.OnWaitGameStartEnd());

		this.stateMachine.SetCallback(SlotGameState.Spin, StateChange.Begin, () => this.OnSpinBegin());
		this.stateMachine.SetCallback(SlotGameState.Spin, StateChange.End, () => this.OnSpinEnd());

		//this.stateMachine.SetCallback(SlotGameState.Exit, StateChange.Begin, () => this.OnExitBegin());
		//this.stateMachine.SetCallback(SlotGameState.Exit, StateChange.End, () => this.GamesMenu());



		this.stateMachine.SetCallback(SlotGameState.BonusMultiplier, StateChange.Begin, () => { this.OnFeaturesBonusMultiplier() });

		this.stateMachine.SetCallback(SlotGameState.FillingPot, StateChange.Begin, () => { this.OnFeaturesFillingPot() });

		this.stateMachine.SetCallback(SlotGameState.Features, StateChange.Begin, () => this.OnFeaturesBegin());
		//this.stateMachine.SetCallback(SlotGameState.Features, StateChange.End, () => this.OnFeaturesEnd());

		this.stateMachine.SetCallback(SlotGameState.Scatter, StateChange.Begin, () => this.OnScatterWinBegin());
		//this.stateMachine.SetCallback(SlotGameState.Scatter, StateChange.End, ()=> this.OnScatterWinEnd());

		this.stateMachine.SetCallback(SlotGameState.BonusTrigger, StateChange.Begin, () => this.OnBonusTriggeBegin());
		// this.stateMachine.SetCallback(SlotGameState.BonusTrigger, StateChange.End, () => this.OnBonusTriggerEnd());


		this.stateMachine.SetCallback(SlotGameState.BigWinBasegame, StateChange.Begin, () => this.OnBigWinBasegameBegin());
		this.stateMachine.SetCallback(SlotGameState.BigWinBasegame, StateChange.End, () => this.OnBigWinBasegameEnd());

		this.stateMachine.SetCallback(SlotGameState.Win, StateChange.Begin, () => this.OnWinBegin());
		this.stateMachine.SetCallback(SlotGameState.Win, StateChange.End, () => this.OnWinEnd());

		//this.stateMachine.SetCallback(SlotGameState.Win, StateChange.Begin, () => this.OnWinBegin());
		//this.stateMachine.SetCallback(SlotGameState.Win, StateChange.End, () => this.OnWinEnd());

		this.stateMachine.SetCallback(SlotGameState.WaitBonusStartConfig, StateChange.Begin, () => this.OnWaitBonusStartConfigBegin());


		this.stateMachine.SetCallback(SlotGameState.Bonus, StateChange.Begin, () => this.OnBonusBegin());
		this.stateMachine.SetCallback(SlotGameState.Bonus, StateChange.End, () => this.OnBonusEnd());

		this.stateMachine.SetCallback(SlotGameState.BigWinTotal, StateChange.Begin, () => this.OnBigWinTotalBegin());
		this.stateMachine.SetCallback(SlotGameState.BigWinTotal, StateChange.End, () => this.OnBigWinTotalEnd());

		this.stateMachine.SetCallback(SlotGameState.WaitCollect, StateChange.Begin, () => this.OnWaitCollectBegin());
		this.stateMachine.SetCallback(SlotGameState.WaitCollect, StateChange.End, () => this.OnWaitCollectEnd());

		this.stateMachine.SetCallback(SlotGameState.Collect, StateChange.Begin, () => this.OnCollectBegin());
		this.stateMachine.SetCallback(SlotGameState.Collect, StateChange.End, () => this.OnCollectEnd());

		this.stateMachine.SetCallback(SlotGameState.GameFinished, StateChange.Begin, () => this.OnGameFinishedBegin());
		this.stateMachine.SetCallback(SlotGameState.GameFinished, StateChange.End, () => this.OnGameFinishedEnd());


		this.stateMachine.SetCallback(SlotGameState.DoubleState, StateChange.Begin, () => this.startDoubleUpGame());
		this.stateMachine.SetCallback(SlotGameState.DoubleState, StateChange.End, () => this.finishDoubleUpGame());
		this.updateInterval = this.systemContext.TimingContext().CreateInterval("updateBalanceInterval", 10 * 1000, async () => {
			const redundanData: RedundantData = await service.onlineApi.getRedundantData();
			this.panel.SetBalance(service.moneyFormatter.FormatCreditCurrentDenom(redundanData.CurrentBalance), service.moneyFormatter.FormatCurrency(redundanData.CurrentBalance));

			// if (redundanData.roundsStats.FreeRoundsNumber > 0){
				this.showFreeRoundsPopUpCallBack?.(redundanData.roundsStats);
			// }
			// console.log("new balance", newBalance);
		});



		//service.protocol.SetMessageHandler("OnMachineLockMessage", (data) =>{this.DisableAutoplay()});


		this.clientState.OnCashIn((cashInParams) => this.OnCashIn(cashInParams));
		this.clientState.OnCashOut((cashOutParams) => this.OnCashOut(cashOutParams));
		this.clientState.AddOnBalanceChangedCallback((balanceParams) => {
			this.buyBonusMenu.UpdateBalance(balanceParams.newBalance)
		});

		this.availableDenoms = this.initData.EnabledBets.map(b => b.Bet.Denom.InCents).filter(Filter.UniqueItem).sort(Compare.NumAsc);
		this.denomMenu = new DenomMenuPIXIAPP_Responsive(this.availableDenoms, this.resid, this.basepath);

		this.denomMenu.DenomSelectedCallback((denomCents: number) => {

			// find smallest bet with this denom and select it
			let betsThisDenom = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == denomCents);
			let bet = betsThisDenom.reduce((min, bet, index, arr) => bet.Bet.TotalBetCents.InCents < min.Bet.TotalBetCents.InCents ? bet : min, betsThisDenom[0]);
			let minBetIndex = this.initData.EnabledBets.indexOf(bet);
			//this.SelectBet2(minBetIndex);
			this.audio.Play(this.resid.ScopedResourceName("denom"));

			this.UpdateDenom?.(this.initData.EnabledBets, denomCents);
			this.GameStateChanged?.(GameState.ReadyToPlay);

			this.SelectBet2(minBetIndex);
		});

		if (initData.JackpotEnabled) {
			this.viewSize = new Size(Settings.ScreenWidth, Settings.ScreenHeight);
			//Interface with neccesary parameters for the jackpot
			let params: JackpotDisplayParams = {
				systemContext: this.systemContext,
				resid: this.resid,
				viewSize: this.viewSize,
				screenProtocol: this.screenProtocol,
				gameName: this.name
			};

			//ADD JACKPOT
			//globalThis.jackpotDisplayGlobalResponsive = globalThis.jackpotDisplayGlobalResponsiveFactory.CreateNewJackpotDisplay(params);

			this.ProtocolSetup();


		}

		//create payoutMenu
		//this.payoutMenu = new PayoutMenu(this.resid, this.basepath, this.translator);
		//this.payoutMenu.PayoutSelectedCallback(() => {
		//	this.payoutMenu.Hide();
		//	this.Payout();
		//});

		// this.payoutMenu.CancelSelectedCallback(() => {
		// 	this.payoutMenu.Hide();
		// });

		// create betTypeChangeMenu

		this.buyBonusMenu = new BuyBonusMenuResponsive(this.resid, this.systemContext, this.basepath, service.translator, this.audio);
		this.buyBonusMenu.BetTypeSelectedCallback(() => this.BetTypeChange());
		this.buyBonusMenu.CancelSelectedCallback(() => this.CancelTypeChange());


		this.changeBetUpdateDelay = this.systemContext.TimingContext().CreateTimeout("changeBetUpdateDelay", 100, () => {
			this.RedrawAllReels();
		});


		this.gameStartTimeout = this.systemContext.TimingContext().CreateTimeout("gameStartTimeout", 5000, () => {

			// game allowed/denied not received in time, change state back to idle
			if (this.stateMachine.IsState(SlotGameState.WaitGameStart)) {

				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				service?.api?.frontendError(FrontendErrorCode.FrontendSpinError, `Spin is taking too long (more than ${this.gameStartTimeout.GetTimeout()}ms)`);
				//Log.Error(this.logGroup, "Spin request timeouted, nothing to do");
				//this.SpinError("Game is not available");
			}
		});

		this.bigWinTotalTimeout = this.systemContext.TimingContext().CreateTimeout("bigWinTotalTimeout", 3000, () => {
			this.stateMachine.ChangeState(SlotGameState.WaitCollect);
		});

		this.replayMessage = new ReplayMessage(this.systemContext);

		this.InitializeIsAnimation()
		let doubleUpParams: DoubleUpParams = {
			gameName: this.gameName,
			translator: this.translator,
			systemContext: this.systemContext,
			viewSize: this.multigameParams.viewSize,
			resid: this.resid,
			audioManager: this.audio,
			logGroup: this.logGroup,
			robotPlay: this.robotPlay
		}

		if (multigameParams.doubleupConfig && this.multigameParams.backendSettings.GetBool("play.allowdoubleup", true)) {
			this.doubleUpView = new DoubleUp(doubleUpParams, multigameParams.doubleupConfig, service.backendSettings);

			this.doubleUpView.doubleUpEnded = () => {
				this.stateMachine.ChangeState(SlotGameState.Idle);
				this.robotPlay.GameFinished(false);
			};

			this.doubleUpView.OnWinChanged2 = (newWin: number) => {
				this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(newWin), service.moneyFormatter.FormatCurrency(newWin));
			};

			this.doubleUpView.OnCreditChanged2 = (newCredit: number) => {
				this.clientState.UpdateBalance(newCredit);
				this.panel.SetBalance(service.moneyFormatter.FormatCreditCurrentDenom(this.clientState.Balance()), service.moneyFormatter.FormatCurrency(this.clientState.Balance()));
			};
		}

		// if (Settings.fillingPotFeature == FillingPotFeature.Enable) {
		// 	this.CreateFillingPot();
		// 	if (JackpotDisplayType.DiamondPotStepShared == Settings.JackpotDisplayType) this.jackpotSharedShow = new JackpotSharedShow(this.audio, this.resid);
		// }

		this.gameView = CreateElement("div", {
			classes: ["game-view"],
			style: {
				width: "100%",
				height: "100%",
			}
		});

		this.popUpResponsiveContainer = CreateElement('div',
			{
				classes: ['popup-responsive', 'container'],
				parentToAppend: this.gameView,
				style: {
					width: "100%",
					height: "100%",
					// display: 'flex',
					position: "absolute",
					justifyContent: "center",
					alignItems: "center",
					zIndex: "1000",
					background: "rgb(0,0,0,0.8)",
					display: "none",
				}
				// mousedown: () => {
				// 	if (this.PopUpMenuAnimView.checkVisibility())
				// 	{
				// 		this.popUpMenuAnim.HidePopUp();

				// 		if (this.popUpResponsiveContainer)
				// 		{
				// 			this.popUpResponsiveContainer.style.display = "none";
				// 		}
				// 	}
				// }
			}
		)

		this.helpResponsiveContainer = CreateElement('div',
			{
				classes: ['help-responsive', 'container'],
				parentToAppend: this.gameView,
				style: {
					width: "100%",
					height: "100%",
					// display: 'flex',
					position: "absolute",
					justifyContent: "center",
					alignItems: "center",
					zIndex: "1000",
					background: "rgb(0,0,0,0.8)",
					display: "none",
				}
				// mousedown: () => {
				// 	if (this.PopUpMenuAnimView.checkVisibility())
				// 	{
				// 		this.popUpMenuAnim.HidePopUp();

				// 		if (this.popUpResponsiveContainer)
				// 		{
				// 			this.popUpResponsiveContainer.style.display = "none";
				// 		}
				// 	}
				// }
			}
		)


		this.popUpResponsiveContainerFit = CreateElement('div',
			{
				classes: ["popup", "container", 'fit'],
				parentToAppend: this.popUpResponsiveContainer,
				style:
				{
					boxSizing: "border-box",

					width: "100%",
					height: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}
			}
		);

		this.helpResponsiveContainerFit = CreateElement('div',
			{
				classes: ["help", "container", 'fit'],
				parentToAppend: this.helpResponsiveContainer,
				style:
				{
					boxSizing: "border-box",

					// width: "100%",
					height: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}
			}
		);

		this.responsivePanel = CreateElement("div", {
			classes: ["responsive-panel"],
			parentToAppend: this.gameView,
			style: {
				position: "absolute",
				// border: "5px solid red",
				boxSizing: "border-box",
				//flexGrow: "1",
				width: "100%",
				height: "15%",
				display: "flex",
				alignItems: "flex-end",
				justifyContent: "center",
				bottom: "0px",
			}
		});

		this.responsivePanelFit = CreateElement("div", {
			classes: ["responsive-panel-fit"],
			parentToAppend: this.responsivePanel,
			style: {
				// border: "5px solid red",
				boxSizing: "border-box",

				width: "100%",
				// height: Scale.Hpx(160),
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				maxHeight: Scale.Hpx(160),
			}
		});

		this.CreateAppBonusView();

		this.winMessageAnimation = new WinMessageAnimationPIXIAPP(this.audio);

		// this.bonusMultiplier = new BonusMultiplier(this.initData.EnabledBets,this.audio, this.resid  );
		// this.bonusMultiplier.OnShowFinishedCallback=()=>{
		// 	this.stateMachine.ChangeState(SlotGameState.FillingPot, null, ChangeStateType.NextTask)
		// }
	}

	protected ProtocolSetup(): void {

		service.api?.registerOperation("JackpotValuesUpdate", this.resid.ID(), (data) => {
			const values = Object.values(data.JackpotValues);
			this.OnJackpotValues(values);
		});
	}

	protected PopUpMenuAnimView: HTMLElement;
	// private baseGameContainer: PIXI.Container | FixedSizeFitContainer = null;

	protected CreateAppBonusView() {
		// initDevtools(this.gameViewAppPixi);
		this.gameViewAppPixi = globalThis.gameViewAppPixiResponsive;

		this.gameViewAppPixi.OnDestroyCallback = () => {
			// if (!this.gameConfig.enabledPuppet) {
			this.spinnableReels.Destroy("Destroy SlotGameType1");
			// }
			if (this.gameConfig.enabledPuppet) {
				this.fillingPotFeature?.Destroy();
			}
			this.buyBonusMenu.Destroy();
			this.uniReel?.Destroy();
		}
		//call back for append into game engine pixi APP spinable reels or filling pot change whit  settings.js 
		// this.gameViewAppPixi.OnCreatedCallback = () => {
		// 	if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
		// 		this.spinnableReels.Create(null, this.gameViewAppPixi.GetAppView());
		// 	}
		// 	if (Settings.fillingPotFeature == FillingPotFeature.Enable) {
		// 		this.fillingPotFeature?.Create(this.gameViewAppPixi.GetAppView().stage);
		// 	};
		// 	// this.betTypeChangeMenu.Create(this.gameViewAppPixi.GetAppView());
		// };
		// this.view.appendChild(this.gameViewAppPixi.GetView());
		this.gameViewAppPixi.OnCreatedCallback = async () => {
			// if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
			// this.uniReel.Create();


			this.uniReel.Create();
			this.uniReel.GetView().zIndex = 2;
			// this.baseGameContainer = this.uniReel.GetReelsContainer() as PIXI.Container;
			this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(this.uniReel.GetView());

			this.spinnableReels.Create(this.uniReel.GetReelsContainer(), null);

			// }
			if (this.gameConfig.enabledPuppet && this.fillingPotFeature) {
				
				this.fillingPotFeature?.Create(this.gameViewAppPixi.GetAppView());
				this.fillingPotFeature.SetBet(this.selectedBet);
				this.fillingPotFeature?.RestartAnim();

				const potView = this.fillingPotFeature.GetSRAPathView();
				potView.zIndex = 2;
				this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(potView);
			}

			if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay) {
				this.payTable.Build();
				this.payTable.Update(true);
			};

			this.PopUpMenuAnimView = this.popUpMenuAnim.View();
			this.PopUpMenuAnimView.style.bottom = "";
			this.PopUpMenuAnimView.style.background = "";

			this.popUpResponsiveContainerFit.appendChild(this.PopUpMenuAnimView);
			this.helpResponsiveContainerFit.appendChild(this.help.View());

			this.popUpResponsiveContainer.style.display = 'none';

			this.popUpMenuAnim.hidePopUpCallback = () => {
				if (this.popUpResponsiveContainer.style.display != "none") {
					this.popUpResponsiveContainer.style.display = 'none';
				}
			}

			await this.CreateResponsiveJackpot();
			await this.OnResize(0, 0, GetOrientation())

			this.fountainAnimation.OnStartedCallback = () => this.audio.PlayLoop(this.resid.ScopedResourceName("fountain"));
			this.fountainAnimation.OnStoppedCallback = () => this.audio.Stop(this.resid.ScopedResourceName("fountain"));


		}
	}
	protected jackpotValuesBuffer: JackpotValue2[] = null;

	protected async CreateResponsiveJackpot(): Promise<void> {
		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay) return;


		await globalThis.jackpotDisplayGlobalResponsive?.Create();
		globalThis.jackpotDisplayGlobalResponsive?.OnResize();
		globalThis.jackpotDisplayGlobalResponsive.OnResizeCallback = () => {
			this.gameViewAppPixi?.GetAppView().ticker?.update(0);
			this.gameViewAppPixi?.OnResize();
		}


		if (this.jackpotValuesBuffer != null) {
			this.OnJackpotValues(this.jackpotValuesBuffer);
		}
		globalThis.jackpotDisplayGlobalResponsive.OnUpdateAppCallback = () => {
			this.gameViewAppPixi?.GetAppView().ticker?.update(0);
		}
	}

	protected fillingPotNextTask: ITimeout = null;
	protected fillingPotHitBonues: ITimeout = null;
	protected skinAttachmentFillingPotFeature: number = 1;
	protected CreateFillingPot() {

		this.fillingPotFeature = new SingleFillingPotFeature({
			systemContext: this.systemContext,
			initData: this.initData,
			resid: this.resid,
			logGroup: this.logGroup,
			//viewSize: this.viewSize,
			gameResourcesBasePath: this.basepath + "resources/",
			commonResourcesPath: this.commonpath + "resources/FillingPot/",
			//EnabledBets: this.initData.EnabledBets,FillingPotvPopet
			gameName: this.gameName,
			audio: this.audio,
			skinAttachment: this.skinAttachmentFillingPotFeature,
			windowRectangle: this.windowRectangle,
			clientState: this.clientState
			//poppetPlusPot : this.gameConfig.poppetPlusPot =! null ? this.gameConfig.poppetPlusPot : false

		});

		this.fillingPotNextTask = this.systemContext.TimingContext().CreateTimeout("fillingPotUpdate", 2000, () => {
			this.stateMachine.ChangeState(SlotGameState.Features, null, ChangeStateType.NextTask);
		});

		this.fillingPotHitBonues = this.systemContext.TimingContext().CreateTimeout("fillingPotUpdate", 100, () => {
			// this.fillingPotFeature?.StartIncrement({
			// 	BonusWin: true,
			// 	ScatterCordinates: null
			// })

			//MultiBonus 				
			let configMultiBonus = this.lastSpinResult.Actions.find(action => action.Phase == "Start" && action.Bonus == "MultiBonus") as SpinAndHoldStartAction
			console.log("LastSpin-Configmultibonus:", configMultiBonus);



			this.lastSpinAction.Triggers.forEach(bonusTriggerResult => {
				//BonusWillUpdateFillingPotFeature.forEach(b => {
				if (BonusWillUpdateFillingPotFeature.find(b => b == bonusTriggerResult.Bonus) && bonusTriggerResult.WillTrigger == true && bonusTriggerResult.Bonus != "Freegames") {
					//change true bonus win for play all anim whit spine on FillingPotFeature 						
					//bonusName = b;						
					if (this.gameConfig.enabledPuppet) {
						setTimeout(() => {
							this.fillingPotFeature?.StartBonusWin(bonusTriggerResult.Bonus, configMultiBonus != null ? configMultiBonus.Types : null, bonusTriggerResult?.Hint?.Multiplier);
							this.timeoutBonusShow.ChangeTimeout(2500);
							this.timeoutBonusShowTransition.ChangeTimeout(2500);
						}, 500);
					}
				} else if (bonusTriggerResult.WillTrigger == true) {
					//bonusName = "Freegames"
					if (this.gameConfig.enabledPuppet) {
						this.fillingPotFeature?.StartBonusWin("Freegames");
						this.timeoutBonusShow.ChangeTimeout(1800);
						this.timeoutBonusShowTransition.ChangeTimeout(100);
					}
				}
				//})
			});
		});
	}

	//public UpdateDenom: UpdateDenomCallBack = null;
	//public GameStateChanged: GameStateChangedCallback = null;
	/////
	protected panelFactory: IPanelFactory = new PanelFactory();
	protected fountainAnimation: FountainPIXI = serviceProvider.Resolve("FountainPIXI");

	public async CreateFountain() {

		this.fountainAnimation.Create();
		await this.fountainAnimation.Start();

	}

	protected PreparedPanel(): void {
		if (Settings.PanelType == PanelType.DefaultGameColorPanel) this.panelColor = this.gameConfig.panelColor;
		//const panelFactory: IPanelFactory = new PanelFactory();
		this.panel = this.panelFactory.CreateNewPanel({
			systemContext: this.systemContext,
			resid: this.resid,
			resourcesBasePath: "./",
			audio: this.audio,
			backendSettings: this.multigameParams.backendSettings,
			translator: this.translator,
			panelColor: this?.gameConfig?.panelColor ?? this.panelColor,
			doubleupEnabled: !!this.doubleUpView,
			symbolAnimationType: this.gameConfig.symbolsType

		});

		this.speedManager.Load(this.multigameParams.backendSettings);

		this.panel.SetEnabledBets(this.initData.EnabledBets);
		let PopUpParams: PopUpSettingsParams =
		{
			audio: this.audio,
			// backendSettings: this.multigameParams.backendSettings,
			panelColors: this?.gameConfig?.panelColor ?? this.panelColor,
			translator: this.translator,
			systemContext: this.systemContext,
			speedManager: this.speedManager,
		}
		const defaultVolume = 3; //this.multigameParams.backendSettings.GetNum("system.defaultVolume", 3);

		this.popUpMenuAnim = new PopUpSettingsResponsive(PopUpParams);
		this.popUpMenuAnim.DefaultVolumeLevel(defaultVolume);

		this.speedManager.CreateUpdateList(this.popUpMenuAnim)

		this.popUpMenuAnim.OnSpeedChanged = (changeSpeedParams) => {
			this.SpeedChanged(changeSpeedParams);
			//console.log("Changed Params:", changeSpeedParams)

		};

		service.translator?.SetOnLanguageChangedCallback((t) => {

			this.panel.SetMessage(this.clientState.Balance() <= 0 ? this.translator.t.message_insertcredit : this.translator.t.message_pressspin);

			if (this.turboSpin) {
				this.panel.SpinButtonLabelChange(t.turbo);
			}
			else {
				this.panel.SpinButtonLabelChange(t.spin);
			}
		});
	}

	protected needsToUpdateWinLinesAnimation: boolean = false;
	protected speedChangeParams: ChangeSpeedParams =
		{
			CelebrationFactor: null,
			SpinParams: null,
			SymbolSpeedAnimationSpine: 1,
		};

	protected SpeedChanged(paramsToChange: ChangeSpeedParams) {
		this.needsToUpdateWinLinesAnimation = true;

		this.speedChangeParams.CelebrationFactor = paramsToChange.CelebrationFactor;
		this.speedChangeParams.SpinParams = paramsToChange.SpinParams;
		this.speedChangeParams.SymbolSpeedAnimationSpine = paramsToChange.SymbolSpeedAnimationSpine

		this.reelSpinAnimation.forEach(animation => {
			animation.UpdateSpinSpeed(paramsToChange.SpinParams);
		})

		this.bonusList.forEach(bonusElement => {
			bonusElement.UpdateSpinSpeed(paramsToChange)
		});

		this.symbolCollection.SetSymbolAnimationSpeed(paramsToChange.SymbolSpeedAnimationSpine);

	}

	protected SetWindowsView(): void {
		let xratio = 1;
		let yratio = 1;
		this.windowRectangle = new Rect(Scale.X(74.0) * xratio, Scale.Y(10.0) + (Settings.ScreenHeight * (Settings.Screens - 1)), Scale.W(1774.0) * xratio, Scale.H(885.0) * yratio);

		this.windowSymbolSize = this.initData.PlayWindow;
	}

	private readonly reelScaleFactor = 1;
	public pixiSpritesByName: Map<string, PIXI.Texture[]> = new Map<string, PIXI.Texture[]>();
	protected ConstructReels() {
		this.spinnableReels = new SpinnableReelsBigCanvas(this.initData.PlayWindow, this.windowRectangle, this.spinnableReelsParams, this.resid, this.systemContext);
		//this.spinnableReels.PreprareResource(resourceManager);		
		this.spinAnimation = new SpinAnimation(this.logGroup);
		this.spinAnimation.AddOnStartCallback(() => {
			this.audio.Play(this.resid.ScopedResourceName("leverpull"));
		});
		this.reelSetMapper = new ReelSetMapper(this.initData.PlayWindow, this.logGroup);
	}
	// //CREATE A FUNCION FOR GROWW REEL IN 3 SCREEN AND 2
	// protected GroowReel(reelWindowElement: HTMLElement,zoomFactor: number,scaleAnim:any,reelElement: HTMLElement)
	// {
	// 	reelWindowElement.style.transformOrigin = "top";
	// 	scaleAnim = TweenLite.to(reelWindowElement, 0.5, {scaleY: zoomFactor/*, backgroundColor: newBackgroundAnticipation.toRgba()*/});
	// 	TweenLite.to(reelElement, 0.5, {scaleX: zoomFactor});
	// }

	//CREATE A FUNCION FOR RESET GROW REEL IN 3 SCREEN AND 2
	// protected GroowReelReset(reelWindowElement: HTMLElement,scaleAnim:any,reelElement: HTMLElement,oldZIndex:string)
	// {
	// 	TweenLite.to(reelElement, 0.5, {scaleX: 1});
	// 				scaleAnim = TweenLite.to(reelWindowElement, 0.5, {scaleY: 1, /*backgroundColor: originalBackgroundAnticipation.toRgba(),*/
	// 				onComplete: () => {
	// 					reelWindowElement.style.zIndex = oldZIndex;
	// 				}});
	// }

	public override RedrawAllReels(forceImage: boolean = false): void {
		console.log(new Error(`Redraw all reels, state: ${this.stateMachine.State()} `));
		if (!forceImage &&
			(this.stateMachine.IsState(SlotGameState.Idle) || this.stateMachine.IsState(SlotGameState.Exit)) &&
			this.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
			this.symbolCollection.PlayAnimationIdleSpineSymbol();
		}
		else {
			for (let i = 0; i < this.spinnableReels.GetWindowSymbolSize().Width; i++) {
				this.RedrawReel(i);
			}
		}
	}

	protected MarkRedrawReel(reelIndex: number): void {
	}

	protected RedrawReel(reelIndex: number): void {
		// 2 symbols more than window height 
		//	 - scrolling reveals additional symbol on top
		//	 - we don't want to change top symbol right at the top window line, 
		//     in case the top symbols peeks out a little


		this.currentSymbols[reelIndex] = this.reelSetMapper.GetReelMapper(reelIndex).GetSymbols2();

		for (let rowIndex: number = 0; rowIndex < this.currentSymbols[reelIndex].length; rowIndex++) {
			this.DrawSymbol(reelIndex, rowIndex);
		}
	}


	protected currentSymbols: ReelSymbolsToDisplay[][] = [];
	protected EnableCache: Boolean = true;
	protected isSymbolAnimation: boolean[][] = [];


	public DrawSymbol(reelIndex: number, rowIndex: number): void {
		try {
			if (this.gameConfig.symbolsType == SymbolTypeAnim.Spine) this.symbolCollection.DestroySymbol(reelIndex, rowIndex);
			//let canvasPIXI: PIXI.AnimatedSprite = this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex];	
			let img = PIXI.Texture.from(this.symbolCollection.symbolCollectionMap.get("Symbol_" + this.symbols[this.currentSymbols[reelIndex][rowIndex].symbolIndex].ID).imgResource);

			let scaleWidth = this.spinnableReels?.GetSymbolSize().Width / img.width;
			let scaleHeight = this.spinnableReels?.GetSymbolSize().Height / img.height
			let scaleProm = (scaleHeight + scaleWidth) / 2;
			this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex].scale.set(scaleProm);
			this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex].texture = img;
			this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex].visible = true;
			this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex].anchor.set(0.5);
			this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex].position.set(this.spinnableReels.GetSymbolSize().Width / 2, this.spinnableReels.GetSymbolSize().Height / 2);
			//this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex].name = "Symbol_" + this.symbols[this.currentSymbols[reelIndex][rowIndex].symbolIndex].ID
			this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, this.currentSymbols[reelIndex][rowIndex].reelPositionIndex, rowIndex, this.symbols[this.currentSymbols[reelIndex][rowIndex].symbolIndex], this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex], null, this.symbolCollection.symbolCollectionMap.get("Symbol_" + this.symbols[this.currentSymbols[reelIndex][rowIndex].symbolIndex].ID).showAward);
			this.symbolCollection.SetSymbolCache("Symbol_" + this.symbols[this.currentSymbols[reelIndex][rowIndex].symbolIndex].ID, reelIndex, rowIndex, this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex]);
		}
		catch (ex) {
			//Log.Error(this.logGroup, "Error drawing symbol", ex);
		}
	}



	//init symbol array animation
	protected InitializeIsAnimation() {
		for (let reel = 0; reel < this.initData.PlayWindow.Width; reel++) {
			this.isSymbolAnimation.push([]);
			for (let row = 0; row < this.initData.PlayWindow.Height; row++) {
				this.isSymbolAnimation[reel][row] = false;
			}
		}
		//console.log("ArraySymbolsAnim:",this.isSymbolAnimation);
	}

	protected EnableSymbolsAnimation(positions: SymbolPositionToAnimate[]): void {
		//console.log("ArraySymbolsAnimPositions:",positions);
		//disable all symbols anim 
		this.DisableSymbolsAnimation();
		//only enable whe need anim 
		for (let p of positions) {
			this.isSymbolAnimation[p.reel][p.row] = true;
			//console.log("ArraySymbolsAnimPositions reel:",p.reel , "row:",p.row);
		}
	}

	//disable symbols anim 
	protected DisableSymbolsAnimation(): void {
		for (let reel = 0; reel < this.isSymbolAnimation.length; reel++) {
			for (let row = 0; row < this.isSymbolAnimation[reel].length; row++) {
				this.isSymbolAnimation[reel][row] = false;
			}
		}
		//console.log("ArraySymbolsAnim:",this.isSymbolAnimation);
	}




	protected OnReelStopped(reelIndex: number) {
		this.symbolCollection.CreateSymbolAnimation(reelIndex);
		this.AddAwardIntoSpine(reelIndex);


		this.EnableReelOverflow(reelIndex);
		this.ZoomInSymbols(reelIndex);
	}

	protected AddAwardIntoSpine(reelIndex: number) {
		if (this.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
			let symbolsReel = this.reelSetMapper.GetReelMapper(reelIndex).GetSymbols2();
			for (let rowIndex = 0; rowIndex < symbolsReel.length; rowIndex++) {
				// //set spine textures
				this.scatterRandomAwardFeature?.DrawSpine(reelIndex, symbolsReel[rowIndex].reelPositionIndex, rowIndex, this.symbols[symbolsReel[rowIndex].symbolIndex], this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex], this.spinnableReels.GetSymbolSize());
			}
			//symbolsReel = null;
		}
	}



	public PrepareFont(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new FontResource(this.commonpath + "resources/bigwincount.ttf", this.resid.ScopedResourceName("bigwincount")));

	}

	public PrepareBackgroundReel(resourceManager: IWriteOnlyResourceManager) {
		this.spinnableReelsParams.backgroundImage = new DecodedImageResource(this.basepath + "resources/reel.png", this.resid.ScopedResourceName(["reel", "image"]))
		resourceManager.Add(this.spinnableReelsParams.backgroundImage);

		this.spinnableReelsParams.maskbackgroundImage = new DecodedImageResource(this.basepath + "resources/reelMask.png", this.resid.ScopedResourceName(["reelMask", "image"]));
		resourceManager.Add(this.spinnableReelsParams.maskbackgroundImage);
	}

	protected colorLineMarkers: MarkersInfoColors =
		{
			MarkerbackgroundColor: "linear-gradient(90deg, rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			//linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
		};


	protected async PrepareWinLines(resourceManager: IWriteOnlyResourceManager) {
		// construct win lines
		let winLinesAnimParams: WinLinesAnimationParams =
		{
			viewSize: this.multigameParams.viewSize,
			spinnableReels: this.spinnableReels,
			lines: this.playlines,
			logGroup: this.logGroup,
			resid: this.resid,
			systemContext: this.systemContext,
			slotWindow: this.windowRectangle,
			slotWindowSymbolSize: this.spinnableReels.GetWindowSymbolSize(),
			colorLineMarkers: this.colorLineMarkers,
			speedFactorAnimation: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameName: this.gameName,
			winLinesTypeStyle: this.gameConfig.winLinesTypeStyle,
		};




		// if (FruitGames.includes(this.initData.GameName)) {
		// 	//this.winLinesFactory = new WinLinesFactory();
		// 	throw "its not implemented big app for fruit games "
		// }

		// TODO replace with factory
		//this.winLinesAnimation = new WinSquareAnimations(winLinesAnimParams);
		this.winLinesAnimation = this.winLinesFactory.CreateWinLinesPIXIAPP(winLinesAnimParams)


		//this.winLineMarkers = new WinLineMarkers(this.windowRectangle, this.spinnableReels.GetWindowSymbolSize(), this.playlines);

		this.winLinesAnimation.AddStartLineCallback((line: LineWin, color: Color) => {
			this.audio.PlayLoop(this.resid.ScopedResourceName("linecount"));
			this.lineCountBackground.PlayLoop(Track.LoopForEver);
			//this.audio.PlayLoop(this.resid.ScopedResourceName("lineCountBackground"));						
			//this.fadeinWinlinesSound.restart();			
			this.EnableCache = true;
			line = null;
			color = null;
		});

		let symbolPositions: SymbolPositionToAnimate[] = [];

		this.winLinesAnimation.AddNextLineCallback((line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => {
			//this.winLineMarkers.Show(line.LineIndex, color);
			symbolPositions = [];
			this.panel.SetMessage(this.translator.t.linepay("" + (line.LineIndex + 1), service.moneyFormatter.FormatCreditCurrentDenom(line.Win)));

			let lineindex: number = line.LineIndex;


			let symbolsToAnimate: number = this.playlines[lineindex].length;
			if (animateOnlyWinningSymbols) {
				symbolsToAnimate = line.SymbolCount;
			}


			for (let i = 0; i < symbolsToAnimate; i++) {
				symbolPositions.push(new SymbolPositionToAnimate(i, this.initData.PlayWindow.Height - 1 - this.playlines[lineindex][i]));
			}

			this.screenProtocol?.Send(new SlotGameMessages.WiningSymbol(line.SymbolIndex), this.screenProtocolScope);

			//this.symbolsAnimation.Stop();
			//this.symbolsAnimation.Update();

			if (this.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
				this.spinnableReels.StopSymbolsAnim();
				this.spinnableReels.PlaySymbolsAnim(symbolPositions);
			} else if (this.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
				this.symbolCollection.PlayAnimationWinSymbolSpineSymbol(symbolPositions);
			}

			//this.spinnableReels.Stop(symbolPositions);

			this.EnableCache = false;
			//this.symbolsAnimation.Stop();
			//this.symbolsAnimation.Update();
			symbolPositions = null;
			lineindex = null;
			symbolsToAnimate = null;
			color = null;
			//this.symbolsAnimation.Start(symbolPositions);
			//this.EnableSymbolsAnimation(symbolPositions);		
			//this.audio.Stop(this.resid.ScopedResourceName("linecount")); 
			//this.audio.PlayLoop(this.resid.ScopedResourceName("linecount"));
		});

		this.winLinesAnimation.AddCompleteCallbacks(() => {
			this.audio.Stop(this.resid.ScopedResourceName("linecount"));
			this.StartAnimWinLinesBackgroundFadeOut();
			this.spinnableReels.StopSymbolsAnim()
			this.EnableCache = true;
			this.DisableSymbolsAnimation();
		});

		await this.winLinesAnimation.PrepareResources(resourceManager);
	}


	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage == LoadingStage.GamesConfig) {
			//load Json Game 
			resourceManager.Add(new JSONResource(`${this.basepath}resources/GameConfig.json`, this.resid.ScopedResourceName(`GameConfig-${this.gameName}-JSON`)));

		}
		else if (loadingStage == LoadingStage.UniReel) {
			if (this.gameConfig.enabledPuppet) {
				this.CreateFillingPot();
				await this.fillingPotFeature.PrepareResources(loadingStage, resourceManager);
			}
			if (this.gameConfig.uniReel) {
				this.uniReel = new UniReelPIXIAPP({ basePath: this.basepath, gameName: this.gameName });
			}
			else {
				this.uniReel = new FakeUniReelPIXIAPP();
			}

			await this.uniReel?.PrepareResources(resourceManager)
		}
		else if (loadingStage == LoadingStage.GamesPreload) {
			await this.PrepareResourcesGamesPreload(resourceManager);
		}
		else if (loadingStage == LoadingStage.Games) {
			//move for create different family for feature 		
			if (this.gameConfig.enabledPuppet) {
				await this.fillingPotFeature?.CreateFamilyAndPrepareResources(resourceManager, !this.gameConfig.poppetPlusPot ? false : true, this.spinnableReels)
			}
			await this.PrepareResourcesGame(resourceManager);
		}

		await this.BonusesPrepare(loadingStage, resourceManager);
	}

	protected async PrepareResourcesGamesPreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		// nothing to load for now
		await this.PreparedPanel();
		await this.winMessageAnimation.PrepareResources(resourceManager);
		//move for GamePreload because takes more time save and share the spine symbol
		await this.SymbolsPrepare(resourceManager);
	}

	protected async PrepareResourcesGame(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//this.panel.PrepareResources(resourceManager);

		if (Settings.OnlineControls) {
			//sresourceManager.Add(new ImageResource(this.basepath + "online/thumbnail.png", this.gameName + ".online.thumbnail"));
		}

		//resourceManager.Add(new HTMLResource(this.basepath + "game.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.basepath + "game.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		//resourceManager.Add(new ImageResource(this.commonpath + "denom-frame.png", this.resid.ScopedResourceName(["frame","image"])));
		//help
		await this.HelpPrepare(resourceManager);

		//font
		await this.PrepareFont(resourceManager);

		await this.PrepareHistory(resourceManager);

		//paytable
		await this.PaytablePrepare(resourceManager);

		//title 
		//resourceManager.Add(new ImageResource(this.basepath + "resources/title.png", this.gameName + ".title.image"));

		//presentation 
		//resourceManager.Add(new ImageResource(this.basepath + "resources/selectbutton.png", this.gameName + ".presentation.image"));



		// nice image of symbols
		//await this.SymbolsPrepare(resourceManager);


		// basegame resources
		await this.BasegamePrepare(resourceManager);

		// //background

		// this.PrepareBackgroundReel(resourceManager);
		//await this.ConstructReels(resourceManager);

		// big win messages
		await this.BigWinPrepare(resourceManager);

		await this.FeaturesPrepare(resourceManager);
		await this.panel.PrepareResources(resourceManager);
		await this.help.PrepareResources(resourceManager);

		await this.PrepareWinLines(resourceManager);


		//this.bigSymbolAnim = new BigSymbolAnim(this.symbolsMap, this.spinnableReels);		
		//this.InitZoomedInSymbols();



		await this.AudioPrepare(resourceManager);

		await this.denomMenu.PrepareResources(resourceManager);

		await this.PresentationPrepare(resourceManager);

		await this.TurboSpinPrepare(resourceManager);

		await this.replayMessage.PrepareResources(resourceManager);
		this.view.appendChild(this.replayMessage.View());

		await this.doubleUpView?.PrepareResources(resourceManager);

		await this.jackpotSharedShow?.PrepareResources(resourceManager);

		await this.PrepareAnticipation(resourceManager);

		await this.fountainAnimation.PrepareResources(resourceManager);

		if (!this.gameConfig.bonusMultiplier) return

		this.bonusMultiplier = new BonusMultiplierResponsive(this.initData.EnabledBets, this.audio, this.resid);
		this.bonusMultiplier.OnShowFinishedCallback = () => {
			this.stateMachine.ChangeState(SlotGameState.FillingPot, null, ChangeStateType.NextTask)
		}
		await this.bonusMultiplier?.PrepareResources(resourceManager);


	}

	protected async PrepareAnticipation(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		const anticipationFactoryParams: IAnticipationFactoryParams = {
			playWindow: this.initData.PlayWindow,
			symbolSize: this.spinnableReels.GetSymbolSize(),
			gameName: this.gameName,
			anticipationType: this.gameConfig.anticipationType,
		};

		this.anticipationFactory = new AnticipationFactory(anticipationFactoryParams);
		this.anticipationAnimation = await this.anticipationFactory.CreateAnticipation();
		await this.anticipationAnimation?.PrepareResources(resourceManager);

	}

	protected viewSize: Size = null;
	protected payTable: IPaytable = null;

	protected async PaytablePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		// when jackpot enabled, load jackpot instead of paytable
		if (this.initData.JackpotEnabled) {
			return;
		}

		const PaytableParams: IPaytableParams = {
			paytable: this.initData.Paytable,
			symbolSpriteAnims: this.symbolSpriteAnims,
			viewSize: this.viewSize,
			symbols: this.symbols,
			nameGame: this.initData.GameName,
			resid: this.resid,
			systemContext: this.systemContext,
			initData: this.initData,
			translator: this.translator,
			symbolsCollection: this.symbolCollection.symbolCollectionMap,
		};

		const payTableFactory: PaytableFactoryPIXIApp = new PaytableFactoryPIXIApp();
		this.payTable = payTableFactory.CreatePayTable(PaytableParams);

		await this.payTable.PrepareResources(resourceManager);
	}

	protected idleMessages: string[] = ["Good Luck", "Feeling lucky"];

	protected timeoutGameState: ITimeout;
	protected timeOutRequestFeature: ITimeout;
	protected timeoutBigWinStart: ITimeout;
	//protected timeoutRobotSpinStops : ITimeout;
	protected timeoutWaitBonusStartConfig: ITimeout;
	protected timeoutBonusShow: ITimeout;
	protected timeoutBonusShowTransition: ITimeout;
	protected winlnestoAnimateFadeOut = { volume: 0 };

	protected gameConfig: GameConfigurationJson = null;
	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		await this.fillingPotFeature?.ResourcesLoaded(loadingStage, resourceManager);
		if (loadingStage == LoadingStage.GamesConfig) {
			this.gameConfig = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`GameConfig-${this.gameName}-JSON`)).json;
			// await this.uniReel?.ResourcesLoaded(resourceManager);

			//console.log(`GameConfig-${this.gameName}:`,this.gameConfig);
			//move create reels for create first and send data too , symbols collection 
			// if (this.fillingPotFeature?.GetReelSize()) this.windowRectangle = this.fillingPotFeature?.GetReelSize();
			// if (this.uniReel){
			// 	this.uniReel.Create();
			// 	this.windowRectangle = this.uniReel.GetReelsPosition();
			// }
			this.color = this.gameConfig.colorScatter ? this.gameConfig.colorScatter : this.color;
			this.ColorLed = this.gameConfig.colorLed ? this.gameConfig.colorLed : this.ColorLed;
			//await this.ConstructReels();
			//create symbols collection 						
			//this.symbolCollection = new SymbolCollection(this.symbols, this.gameName, this.resid, this.basepath, this.spinnableReels, this.gameConfig, this.logGroup, this.initData.PlayWindow, this.audio);
		}
		else if (loadingStage == LoadingStage.UniReel) {
			if (this.gameConfig.enabledPuppet) {
				await this.fillingPotFeature.ResourcesLoaded(loadingStage, resourceManager);
			}

			if (this.uniReel) {

				await this.uniReel?.ResourcesLoaded(resourceManager);
				this.uniReel.Create();
				this.windowRectangle = this.uniReel.GetReelsPosition();
			}
			await this.ConstructReels();
			//create symbols collection 						
			this.symbolCollection = new SymbolCollection(this.symbols, this.gameName, this.resid, this.basepath, this.spinnableReels, this.gameConfig, this.logGroup, this.initData.PlayWindow, this.audio);

		}
		else if (loadingStage == LoadingStage.GamesPreload) {
			await this.ResourcesLoadedGamesPreload(resourceManager);
		}
		else if (loadingStage == LoadingStage.Games) {
			await this.ResourcesLoadedGames(resourceManager);
			this.buyBonusMenu.ResourcesLoaded(resourceManager);
			// this.view.appendChild(this.betTypeChangeMenu.ViewPIXIAPP());
		}

		await this.BonusesLoaded(loadingStage, resourceManager);

		//this.popupMessage.CallPayoutMenu= () =>	this.betTypeChangeMenu.Show()
	}

	protected async ResourcesLoadedGamesPreload(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//move for GamePreload because takes more time save and share the spine symbol
		// construct symbols
		// await this.SymbolsLoaded(resourceManager);
	}

	protected async ResourcesLoadedGames(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//this.view.innerHTML += resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;

		await this.AudioLoaded(resourceManager);


		await this.LoadedHistory(resourceManager);

		// construct symbols
		await this.SymbolsLoaded(resourceManager);

		//this.symbolsAnimation = new SymbolsAnimation(this.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper);
		//this.symbolsAnimation = new SpecificSymbolsAnimation(this.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper, this);

		// construct basegame
		this.basegameElement = CreateElement("div", {
			classes: ["basegame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: "100%",

				backgroundSize: "cover",
				backgroundPosition: "center center",
				position: "relative",
			}
		});

		await this.payTable?.ResourcesLoaded(resourceManager);

		await this.spinnableReels.ResourcesLoaded(null, this.reelBackgroundTexture, this.reelBackgroundMaskTexture);
		//this.basegameElement.appendChild(this.spinnableReels.GetView());
		this.LoadedReels();
		//this.RedrawAllReels();
		await this.InitZoomedInSymbols();

		if (this.initData.Meta.Demo == true) {

			this.basegameElement.appendChild(this.demoMessage);
		}
		//append denom and line message
		//this.basegameElement.appendChild(this.lineMessageLeftContainer);
		//this.basegameElement.appendChild(this.lineMessageRightContainer);
		//this.basegameElement.appendChild(this.denomMessage);


		await this.winLinesAnimation.ResourcesLoaded(resourceManager);



		// construct line markers
		//this.basegameElement.appendChild(this.winLineMarkers.LeftView());
		//this.basegameElement.appendChild(this.winLineMarkers.RightView());



		// basegame loaded
		await this.BasegameLoaded(resourceManager);

		//
		//await this.basegameElement.appendChild(this.winLinesAnimation.View());

		await this.LoadedFillingPot(resourceManager);

		// BIG WIN
		//this.winMessageAnimation = new WinMessageAnimation(this.multigameParams.viewSize);
		await this.BigWinLoaded(resourceManager);

		await this.FeaturesLoaded(resourceManager);

		await this.panel.ResourcesLoaded(resourceManager);



		// put panel on top
		this.view.appendChild(this.panel.View());

		await this.HelpLoaded(resourceManager);

		await this.denomMenu.ResourcesLoaded(resourceManager);
		//this.view.appendChild(this.denomMenu.View());


		await this.PresentationLoaded(resourceManager);

		//this.bonusTriggerAnimation = new SpecificSymbolsAnimation(null, this.spinnableReels, this.reelSetMapper, this);


		this.panelWinLabel = this.translator.Translate(() => this.stateMachine.State() == SlotGameState.Idle ? this.translator.t.lastwin : this.translator.t.win);
		this.View()?.querySelector(".but-win-label")?.appendChild(this.panelWinLabel?.location);

		await this.TurboSpinLoaded(resourceManager);
		this.stateMachine.ChangeState(SlotGameState.Idle);

		this.stopAnimTriggerBonusAnim = this.systemContext.TimingContext().CreateTimeout("stopAnimTriggerBonusAnim", 2000, () => {
			this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig);
			this.EnableCache = true;
			this.spinnableReels.StopSymbolsAnim();
			this.DisableSymbolsAnimation();
		});

		this.stopAnimTriggerScatterAnim = this.systemContext.TimingContext().CreateTimeout("stopAnimTriggerScatterAnim", 2000, () => {
			this.spinnableReels.StopSymbolsAnim();
			//this.symbolsAnimation.Stop();
			this.EnableCache = true;
			this.DisableSymbolsAnimation();
			this.OnScatterWinEnd();
		});

		this.nextTimeoutAnimTriggerScatterAnim = this.systemContext.TimingContext().CreateTimeout("nextTimeoutAnimTriggerScatterAnim", 2000, () => {
			this.PlayNextScatter()
			this.CheckifMoreScatter(this.scatterResult.PositionsPerSymbol[this.startkeysIndexScatter[this.currentIndex + 1]]?.Position);
		});

		this.nextAnimTimeoutTriggerBonus = this.systemContext.TimingContext().CreateTimeout("nextAnimTimeoutTriggerBonus", 2000, () => {
			this.EnableCache = true;
			this.PlayNextTriggerBonus();
			this.CheckifMoreTriggerBonus();
		});


		await this.replayMessage.ResourcesLoaded(resourceManager);

		//Destroy all reels when all games it loaded 
		//this.DestroyPixi();
		this.timeoutGameState = this.systemContext.TimingContext().CreateTimeout("timeoutGameState ReadyToPlay", 1000, () => {
			this.GameStateChanged(GameState.ReadyToPlay);
		});

		this.timeOutRequestFeature = this.systemContext.TimingContext().CreateTimeout("Request-Feature-Stops-Timeout", 1500, () => {
			if (this.turboSpin && this.currentFeature != null) {
				this.RequestFeatureStop();
			}
		});

		this.timeoutBigWinStart = this.systemContext.TimingContext().CreateTimeout("timeoutBigWinStart", 2000, async () => {
			this.audio.Stop(this.resid.ScopedResourceName("bigwin"));
			this.shakeAnimation.Stop();
			this.stateMachine.ChangeState(SlotGameState.Win);
			this.fountainAnimation.Create();
			await this.fountainAnimation.Start();
		});


		// this.timeoutRobotSpinStops = this.systemContext.TimingContext().CreateTimeout("timeoutRobotSpinStops",1000,()=>{
		// 	this.robotPlay.OnSpinStopAvailable();		
		// });

		this.timeoutWaitBonusStartConfig = this.systemContext.TimingContext().CreateTimeout("timeoutWaitBonusStartConfig", 1500, () => {
			// this.currentBonus.Hide();
			// this.currentBonus.GameExit();
			// this.currentBonus.DestroyTransition();								
			//this.currentBonus = this.runingBonuses[this.runingBonuses.length - 1];
			this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig);
		});


		let timerBonusShow: number = 2000;
		this.timeoutBonusShow = this.systemContext.TimingContext().CreateTimeout("timeoutBonusShow", timerBonusShow, () => {
			this.robotPlay.BonusStarted(this.currentBonus);
			this.currentBonus.GameSelected(this.gameViewAppPixi.GetAppView().stage);
			this.currentBonus.fillingPotFeature?.SetCurrentFromBaseGameLevels(this.fillingPotFeature?.GetCurrentLevels());
			this.currentBonus.fillingPotFeature?.SetBet(this.selectedBet);

			if (this.currentBonus.Name() != "FreeGameBonus") this.bonusMultiplier?.ResetLevel(this.selectedBet);
			//stops fillingPotFeature				
			this.fillingPotFeature?.StopAnim();

			//for(let i = 0; i < this.runingBonuses.length; i++)
			//{
			//this.runingBonuses[i].Hide();
			//}
			//comment this and move for test it TransitionParticles 
			this.currentBonus.Show();
			this.audio.Stop(this.resid.ScopedResourceName("background"));
			this.basegameElement.style.display = "none";
			this.currentBonus.Start();
			//this.screenProtocol?.Send(new SlotGameMessages.BonusStart(this.currentBonus.Name()), this.screenProtocolScope);

			if (!this.gameConfig.enabledPuppet) {
				this.spinnableReels.Destroy("SlotGameType1.timeoutBonusShow");
			} else {
				this.fillingPotFeature?.Destroy();
			}
		});

		this.timeoutBonusShowTransition = this.systemContext.TimingContext().CreateTimeout("timeoutBonusShow", 100, () => {
			this.currentBonus.ShowVideoTransition();
			this.currentBonus.BackGroundTransition();
			this.timeoutBonusShow.Start();
			//stops fillingPotFeature				
			this.fillingPotFeature?.StopAnim();
		});

		if (this.doubleUpView) {
			this.view.appendChild(this.doubleUpView.View());
			await this.doubleUpView?.ResourcesLoaded(resourceManager);
		}

		this.view.appendChild(this.popUpMenuAnim.View())

		this.lineCountBackground = this.audio.Track(this.resid.ScopedResourceName("lineCountBackground"));

		//let toAnimateFadeIn = { volume: 0  };
		// this.fadeinWinlinesSound = TweenMax.to(toAnimateFadeIn, {			
		// 	volume: this.audio.GetAudioLevel() , duration: 0.85, onUpdate: () => track.SetVolumeAnalog(toAnimateFadeIn.volume),onStart : ()=> {
		// 		track.PlayLoop(Track.LoopForEver);
		// 	}
		// }).pause();

		await this.winMessageAnimation.ResourcesLoaded(resourceManager);
		// // messages			
		for (let i = 0; i < this.wins.length; i++) {
			// 	let message = new WinMessage(this.wins[i].name, resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name)).sprite, this.wins[i].winMultiplier, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
			// 	this.winMessageAnimation.AddMessage(message);
			await this.winMessageAnimation.AddSound(this.wins[i].name, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
		}


		//await this.symbolsCollection.ResourcesLoaded(resourceManager);
		await this.jackpotSharedShow?.ResourcesLoaded(resourceManager);

		await this.bonusMultiplier?.ResourcesLoaded(resourceManager);

		await this.anticipationAnimation?.ResourcesLoaded(resourceManager);

		await this.fountainAnimation.ResourcesLoaded(resourceManager);

		this.responsivePanelFit.appendChild(this.panel.View());
		this.gameView.appendChild((this.panel as PanelOnlineResponsive).ResponsiveView());
	}

	protected StartAnimWinLinesBackgroundFadeOut() {
		if (this.lastSpinAction.Win.ResultLines.length < 1) return
		//console.log("WinLineSound-StartAnim")
		this.GetAudioLevelTrackWinLines();
		this.fadeoutWinlinesSound = TweenMax.to(this.winlnestoAnimateFadeOut, {
			volume: 0, duration: 1,
			//onStart: () => this.GetAudioLevelTrackWinLines(),
			onUpdate: () => this.lineCountBackground.SetVolumeAnalog(this.winlnestoAnimateFadeOut.volume),
			onComplete: () => {
				//this.lineCountBackground.Stop();
				this.GetAudioLevelTrackWinLines();
				this.lineCountBackground.Stop();
				this.fadeoutWinlinesSound?.kill();
				this.fadeoutWinlinesSound = null;
			}
		});
	}


	//create FillingPot 
	protected async LoadedFillingPot(resourceManager: IReadOnlyResourceManager) {
		if (!this.fillingPotFeature) {
			// not enabled;
			return;
		}

		// this.basegameElement.appendChild(this.fillingPotFeature.View());
		// redraw reels when context recovers
		this.fillingPotFeature.OnCreatedCallback = async () => {
			//console.log("CallBackForFillingPot");
			// this.spinnableReels.Create(this.fillingPotFeature.GetReelContainer(), this.gameViewAppPixi.GetAppView());
			// this.shakeAnimation.CreateShakeAnimationPixi(this.fillingPotFeature?.GetReelContainer());

			// for (let [name, feature] of this.features) {
			// 	//await feature.ResourcesLoaded(resourceManager);

			// 	if (feature) {
			// 		feature.CreatePIXIAPP();
			// 		this.gameViewAppPixi.GetAppView().stage.addChild(feature.ViewPIXIAPP());
			// 	}
			// };

			// this.winLinesAnimation.CreatePIXIAPP();
			// this.gameViewAppPixi?.GetAppView().stage.addChild(this.winLinesAnimation.ViewPIXIAPP());
			// this.denomMenu.CreatePIXIAPP();
			// this.gameViewAppPixi?.GetAppView().stage.addChild(this.denomMenu.ViewPIXIAPP());
			// this.bigWinCountAnimation.CreatePIXIAPP();
			// this.gameViewAppPixi?.GetAppView().stage.addChild(this.bigWinCountAnimation.ViewPIXIAPP());
			// this.winMessageAnimation.CreatePIXIAPP();
			// this.gameViewAppPixi?.GetAppView().stage.addChild(this.winMessageAnimation.ViewPIXIAPP());

			// if(this.jackpotSharedShow != null){
			// 	this.jackpotSharedShow?.Create();
			// 	this.gameViewAppPixi?.GetAppView().stage.addChild(this.jackpotSharedShow?.View());			
			// }

			// this.bonusMultiplier?.Create(this.fillingPotFeature?.GetPositionBonusMultiplier());
			// this.gameViewAppPixi.GetAppView().stage.addChild(this.bonusMultiplier?.View())

			// await this.CreateGamePIXIElements();
		};

		this.fillingPotFeature.OnDestroyCallback = () => {
			//console.log("CallBackForFillingPot");			
			// this.spinnableReels.Destroy("Destroy SlotGameType1");

			// this.winLinesAnimation.ViewPIXIAPP().destroy({ children: true });
			// for (let [name, feature] of this.features) {
			// 	if (feature) {
			// 		feature.ViewPIXIAPP().destroy({ children: true });
			// 	}
			// };

			// this.denomMenu.ViewPIXIAPP()?.destroy({ children: true });
			// this.bigWinCountAnimation?.ViewPIXIAPP().destroy({ children: true });
			// this.winMessageAnimation?.ViewPIXIAPP().destroy({ children: true });
			// this.bonusMultiplier?.Destroy();
			// this.buyBonusMenu.ViewPIXIAPP()?.destroy({ children: true });
			// this.features.forEach(ele => {
			// 	ele.Destroy();
			// });
			// this.jackpotSharedShow?.Destroy();

			// this.anticipationAnimation.Destroy();
		};
	}


	protected CreateGamePIXIElements() {
		this.shakeAnimation.CreateShakeAnimationPixi(this.spinnableReels.GetReelsContiner());
		// this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(this.uniReel.GetView());
		for (let [name, feature] of this.features) {
			//await feature.ResourcesLoaded(resourceManager);

			if (feature) {
				feature.CreatePIXIAPP();
				this.uniReel.GetReelsContainer().addChild(feature.ViewPIXIAPP());
			}
		};

		this.anticipationAnimation?.Create(this.spinnableReels.GetReelBackgroundRect(), this.windowRectangle);

		if (this.anticipationAnimation?.GetView()) {
			this.uniReel.GetReelsContainer().addChild(this.anticipationAnimation?.GetView());
		}
		//create and add winlines 
		// this.SetupWinLines();
		this.denomMenu.CreatePIXIAPP();
		this.gameViewAppPixi?.GetAppView().stage.addChild(this.denomMenu.ViewPIXIAPP());
		this.bigWinCountAnimation.CreatePIXIAPP();
		const bigWinCountView = this.bigWinCountAnimation.ViewPIXIAPP();
		bigWinCountView.zIndex = 3;
		this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(bigWinCountView);
		this.winMessageAnimation.CreatePIXIAPP();
		const winMessageView = this.winMessageAnimation.ViewPIXIAPP();
		winMessageView.zIndex = 3;
		this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(winMessageView);

		this.SetupWinLines();


		this.buyBonusMenu.CreatePIXIAPP();
		const buyBonusView = this.buyBonusMenu.ViewPIXIAPP();
		buyBonusView.zIndex = 3;
		this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(buyBonusView);

		if (this.jackpotSharedShow) {
			this.jackpotSharedShow?.Create();
			this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(this.jackpotSharedShow?.View());
		}

		if (!this.gameConfig.bonusMultiplier) return
		this.bonusMultiplier?.Create(this.fillingPotFeature?.GetPositionBonusMultiplier());
		this.gameViewAppPixi.GetReelsGameResponsiveContainer().addChild(this.bonusMultiplier?.View());

		void this.OnResize(0, 0, GetOrientation())
	}

	protected SetupWinLines() {
		let containerReels: PIXI.Container = null;
		if (this.gameConfig.winLinesDrawOrder == WinLinesDrawOrder.backSymbols) containerReels = this.fillingPotFeature?.GetReelContainer();
		this.winLinesAnimation.CreatePIXIAPP(containerReels);

		this.uniReel.GetReelsContainer().addChild(this.winLinesAnimation.ViewPIXIAPP());
	}

	protected reelElement: PIXI.Container[] = [];
	protected reelMask: PIXI.Container[] = [];
	protected reelSpinAnimation: ReelSpinAnimation[] = [];
	protected wonFlagDoubleUpGame: boolean = null;


	protected LoadedReels() {

		const spinParams: SpinAnimParams = availableSpinParams[this.speedManager.GetDefaultReelSpeedType()];

		for (let i: number = 0; i < this.spinnableReels.GetWindowSymbolSize().Width; i++) {
			((i: number) => {


				let isSpinEnding = false;
				//console.log("reelElementReturned:",	this.reelElement[i]);				
				//console.log("reelElementReturned:",reelWhitBackgroundElement[i]);				
				//SetStyles(reelWindowElement., {margin: "0px 5px"});

				const anticipationZoomFactor: number = 1.125;
				const idleZIndex: number = ZIndex.ReelContainerBackground;
				const anticipationZIndex: number = 100;


				//const anticipationBeginAnim = TweenLite.to(reelWhitBackgroundElement[i], 0.5, {pixi:{scaleY: anticipationZoomFactor, onStart: () =>this.reelElement[i].zIndex = anticipationZIndex}});
				//const anticipationEndAnim = TweenLite.to(reelWhitBackgroundElement[i], 0.5, {pixi:{scaleY: 1,onStart: () =>this.reelElement[i].zIndex = idleZIndex}});

				let originalBackgroundAnticipation: Color = null;
				let newBackgroundAnticipation: Color = null;

				let r: ReelSpinAnimation = new ReelSpinAnimation(
					i,
					this.logGroup,
					this.spinnableReels.GetSymbolSize(),
					this.spinnableReels.GetWindowSize(),
					this.spinnableReels.GetWindowSymbolSize(),
					this.spinnableReels.GetExtendendWindowSymbolSize(),
					spinParams.SpeedFactor,
					spinParams.Duration,
					spinParams.Delay,
					spinParams.SpeedCorrection
				);

				this.reelSpinAnimation.push(r);

				let m: ReelMapper = new ReelMapper(i, this.logGroup, this.windowSymbolSize.Height, this.spinnableReels.GetExtendendWindowSymbolSize().Height);

				this.reelSetMapper.AddReelMapper(m);

				r.AddOnStartCallback(() => {
					isSpinEnding = false;
					m.Start();
					this.DisableReelOverflow(i);
					//this.bigSymbolAnim.UpdateSymbols(i, m.GetSymbols2().map(s => s.symbolIndex));
				});

				r.AddOnStopAvailableCallback((reelIndex) => {
					//// Log.Debug(this.logGroup, "Reel stop request is available");
				});

				r.OnUpdateCallback = (anim, params) => {
					m.Update(params.distanceSymbols);
					// symbols in window have changed, update
					if (m.DidSymbolsChange()) {
						this.RedrawReel(i);
						//need to redraw symbol if you hit some wild , change reelMapper and redraw all again because symbols was changed by callback works 				
						if (m.IsOverlayActivated() == true) {
							this.symbolCollection.CreateSymbolAnimation(i);
							this.AddAwardIntoSpine(i);
						}

					}

					if (this.reelElement?.[i]?.transform?.position) {
						this.reelElement[i].transform.position.y = params.translatePixels;
					}
				};

				r.onAnticipationBeginCallbacks = () => {
					// Log.Debug(this.logGroup, "Anticipation begin");

					//anticipationBeginAnim.restart();
					this.anticipationAnimation?.ShowReelAnimation(i);
					if (!this.anticipationStarted) {
						//console.log(`Anticipation started reel ${i}`);						
						this.anticipationStarted = true;
						this.fillingPotFeature?.StartAnticipationBegin();
						this.audio.Play(this.resid.ScopedResourceName("anticipation"));
					}
				};

				r.onAnticipationEndCallbacks = () => {
					// Log.Debug(this.logGroup, "Anticipation end");

					//anticipationBeginAnim.pause();
					//anticipationEndAnim.restart();					
				};

				r.AddOnDeccelerationCallbak((params: OnDeccelerationParams) => {
					// Log.Debug(this.logGroup, "decceleration started");

					// when decceleraton starts, we know when animation will end, so we can set up reel slice distance

					//let distance = r.GetDistance() + params.distanceToEnd;
					let distanceInSymbols = params.totalDistanceInSymbols; //Math.floor( / 100);

					m.Slice(distanceInSymbols);
					isSpinEnding = true;

					this.symbolCollection.PlayAnimationIdleSpineSymbol();
				});

				r.onNearComplete = this.OnReelNearStopped.bind(this);

				// r.AddOnNearCompleteCallback(() => {
				// 	//this.bigSymbolAnim.UpdateSymbols(i, m.GetSymbols(this.spinnableReels.GetExtendendWindowSymbolSize().height));
				// 	this.OnReelNearStopped(i);
				// });

				r.AddOnCompleteCallback(() => this.OnReelStopped(i));

				this.spinAnimation.AddReelAnimation(r);

				// stop the reel when touched
				// reelWindowElement.addEventListener('click', (ev:MouseEvent) => {
				// 	if (this.stateMachine.State()== SlotGameState.Spin){
				// 		this.spinAnimation.RequestStop(i);
				// 	}
				// });

				// this.symbolCollection.CreateSymbolAnimation(i);
			})(i);
		}

		// when spin finishes, go to features
		this.spinAnimation.AddOnCompleteCallback(() => {
			if (this.bonusMultiplier) {
				this.stateMachine.ChangeState(SlotGameState.BonusMultiplier, null, ChangeStateType.NextTask);
				return;
			}

			if (this.fillingPotFeature) {
				this.stateMachine.ChangeState(SlotGameState.FillingPot, null, ChangeStateType.NextTask);
				return;
			}

			this.stateMachine.ChangeState(SlotGameState.Features, null, ChangeStateType.NextTask);
		});

		this.spinAnimation.AddOnCompleteCallback(() => {
			if (this.anticipationStarted == true) {
				this.fillingPotFeature?.EndAnticipationBegin();
			}
			this.anticipationStarted = false;
			this.audio.Stop(this.resid.ScopedResourceName("anticipation"));

		});

		this.reelSetMapper.SetReelSet(this.reelset, this.startPositions);

		this.currentSymbols = this.reelSetMapper.GetSymbols2();

		let spinnableReelsView: HTMLElement = this.spinnableReels.GetView();

		if (Settings.touchToStop == true) {
			AddMouseDownListener(spinnableReelsView, () => {
				this.spinAnimation.RequestStop();
			});
		}

		// redraw reels when context recovers
		this.spinnableReels.OnCreatedCallback = () => {

			this.CreateGamePIXIElements();
			this.ReelsRestored()
		};

		this.spinnableReels.OnDestroyCallback = () => {
			// this.spinnableReels.Destroy("Destroy SlotGameType1");
			this.winLinesAnimation.ViewPIXIAPP().destroy({ children: true });
			for (let [name, feature] of this.features) {
				if (feature) {
					feature?.ViewPIXIAPP()?.destroy({ children: true });
				}
			};
			if (this.uniReel) {
				this.uniReel.Destroy();
			}
			this.bigWinCountAnimation?.ViewPIXIAPP().destroy({ children: true });
			this.winMessageAnimation?.ViewPIXIAPP().destroy({ children: true });
			this.features.forEach(ele => {
				ele?.Destroy();
			});
			this.jackpotSharedShow?.Destroy();

		}
	}

	protected panelWinLabel: TranslatedLocation;
	public OnDestroyCallback: OnDestroyCallbackHandler = null;


	//protected recover: boolean = false;
	protected bonusStartConfigForRecover: IBonusStartConfig[] = [];

	// public Recover(lastGame: IHistoryEntry, bonusStartConfig: IBonusStartConfig[]):void
	// {
	// 	this.lastGame = lastGame;
	// 	this.recover = true;
	// 	this.lastSpinResult = {} as SimpleSlotGameState;
	// 	this.bonusStartConfig = null;
	// 	this.bonusStartConfigForRecover = bonusStartConfig;

	// 	// get win from last action
	// 	let win: Money = lastGame.Actions[lastGame.Actions.length -1].GameResult.Win;



	// 	let betIndex = this.initData.EnabledBets.findIndex(b => 
	// 		b.Denom.InCents == lastGame.SlotGameBet.Denom.InCents &&
	// 		b.BetPerLineCents.InCents == lastGame.SlotGameBet.BetPerLineCents.InCents &&
	// 		b.Lines == lastGame.SlotGameBet.Lines
	// 	);

	// 	if (betIndex == -1)
	// 	{
	// 		throw `No such bet when recovering!`;
	//     }

	//     this.SelectBet2(betIndex);
	//     this.bet = this.initData.EnabledBets[betIndex];





	// 	this.clientState.GameStart(this.bet.TotalBetCents);

	// 	let spinAction: ISpinHistoryAction = lastGame.Actions[0] as ISpinHistoryAction;




	// 	if(spinAction.TriggeredBonus != Bonus.None)
	// 	{
	// 		let firstBonus: Bonus = spinAction.TriggeredBonus;


	// 		//this.lastSpinResult.Bonus = firstBonus;
	// 		//this.lastSpinResult.TotalWin = lastGame.TotalWin;
	// 		//this.panel.SetBalance(this.moneyFormatter.FormatCredit(spinAction.SpinTotalWin.InCents), this.moneyFormatter.FormatCurrency(spinAction.SpinTotalWin.InCents));
	// 		this.bonusStartConfig = bonusStartConfig[0];


	// 		this.currentBonus = this.bonusList.get(firstBonus);
	// 		//this.runingBonuses.push(this.currentBonus);

	// 		//this.currentBonus.Recover(lastGame);
	// 		this.stateMachine.ChangeState(SlotGameState.Bonus);
	// 	}
	// 	this.ShowGame();


	// 	this.panel.SetWin(this.moneyFormatter.FormatCreditCurrentDenom(win.InCents), this.moneyFormatter.FormatCurrency(win.InCents));
	// 	//this.screenProtocol?.Send(new SlotGameMessages.RecoverGame(lastGame), this.screenProtocolScope);

	// 	//
	// 	if ( this.UpdateDenom != null) {
	// 		this.UpdateDenom(this.initData.EnabledBets, this.selectedBet.Denom.InCents);
	// 	}
	// 	if( this.GameStateChanged != null){
	// 		this.GameStateChanged(GameState.ReadyToPlay);
	// 	}
	// }

	protected isReplay: boolean = false;
	protected realBalanceAfterReplay: number;

	public ContinueUnfinishedGame(gameState: SimpleSlotGameState): void {
		if (!this.stateMachine.IsState(SlotGameState.Idle)) {
			// only in idle
			return;
		}



		this.isReplay = true;
		this.realBalanceAfterReplay = this.clientState.Balance();


		this.replayMessage.Show();

		let betIndex = this.initData.EnabledBets.findIndex(b =>
			b.Bet.Denom.InCents == gameState.Bet.Bet.Denom?.InCents &&
			b.Bet.TotalBetCents.InCents == gameState.Bet.Bet.TotalBetCents.InCents &&
			b.Bet.Lines == gameState.Bet.Bet.Lines
		);

		if (betIndex == -1) {
			throw `No such bet when recovering!`;
		}

		this.SelectBet2(betIndex);
		this.selectedBetIndex = {
			Index: betIndex,
			Type: BetType.Normal
		};

		this.clientState.UpdateBalance(gameState.CreditStart.InCents);
		this.clientState.TryGameStart(this.bet.TotalBetCents);

		this.showDenomMenu = false;


		this.stateMachine.ChangeState(SlotGameState.WaitGameStart);
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		this.SpinSuccess(gameState);
	}

	public override ContinueUnfinishedDoubleUp(unfinishedGameState: DoubleUpGameState): void {

		if (!this.doubleUpView) {
			// doubleup is not enabled, we are not recovering
			return;
		}

		let betIndex = this.initData.EnabledBets.findIndex(b =>
			b.Bet.Denom.InCents == unfinishedGameState.Denom.InCents &&
			b.Bet.TotalBetCents.InCents == unfinishedGameState.BetStart.InCents
		);

		if (betIndex == -1) {
			betIndex = 0;
		}

		this.SelectBet2(betIndex);
		this.selectedBetIndex = {
			Index: betIndex,
			Type: BetType.Normal
		};

		this.clientState.UpdateBalance(unfinishedGameState.CreditStart.InCents);

		this.showDenomMenu = false;





		// todo
		//this.stateMachine.ChangeState(SlotGameState.DoubleState);

		this.startDoubleUpGame(unfinishedGameState);
	}


	protected HelpPrepare(resourceManager: IWriteOnlyResourceManager): void {
		this.help = this.helpFactory.CreateNewHelp({
			initData: this.initData,
			slotSize: Size.FromPlayWindow(this.windowSymbolSize),
			resid: this.resid,
			translator: this.translator,
			game: this as unknown as SimpleSlotGameState,
			backendSettings: this.multigameParams.backendSettings,
			symbols: this.symbols,
			symbolCollectionMap: this.symbolCollection.symbolCollectionMap,
			symbolTypeAnim: this.gameConfig.symbolsType,
			backgroundHelpPanelColor: this.gameConfig.backgroundHelpPanelColor ? this.gameConfig.backgroundHelpPanelColor : null
		});
		this.help.hideHelpCallback = () => this.helpResponsiveContainer.style.display = "none";
		this.buyBonusMenu.PrepareResources(resourceManager);
		//this.help = new Help(this.initData,this.windowSymbolSize, this.resid, this.translator, this);

		//this.help.PrepareResources(resourceManager);
		let paytableParams: IPaytableParams = {
			paytable: this.initData.Paytable,
			//symbolSpriteAnims : this.symbolsCollection.symbolSpriteAnims,
			viewSize: this.multigameParams.viewSize,
			symbols: this.symbols,
			nameGame: this.name,
			resid: this.resid,
			systemContext: this.systemContext,
			initData: this.initData,
			translator: this.translator,
			symbolsCollection: this.symbolCollection.symbolCollectionMap,
			symbolSpriteAnims: []
		}


		this.helpPaytable = this.help.pages.get("Paytable") as HelpPagePayTable;
		this.helpPaytable.PreprarePaytable(paytableParams, resourceManager);

	}

	protected helpPaytable: HelpPagePayTable = null;
	protected HelpLoaded(resourceManager: IReadOnlyResourceManager): void {

		this.help.ResourcesLoaded(resourceManager);

		//let paytable: HelpPagePayTable = this.help.pages.get("Paytable") as HelpPagePayTable;

		//this.helpPaytable = this.help.pages.get("Paytable") as HelpPagePayTable;
		//this.helpPaytable.SetPaytable(this.initData.PayTable, this.symbolSpriteAnims, this.multigameParams.viewSize,resourceManager);

		//paytable.SetPaytable(this.initData.paytable, this.symbolSpriteAnims, this.multigameParams.viewSize);
		this.helpPaytable.LoadPaytable(resourceManager);
		// this.helpResponsiveContainerFit.appendChild(this.help.View());
		this.Hide(this.help.View());
	}

	/**
	 *	SYMBOLS
	 */

	protected readonly symbolsByJackpot = {
		[JackpotDisplayType.RapidDiamondPot]: ["SRA"],
		[JackpotDisplayType.PlayCityLink]: ["SRA"],
		[JackpotDisplayType.RapidDiamondPotStep]: ["SRA"],
	}


	protected symbolsSpineIsExist: boolean = false;
	protected async SymbolsPrepare(resourceManager: IWriteOnlyResourceManager) {

		//resourceManager.Add(new SpriteResource(this.basepath + "resources/lightweight-symbols/symbols_181x181", this.resid.Add("SymbolsIdle"), true, this.logGroup.Add("SymbolsIdle"), true));

		// // symbols
		// for (let s of this.symbols) {

		// 	let symbolName: string = s.ID;
		// 	let symbolPath = this.basepath + "resources/symbols2/symbol_"+ symbolName;

		// 	if(this.symbolsByJackpot[Settings.JackpotDisplayType]?.includes(symbolName)){
		// 		symbolPath = this.basepath + "resources/SymbolsJackpots/"+ Settings.JackpotDisplayType + "/symbol_" + symbolName;
		// 	}

		// 	resourceManager.AddGlobal(new PixiSpriteResource(symbolPath , this.resid.Add("Symbol").Add(s.ID).Shared(), true, this.logGroup.Add("Symbol").Add(s.ID), true));
		// 	//resourceManager.AddGlobal(new PixiSpriteResource(this.basepath + "resources/symbols2/symbol_" + n , this.resid.Add("Symbol").Add(s.ID).Shared(), true, this.logGroup.Add("Symbol").Add(s.ID), true));

		// 	console.log("Symbols:", this.resid.Add("Symbol").Add(s.ID).Shared());
		// }	


		await this.symbolCollection.PrepareResources(resourceManager);

		//background

		await this.PrepareBackgroundReel(resourceManager);
	}

	//protected handleLoadProgeres(loader, resource) {
	//console.log(loader.progress + "% loaded");
	//}

	//protected symbolCache: SymbolCache;
	protected reelBackgroundTexture: PIXI.Texture = null;
	protected reelBackgroundMaskTexture: PIXI.Texture = null;
	//protected symbolCollectionMap: Map<string, SpineResources> = new Map<string, SpineResources>();

	protected async SymbolsLoaded(resourceManager: IReadOnlyResourceManager) {
		await this.symbolCollection.ResourcesLoaded(resourceManager);
		// //reels resources prepare Texture for pixi.js			
		let reelImageResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reel", "image"]));
		this.reelBackgroundTexture = PIXI.Texture.from(reelImageResource.DecodedImage());


		let reelImageMaskResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reelMask", "image"]));
		this.reelBackgroundMaskTexture = PIXI.Texture.from(reelImageMaskResource.DecodedImage());



		// Log.Debug(this.logGroup, "Symbols size: " + formatBytes(totalSymbolsSpritesSize));

		reelImageResource = null
		reelImageMaskResource = null

		//this.symbolCache = new SymbolCache(this.symbolSpriteAnimsByName, this.spinnableReels.GetSymbolSize(), this.resid);


		//this.symbolSpriteAnims = this.symbolsCollection.symbolSpriteAnims;
		//this.symbolSpriteAnimsByName = this.symbolsCollection.symbolSpriteAnimsByName;
		//this.pixiSpritesByName = this.symbolsCollection.pixiSpritesByName;		
	}

	//History view
	protected PrepareHistory(resourceManager: IWriteOnlyResourceManager) {
		//	resourceManager.Add(new CSSResource(Settings.ResourcesFolder + "multigame/slot/common/resources/playLines.css",this.resid.ScopedResourceName("playLines"), this.resid.Add("History").CSSScope()));
	}

	protected historySpinableReels: SpinnableReels = null;
	protected LoadedHistory(resourceManager: IReadOnlyResourceManager) {

		this.historySpinableReels = new SpinnableReels(this.initData.PlayWindow, new Rect(0, 0, Scale.W(720), Scale.H(512)), this.spinnableReelsParams);
		//this.historySpinableReels = new SpinnableReels(new Size(5,4),new PixelRect(0,0,900,640));
		SetStyles(this.historySpinableReels.GetView(),
			{
				position: "static"
			})
	}

	/**
	 *	BASEGAME SCENE
	 */
	protected BasegamePrepare(resourceManager: IWriteOnlyResourceManager) {
		//resourceManager.Add(new CSSResource(this.basepath + "basegame/basegame.css", this.resid.ScopedResourceName(["basegame", "css"]), this.resid.CSSScope()));

		if (Settings.Enable2plus1 == true) {
			resourceManager.Add(new ImageResource(this.basepath + "resources/background" + Settings.Screens + "S/" + "background2plus1.png", this.resid.ScopedResourceName([this.gameName, "background" + Settings.Screens + "S"])));
		} else {
			resourceManager.Add(new ImageResource(this.basepath + "resources/background" + Settings.Screens + "S/" + "background.png", this.resid.ScopedResourceName([this.gameName, "background" + Settings.Screens + "S"])));
		}
	}																			//ruta 										, 															

	protected gameBackground: ImageResource = null;

	protected BasegameLoaded(resourceManager: IReadOnlyResourceManager) {
		this.gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName([this.gameName, "background" + Settings.Screens + "S"]));

		SetStyles(this.backgroundBaseGame, {
			backgroundImage: this.gameBackground.CssBackground(),
			backgroundSize: "100%",
		});
	}

	/**
	 *	WIN LINES AND MARKERS
	 */
	// todo

	/**
	 *	BIG WIN
	 */
	protected async BigWinPrepare(resourceManager: IWriteOnlyResourceManager) {

		// // message
		// for (let i = 0; i < this.wins.length; i++) {
		// 	resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/winmessages/" + this.wins[i].file, ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name), true, LogGroup.Global.Add("WinMsg").Add(this.wins[i].name), true));
		// }

		// fountain
		resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/coin_1_200x200", ResourceIdentifier.Global.Add("fountain").Add("coin"), true, LogGroup.Global.Add("fountain").Add("coin"), true));

	}

	protected async BigWinLoaded(resourceManager: IReadOnlyResourceManager) {

		//await this.winMessageAnimation.ResourcesLoaded(resourceManager);
		//create flag for create ShakeAnimation if you are using FillingPot or not 

		this.shakeAnimation = new ShakeAnimation(this.spinnableReels.GetView());

		this.bigWinCountAnimation = new BigWinCountAnimationPIXIAPP(this.resid, new Size(Scale.W(1920), Scale.H(200)), Scale.fh(150), this.resid.ScopedResourceName("bigwincount"));



		//this.basegameElement.appendChild(this.winMessageAnimation.View());

		// fountain
		//this.fountainAnimation = new FountainAnimation(new Size(1920, 3240), resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("fountain").Add("coin")).sprite, 1.4);

		// this.fountainAnimation.AddOnStartCallback(() => this.audio.PlayLoop(this.resid.ScopedResourceName("fountain")));
		// this.fountainAnimation.AddOnStopCallback(() => this.audio.Stop(this.resid.ScopedResourceName("fountain")));

		// this.basegameElement.appendChild(this.fountainAnimation.View());

		// let fountainAnimation = SlotGameType1Shared.Instance().smallFountainAnimation;
		// fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.resid.ScopedResourceName("fountain")));
		// fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.resid.ScopedResourceName("fountain")));

		// let countView = this.bigWinCountAnimation.View();
		// countView.style.position = "absolute";
		// countView.style.top = Scale.Xpx(500);
		// countView.style.left = Scale.Xpx(0) ;
		// countView.style.pointerEvents = "none";

		//this.basegameElement.appendChild(this.bigWinCountAnimation.View());
	}

	/**
	 *	FEATURES
	 */
	protected async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (this.initData.Feature.includes("ExpandingWildReel")) {

			let params: ExpandingWildsReelParam = {
				resid: this.resid,
				logGroup: this.logGroup,
				resourcesBasePath: this.basepath + "resources/expanding_wild_reel/",
				slotWindow: this.windowRectangle,
				slotWindowSymbolSize: this.spinnableReels.GetWindowSymbolSize(),
				reelSetMapper: this.reelSetMapper,
				audio: this.audio,
				gameName: this.name,
				availableSymbols: this.symbols,
				systemContext: this.systemContext,
				symbolTypeAnim: this.gameConfig.symbolsType
			};

			let config: ExpandingWildReelConfiguration = this.initData.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildReel") as ExpandingWildReelConfiguration;
			let expandingWildsReel: ExpandingWildsReelPIXIAPP = new ExpandingWildsReelPIXIAPP(params, config);

			// TODO must check for other features before continuing
			expandingWildsReel.AddOnCompleteCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinBasegame));

			this.features.set("ExpandingWildReel", expandingWildsReel);
		}

		if (this.initData.Feature.includes("ExpandingWildBulk")) {

			let param: ExpandingWildsBulkParam = {
				resid: this.resid,
				logGroup: this.logGroup,
				resourcesBasePath: this.basepath + "resources/expanding_wild_bulk/",
				slotWindow: this.windowRectangle,
				slotWindowSymbolSize: this.spinnableReels.GetWindowSymbolSize(),
				reelSetMapper: this.reelSetMapper,
				audio: this.audio,
				gameName: this.name,
				availableSymbols: this.symbols,

				systemContext: this.systemContext,
				symbolTypeAnim: this.gameConfig.symbolsType,
			};

			let config: ExpandingWildsBulkConfig = this.initData.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildBulk") as ExpandingWildsBulkConfig;
			let expandingWildsBulk: ExpandingWildsBulkPIXIAPP = this.expandingWildsFactory.CreateExpandingWildsBulkPIXIAPP(param, config);



			// TODO must check for other features before continuing
			expandingWildsBulk.AddOnCompleteCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinBasegame));

			this.features.set("ExpandingWildBulk", expandingWildsBulk);
		}

		if (this.initData.Feature.includes("ScatterRandomAward")) {
			let params: ScatterRandomAwardCreateParams =
			{
				logGroup: this.logGroup,
				resid: this.resid,
				//reelSet: this.reelset,
				availableSymbols: this.symbols,
			};

			const configs = { "ScatterRandomAward": this.initData.FeatureConfigurations.find(f => f && f.FeatureType == "ScatterRandomAward") as ScatterRandomAwardConfiguration };
			this.scatterRandomAwardFeature = new ScatterRandomAwardPIXI(params, configs, this.color);
			//this.features.set("ScatterRandomAward", this.scatterRandomAwardFeature as SlotFeaturePIXI);
			await this.scatterRandomAwardFeature?.PrepareResources(resourceManager);


			this.scatterRandomAwardFeature.UpdateReels({
				reelSet: this.initData.ReelSet,
				playWindow: this.initData.PlayWindow
			});
		}

		// TODO check for unsupported features


		for (let [name, feature] of this.features) {
			await feature.PrepareResources(resourceManager);
		};

	}

	protected async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		for (let [name, feature] of this.features) {
			await feature.ResourcesLoaded(resourceManager);
		};

		await this.scatterRandomAwardFeature?.ResourcesLoaded(resourceManager);
	}

	/**
	 *	BONUSES
	 */
	protected async BonusesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (loadingStage == LoadingStage.GamesConfig || loadingStage == LoadingStage.UniReel) return

		// TODO CONSOLIDATE WITHOUT IFS FOR EACH BONUS!
		if (this.initData.BonusConfiguration) {
			for (let [bonusName, bonus] of Object.entries(this.initData.BonusConfiguration)) {
				let prepareItem = this.bonusLoadSequence.find(s => s.Bonus == bonusName);
				assertNotNullish(prepareItem, `Unknown bonus ${bonusName}`);

				await prepareItem.Prepare?.(loadingStage, resourceManager);
			}
		}
	}

	protected async BonusesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage == LoadingStage.GamesConfig || loadingStage == LoadingStage.UniReel) return
		// TODO CONSOLIDATE WITHOUT IFS FOR EACH BONUS!

		if (this.initData.BonusConfiguration) {
			for (let bonusName of Object.keys(this.initData.BonusConfiguration)) {
				let prepareItem = this.bonusLoadSequence.find(s => Bonus[s.Bonus] == bonusName);
				await prepareItem.Loaded?.(loadingStage, resourceManager);
			}
		}
	}

	// protected DiamondSpinPrepare(resourceManager: IWriteOnlyResourceManager):void 
	// {

	// 	let dsparams: DiamondSpinParams = new DiamondSpinParams(
	// 		this.resid,
	// 		this.logGroup,
	// 		this.screenProtocol,
	// 		this.screenProtocolScope,
	// 		this.basepath + "resources/DiamondSpin/",
	// 		this.commonpath + "resources/DiamondSpin/",
	// 		this.multigameParams.viewSize,
	// 		//this.windowSymbolSize,
	// 		this.windowRectangle,
	// 		<number[][]>this.initData.bonusConfiguration["DiamondSpin"].ReelSet,
	// 		[0, 0, 0,],
	// 		this.panel,
	// 		this.audio,
	// 		this.initData.bonusConfiguration["DiamondSpin"] as DiamondSpinConfiguration,
	// 		this.moneyFormatter,
	// 		this.translator,
	// 		this.initData.slotGameMeta,
	// 	);

	// 	let diamondSpin: SlotBonus = this.diamondSpinFactory.CreateDiamondSpin(this.gameName, dsparams);

	// 	diamondSpin.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
	// 	diamondSpin.SetBonusPanelRequiredCallback((required: boolean) => {
	// 		if (required)
	// 			this.panel.Show();
	// 		else
	// 			this.panel.Hide();
	// 	});


	// 	diamondSpin.PrepareResources(resourceManager);

	// 	this.bonusList.set("DiamondSpin", diamondSpin);
	// }

	// protected DiamondSpinLoaded(resourceManager: IReadOnlyResourceManager): void {


	// 	let diamondSpin = this.bonusList.get("DiamondSpin");
	// 	diamondSpin.ResourcesLoaded(resourceManager);

	// 	let diamondSpinView = diamondSpin.View();
	// 	diamondSpinView.style.width = this.multigameParams.viewSize.width + "px";
	// 	diamondSpinView.style.height = this.multigameParams.viewSize.height + "px";

	// 	this.view.appendChild(diamondSpinView);

	// 	diamondSpin.Hide();
	// }

	protected async FreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (loadingStage == LoadingStage.GamesPreload) {
			const reelSet = this.initData.BonusConfiguration.FreeGameBonus.ReelSet;


			let fgparams: FreegameBonusParams =
			{
				systemContext: this.systemContext,
				resid: this.resid,
				logGroup: this.logGroup,
				screenProtocol: this.screenProtocol,
				screenProtocolScope: this.screenProtocolScope,
				gameResourcesBasePath: this.basepath,
				gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/",
				commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
				screenSize: this.multigameParams.viewSize,
				windowSymbolSize: this.spinnableReels.GetWindowSymbolSize(),
				windowRectangle: this.windowRectangle,
				symbolSpriteAnims: null,
				symbolSpriteAnimsByName: null,
				playlines: this.playlines,
				// reelSet: reelSet,
				startPositions: reelSet.map(r => 0),
				panel: this.panel,
				audio: this.audio,
				// TODO remove
				lines: this.selectedBet.Lines,

				// TODO remove?
				denom: this.selectedBet.Denom.InCents,

				// TODO remove?
				linesPlayed: this.selectedBet.Lines,

				bonusConfiguration: this.initData.BonusConfiguration.FreeGameBonus,
				pickElementFactory: this.freegameBonusFactory,
				clientState: this.clientState,
				translator: this.translator,
				robotPlay: this.robotPlay,
				slotGameMeta: this.initData.Meta,
				slotGameInitData: this.initData,
				slotGame: this,
				availableSymbols: this.symbols,
				availableSymbolsMap: this.symbolsMap,
				jackpotRequired: this.multigameParams.jackpotRequired,
				color: this.color,
				bonusList: this.bonusList,
				pixiSpritesByName: null,
				spinnableReelsParams: this.spinnableReelsParams,
				reelBackgroundTexture: this.reelBackgroundTexture,
				reelBackgroundMaskTexture: this.reelBackgroundMaskTexture,
				colorLineMarkers: this.colorLineMarkers,
				initData: this.initData,
				skinAttachmentFillingPotFeature: this.skinAttachmentFillingPotFeature,
				reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
				winAnimationSpeedFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
				symbolCollection: this.symbolCollection,
				gameConfig: this.gameConfig,
				backendSettings: this.multigameParams.backendSettings,
				uniReelPixiApp: this.uniReel,
			};

			console.log("CreateParamsFG:", fgparams);
			let freegameBonus: FreegameBonusPIXIAPPResponsive = this.freegameBonusFactory.CreateFreegameBonusPIXIAPPResponsive(this.gameName, fgparams);

			// after bonus comes collect
			freegameBonus.SetBonusFinishedCallback(async () => {
				//this.stateMachine.ChangeState(SlotGameState.BigWinTotal);
				await this.OnBonusFinished();
			});

			freegameBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
				this.OnBonusRunFinish(run);
			})
			freegameBonus.SetBonusPanelRequiredCallback((required: boolean) => {
				if (required)
					this.panel.Show();
				else
					this.panel.Hide();
			});

			this.bonusList.set(Bonus.FreeGameBonus, freegameBonus);
		}

		let freegameBonus = this.bonusList.get(Bonus.FreeGameBonus);
		await freegameBonus?.PrepareResources(loadingStage, resourceManager);
	}

	protected async FreegamesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {

		let freegameBonus = this.bonusList.get(Bonus.FreeGameBonus);

		// if (loadingStage == LoadingStage.Games) {
		// 	// let freegameView = freegameBonus.View();
		// 	// SetStyles(freegameView, {
		// 	// 	width: this.multigameParams.viewSize.Width.px(),
		// 	// 	height: this.multigameParams.viewSize.Height.px()
		// 	// });

		// 	// // this.view.appendChild(freegameView);

		// 	// // hide all bonuses by default
		// 	// freegameBonus.Hide();
		// }

		await freegameBonus.ResourcesLoaded(loadingStage, resourceManager);
	}



	protected async SpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.GamesPreload) {
			return;
		}

		let bonusParams: SpinAndHoldParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: null,
			symbolSpriteAnimsByName: null,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,
			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this as unknown as SlotGame,
			color: this.color,
			jackpotEnable: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName: null,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig,
			symbolCollection: this.symbolCollection,
		};

		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.SpinAndHold;

		let spinAndHoldBonus: SlotBonus = this.spinAndHoldBonusFactory.CreateSpinAndHoldBonusPIXIAPPResponsive(this.gameName, bonusParams, bonusConfig) as any as SlotBonus;

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		spinAndHoldBonus.SetBonusFinishedCallback(async () => {
			await this.OnBonusFinished();
		});

		spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.SpinAndHold, spinAndHoldBonus);
	}

	protected async SpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let spinAndHold = this.bonusList.get(Bonus.SpinAndHold);
		await spinAndHold.ResourcesLoaded(loadingStage, resourceManager);

		// let bonusView = spinAndHold.View();
		//NEED QUIT AND CREATE ONE FOR EXTEDEND SPIN & HOLD 
		//bonusView.style.width = this.multigameParams.viewSize.width + "px";
		//bonusView.style.height = this.multigameParams.viewSize.height + "px";			
		// this.view.appendChild(bonusView);

		// hide all bonuses by default
		// spinAndHold.Hide();
	}

	protected async ExtendedSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.GamesPreload) {
			return;
		}

		let bonusParams: SpinAndHoldParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/ExtendedHoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/ExtendedHoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			//windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: null,
			symbolSpriteAnimsByName: null,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,
			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this as unknown as SlotGame,
			color: this.color,
			jackpotEnable: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName: null,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig,
			symbolCollection: this.symbolCollection,
		};

		let bonusConfig: ExtendedSpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.ExtendedSpinAndHold;

		let extendedSpinAndHoldBonus: SlotBonus = this.extendedSpinAndHoldBonusFactory.CreateExtendedSpinAndHoldBonusPIXIAPPResponsive(this.gameName, bonusParams, bonusConfig);

		// after bonus comes collect
		extendedSpinAndHoldBonus.SetBonusFinishedCallback(async () => {
			await this.OnBonusFinished();
		});

		extendedSpinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		extendedSpinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await extendedSpinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.ExtendedSpinAndHold, extendedSpinAndHoldBonus);
	}

	protected async ExtendedSpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let extendedSpinAndHold = this.bonusList.get(Bonus.ExtendedSpinAndHold);
		await extendedSpinAndHold.ResourcesLoaded(loadingStage, resourceManager);

		// let bonusView = extendedSpinAndHold.View();
		// this.view.appendChild(bonusView);

		// hide all bonuses by default
		// extendedSpinAndHold.Hide();
	}


	protected async MultiBonusPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.GamesPreload) {
			return;
		}

		let bonusParams: SpinAndHoldParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/ExtendedHoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/ExtendedHoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: null,
			symbolSpriteAnimsByName: null,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,
			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this as unknown as SlotGame,
			color: this.color,
			jackpotEnable: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName: null,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig,
			symbolCollection: this.symbolCollection
		};

		let bonusConfig: MultiBonusCommonConfiguration = this.initData.BonusConfiguration.MultiBonus;

		let multiBonus: SlotBonus = this.multiBonusFactory.CreateMultiBonusPIXIAPPResponsive(this.gameName, bonusParams, bonusConfig) as any as SlotBonus;

		// after bonus comes collect
		multiBonus.SetBonusFinishedCallback(async () => {
			await this.OnBonusFinished();
		});

		multiBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		multiBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await multiBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.MultiBonus, multiBonus);
	}

	protected async MultiBonusLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let multiBonus = this.bonusList.get(Bonus.MultiBonus);
		await multiBonus.ResourcesLoaded(loadingStage, resourceManager);

		// let bonusView = multiBonus.View();
		// this.view.appendChild(bonusView);

		// hide all bonuses by default
		// multiBonus.Hide();
	}

	protected async BigSymbolSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let bonusParams: SpinAndHoldParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: null,
			symbolSpriteAnimsByName: null,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this as unknown as SlotGame,
			color: this.color,
			jackpotEnable: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName: null,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig,
			symbolCollection: this.symbolCollection,

		};

		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.BigSymbolSpinAndHold;

		let spinAndHoldBonus: SlotBonus = this.bigSymbolSpinAndHoldBonusFactory.CreateBigSymbolSpinAndHoldBonus(this.gameName, bonusParams, bonusConfig) as any as SlotBonus;

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		spinAndHoldBonus.SetBonusFinishedCallback(async () => {
			await this.OnBonusFinished();
		});

		spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolSpinAndHold, spinAndHoldBonus);
	}

	protected async BigSymbolSpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let spinAndHold = this.bonusList.get(Bonus.BigSymbolSpinAndHold);
		await spinAndHold.ResourcesLoaded(loadingStage, resourceManager);

		let bonusView = spinAndHold.View();
		bonusView.style.width = this.multigameParams.viewSize.Width + "px";
		bonusView.style.height = this.multigameParams.viewSize.Height + "px";
		// this.view.appendChild(bonusView);

		// hide all bonuses by default
		// spinAndHold.Hide();
	}

	protected async BigSymbolFreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let bonusParams: BigSymbolFreegamesBonusParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamePath: this.basepath,
			commonPath: this.commonpath,
			screenSize: this.multigameParams.viewSize,
			playWindow: this.windowSymbolSize,
			windowRectangle: this.windowRectangle,
			symbolSpriteAnims: null,
			symbolSpriteAnimsByName: null,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,

			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this as unknown as SlotGame,
			color: this.color,
			jackpotEnable: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			bonusList: this.bonusList,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			winAnimationFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig,
		};

		let bonusConfig: BigSymbolFreegamesCommonConfiguration = this.initData.BonusConfiguration.BigSymbolFreegames;

		let bonus: SlotBonus = this.bigSymbolFreegameBonusFactory.CreateSpinAndHoldBonus(this.gameName, bonusParams, bonusConfig) as unknown as SlotBonus;

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		bonus.SetBonusFinishedCallback(async () => {
			await this.OnBonusFinished();
		});

		bonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		bonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await bonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolFreegames, bonus);
	}

	protected async BigSymbolFreegamesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let bigSymbolFreegameBonus = this.bonusList.get(Bonus.BigSymbolFreegames);
		await bigSymbolFreegameBonus.ResourcesLoaded(loadingStage, resourceManager);

		// let bonusView = bigSymbolFreegameBonus.View();
		// bonusView.style.width = this.multigameParams.viewSize.Width + "px";
		// bonusView.style.height = this.multigameParams.viewSize.Height + "px";
		// this.view.appendChild(bonusView);

		// hide all bonuses by default
		bigSymbolFreegameBonus.Hide();
	}


	protected async PickBonusPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) return;

		let pickBonusparams: PickBonusParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/PickBonus/",
			commonBonusResourcesBasePath: this.commonpath + "resources/PickBonus/",
			bonusConfiguration: this.initData.BonusConfiguration.PickBonus,
			pickElementFactory: this.pickBonusFactory,
			screenSize: this.multigameParams.viewSize,
			panel: this.panel,
			audio: this.audio,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			clientState: this.clientState,
			jackpotRequired: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true)
		};

		//USE FOR 3 SCREEN

		let pickBonus: SlotBonus = this.pickBonusFactory.CreatePickBonus(this.name, pickBonusparams);

		//change state when bonus is finished 
		//after bonus comes collect
		pickBonus.SetBonusFinishedCallback(() => this.OnBonusFinished());
		pickBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await pickBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.PickBonus, pickBonus);
	}

	protected async PickBonusLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		let pickBonus = this.bonusList.get(Bonus.PickBonus);
		await pickBonus.ResourcesLoaded(loadingStage, resourceManager);


		// let pickView = pickBonus.View();
		// pickView.style.width = this.multigameParams.viewSize.Width + "px";
		// pickView.style.height = this.multigameParams.viewSize.Height + "px";

		// this.view.appendChild(pickView);

		// pickBonus.Hide();

	}


	public BonusList(): Map<string, SlotBonus> {
		return this.bonusList;
	}


	/**
	 *	AUDIO
	 */

	protected AudioPrepare(resourceManager: IWriteOnlyResourceManager): void {
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background"), false));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/leverPull" + Settings.audioFormat, this.resid.ScopedResourceName("leverpull")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/anticipation" + Settings.audioFormat, this.resid.ScopedResourceName("anticipation")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/reelSpinStop" + Settings.audioFormat, this.resid.ScopedResourceName("reelstop")));
		this.audio.AddTrack(new Track(this.commonpath + "resources/tracks/scatterReelStop" + Settings.audioFormat, this.resid.ScopedResourceName("scatterstop")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/reelSpinStopBonus" + Settings.audioFormat, this.resid.ScopedResourceName("reelstopbonus")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/expandingWild" + Settings.audioFormat, this.resid.ScopedResourceName("expandingwild")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/waitCollect" + Settings.audioFormat, this.resid.ScopedResourceName("waitcollect")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/collect" + Settings.audioFormat, this.resid.ScopedResourceName("collect")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/lineCount" + Settings.audioFormat, this.resid.ScopedResourceName("linecount"), false));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/lineCountBackground" + Settings.audioFormat, this.resid.ScopedResourceName("lineCountBackground"), false));
		//this.audio.AddTrack(new Track(this.basepath + "resources/tracks/lineCountEnd" + Settings.audioFormat, this.resid.ScopedResourceName("linecountend"),false));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/choosedenomination" + Settings.audioFormat, this.resid.ScopedResourceName("denom")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/cashin" + Settings.audioFormat, this.resid.ScopedResourceName("cashin")));
		//this.audio.AddTrack(new Track(this.basepath + "resources/tracks/reellost" + Settings.audioFormat, this.resid.ScopedResourceName("reellost")));

		// only when pickbonus
		//this.audio.AddTrack(new Track(this.basepath + "resources/tracks/pickbonus" + Settings.audioFormat, this.resid.ScopedResourceName("pickbonus")));
		//this.audio.AddTrack(new Track(this.commonpath + "resources/tracks/transition" + Settings.audioFormat, "transition"));

		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/fountain" + Settings.audioFormat, this.resid.ScopedResourceName("fountain")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/winMessage" + Settings.audioFormat, this.resid.ScopedResourceName("bigwin")));
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/notcredit" + Settings.audioFormat, this.resid.ScopedResourceName("notcredit")));


		for (let i = 0; i < this.wins.length; i++) {
			this.audio.AddTrack(new Track(this.commonpath + "resources/voice/" + this.wins[i].name + Settings.audioFormat, this.resid.ScopedResourceName(this.wins[i].name)));
		}
		// hand over all tracks to resource manager
		//resourceManager.Add(this.audio.GetResources());
	}

	protected AudioLoaded(resourceManager: IReadOnlyResourceManager): void {

	}

	protected PresentationPrepare(resourceManager: IWriteOnlyResourceManager): void {
		//this.audio.AddTrack(new Track(this.basepath + "resources/tracks/presentation" + Settings.audioFormat, this.resid.ScopedResourceName("presentation")));
	}

	protected PresentationLoaded(resourceManager: IReadOnlyResourceManager): void {
		//this.presentation = new GamePresentation(this.logGroup, this.audio.Track(this.resid.ScopedResourceName("presentation")));
	}

	/**
	 *	INTERACTION
	 */

	protected turboSpin: boolean = false;
	protected turboSpinStartTimeout: ITimeout = null;

	protected TurboSpinPrepare(resourceManager: IWriteOnlyResourceManager): void {
		if (this.multigameParams.backendSettings.GetBool("play.turbo", false)) {
			this.turboSpinStartTimeout = this.systemContext.TimingContext().CreateTimeout("turboSpinStart", 3000, () => {
				this.TurboSpinStart();
			});
		}
	}

	protected TurboSpinLoaded(resourceManager: IReadOnlyResourceManager): void {

	}

	public TurboSpinStart(): void {
		if (this.multigameParams.backendSettings.GetBool("play.turbo", false)) {
			// Log.Debug("TURBOSPIN", "TurboSpinStart()");
			this.turboSpin = true;

			this.panel.SpinButtonLabelChange(this.translator.t.turbo);
			this.panel.TurboEnabled();
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.Spin();

		}
	}

	public TurboSpinStop(): void {
		if (this.multigameParams.backendSettings.GetBool("play.turbo", false)) {
			// Log.Debug("TURBOSPIN", "TurboSpinStop()");

			this.turboSpinStartTimeout.Stop();


			if (this.turboSpin) {
				this.panel.SpinButtonLabelChange(this.translator.t.spin);
				this.panel.TurboDisabled();
			}
			this.turboSpin = false;
		}
	}

	public SpinButton(pressed: boolean): void {
		// disable autoplay if enabled
		if (this.stateMachine.State() != SlotGameState.Bonus && this.autoPlay) {
			this.AutoplayDisable();
			this.TurboSpinStop();
		}

		if (this.autoPlay || this.turboSpin) {
			this.AutoplayDisable();
			this.TurboSpinStop();
		}
		else {
			if (pressed) {
				if (this.turboSpin) {
					this.TurboSpinStop();
				}
				// not starting turbo during bonus
				else if (this.stateMachine.State() != SlotGameState.Bonus) {
					if (this.multigameParams.backendSettings.GetBool("play.turbo", false)) {
						// Log.Debug("TURBOSPIN", "StartTimer()");
						this.turboSpinStartTimeout.Restart();
					}
				}

				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				this.Spin();
			}
			else {
				this.TurboSpinStop();
			}
		}
	}
	public SettingsButton(pressed: boolean) {

	}

	//protected betRequest: BetRequest = null;
	protected get bet(): SlotGameBet {
		return this.initData.EnabledBets[this.selectedBetIndex.Index].Bet;
	}
	//protected totalBetCents: number = 0;


	public async Spin() {

		//// Log.Debug(this.logGroup,);
		//console.log("SPIIIIIIIIN, current state: " + this.stateMachine.State())

		switch (this.stateMachine.State()) {
			case SlotGameState.Idle:
				if (this.selectedBet.TotalBetCents.InCents > this.clientState.Balance()) {
					// not enough credit
					this.panel.SetMessage(this.translator.t.notcredit);
					this.audio.Play(this.resid.ScopedResourceName("notcredit"), false);
					if (this.popUpMenuAnim.CheckPopUpVisibility()) {
						this.popUpMenuAnim.HidePopUp();
					}
					break;
				}

				if (this.denomMenu.IsLocked()) {
					// denom menu on
					break;
				}

				if (this.help.IsStarted()) {
					// help is on
					break;
				}
				if (this.popUpMenuAnim.CheckPopUpVisibility()) {
					this.popUpMenuAnim.HidePopUp();
					break;
				}


				if (this.jackpotSharedShow?.isVisible() == true && this.robotPlay.IsEnabled() == false) {
					break;
				}

				if (this.buyBonusMenu.Visible()) {
					return;
				}

				{
					// Log.Debug(this.logGroup, "Spin");

					// reset whatever needs resettings
					this.lastSpinResult = null;
					//this.canCollectReceived = false;
					this.currentBonus = null;
					this.onSimpleNextBonusAction = null;
					this.bonusStartConfig = null;
					this.runingBonuses = [];
					this.lastSpinAction = null;
					this.EnableCache = true;


					this.stateMachine.ChangeState(SlotGameState.WaitGameStart);
					this.screenProtocol?.Send(new JackpotValuesPause(), this.screenProtocolScope);

					// eslint-disable-next-line @typescript-eslint/no-floating-promises
					this.ActualSpin(this.selectedBetIndex);
				}
				break;

			case SlotGameState.WaitGameStart:
				this.spinAnimation.RequestStop(-1);
				break;

			case SlotGameState.Spin:
				this.spinAnimation.RequestStop(-1);
				break;

			case SlotGameState.Win:
				if (!this.winMessageAnimation?.IsRunning() || this.stateMachine.TimeSinceLastStateChange() > 500) {
					this.StartAnimWinLinesBackgroundFadeOut();
					this.winLinesAnimation?.RequestStop();
					this.winCreditAnimation?.progress(1, false);
					//this.audio.Stop(this.resid.ScopedResourceName("lineCountBackground"));	

					if (!this.robotPlay.IsEnabled()) {
						this.autoPlaySkipWinLines = true;
					}
				}
				break;

			case SlotGameState.Scatter:
				// Log.Debug(this.logGroup, "Spin: Request Scatter stop");
				//this.EnableCache = true;
				// if (this.winCreditAnimation != null && this.winCreditAnimation.progress() != 1) {
				// 	this.winCreditAnimation.progress(1, false);
				// 	//this.RequestFeatureStop();
				// }	
				//this.RequestFeatureStop();			

				break;

			case SlotGameState.Features:
				// stop features
				//commented you cant jupm wild feature some times works like stacked 
				// // Log.Debug(this.logGroup, "Spin: Request features stop");
				// if(this.stateMachine.LastStateChange()>1000 || this.stateMachine.IsState()){
				// 	this.RequestFeatureStop();
				// }
				break;

			case SlotGameState.BonusTrigger:
				// stop features
				// Log.Debug(this.logGroup, "Spin: Request trigger stop");
				//if (this.stateMachine.IsState(SlotGameState.BonusTrigger)) {											
				//	this.stateMachine.ChangeState(SlotGameState.BigWin);
				//}
				break;

			case SlotGameState.WaitCollect:
				// Log.Debug(this.logGroup, "Spin: Waiting for collect");
				// if (this.lastSpinResult?.CanCollect)
				// {
				// 	if (this.lastSpinResult.
				// 		this.canCollect)
				// 	{
				// 		// Log.Debug(this.logGroup, "CanCollect is false, can't collect at the moment?");
				// 	}
				// 	else
				// 	{
				// 		this.stateMachine.ChangeState(SlotGameState.Collect);
				// 	}
				// }
				// else
				// {
				// 	// Log.Debug(this.logGroup, "CanCollect not received!");
				// }
				break;

			case SlotGameState.Collect:
				// Log.Debug(this.logGroup, "Spin: Collecting");
				break;

			case SlotGameState.Bonus:
				if (this.currentBonus != null) {
					this.currentBonus.Spin();
				}
				break;

			default:
				// Log.Debug(this.logGroup, "Spin button not functional");
				break;
		}

		// Log.Debug(this.logGroup, "SPIIIIIIIIN, new state: " + SlotGameState[this.stateMachine.State()]);
	}

	public async ActualSpin(betIndex: BetRequest) {

		this.gameStartTimeout.Start();
		let spinSuccess: SpinSuccess = null;
		let startTime = now();

		//let info = new SelectedBetInfo(betIndex, this.betType);

		try {
			spinSuccess = await service.api?.slot_Spin(this.gameName, betIndex);
			// this.betType = BetType.Normal;
		}
		catch (ex) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			await service.api.frontendError(FrontendErrorCode.FrontendSpinError, `Exception while waiting for spin: ${ex.toString()}`);
		}

		this.gameStartTimeout.Stop();
		let endTime = now();

		if (spinSuccess?.Success &&
			this.stateMachine.State() != SlotGameState.WaitGameStart) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			await service.api.frontendError(FrontendErrorCode.FrontendSpinError, `Received spin, but after timeout of ${this.gameStartTimeout.GetTimeout()}ms, took ${endTime - startTime}ms`);

			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.SpinError("Game took too long", spinSuccess);
			return;
		}

		if (!spinSuccess) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			await service.api.frontendError(FrontendErrorCode.FrontendSpinError, `Did not receive spin`);

			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.SpinError("Game not available", spinSuccess);
			return;
		}

		if (!spinSuccess?.Success) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises


			// service.api.frontendError(FrontendErrorCode.FrontendSpinError, `Error while receiving spin, error message: ${spinSuccess?.Message ?? ""}`);

			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.SpinError("Game not available", spinSuccess);
			return;
		}

		// finally all good
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		await this.SpinSuccess(spinSuccess.GameState);
		spinSuccess = null;
	}

	public async SpinSuccess(gameState: SimpleSlotGameState) {
		// Log.Debug(this.logGroup, `SpinSuccess()`);
		if (!this.stateMachine.IsState(SlotGameState.WaitGameStart)) {
			// Log.Debug(this.logGroup, `SpinSuccess() Too late, already past this`);
			return;
		}

		this.stateMachine.ChangeState(SlotGameState.Spin, null, ChangeStateType.NextTask);
		//this.spinAnimation.Start();

		await NextTaskAsync(() => {

			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.OnSpinResult(gameState)
			gameState = null;
		});
		//console.log("ApiResultPlayed", gameState);							
		this.robotPlay.GameSpinAccepted();
	}

	public async SpinError(message: string, spinResponse?: SpinSuccess) {
		// Log.Debug(this.logGroup, `SpinError() Error spinning state: ${this.stateMachine.State()}, message ${message}`);

		this.TurboSpinStop();
		this.AutoplayDisable();
		this.clientState.CancelGame();
		this.spinAnimation.Cancel();

		if (!this.stateMachine.IsState(SlotGameState.WaitGameStart)) {
			// Log.Debug(this.logGroup, `SpinError() Alredy moved past this error`);
			return;
		}



		if (spinResponse?.Balance?.InCents !== undefined) {
			this.clientState.UpdateBalance(spinResponse.Balance.InCents);
			spinResponse = null;
		}

		this.audio.Stop(this.resid.ScopedResourceName("leverpull"));

		this.UpdatePanel();

		this.panel.SetMessage(message);



		this.AutoplayDisable();
		this.TurboSpinStop();

		this.stateMachine.ChangeState(SlotGameState.GameFinished);
	}


	public MaxBet(): void {
		if (!this.stateMachine.IsState(SlotGameState.Idle)) {
			return;
		}

		// find max bet for selected denomination!
		let betsCurrentDenom = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == this.selectedBet.Denom.InCents);

		// find biggest bet
		let maxBet = betsCurrentDenom.reduce((max, curr) => curr.Bet.TotalBetCents.InCents > max.Bet.TotalBetCents.InCents ? curr : max, this.selectedBetConfig);
		let maxBetIndex = this.initData.EnabledBets.indexOf(maxBet);

		// select maximum possible bet per line
		if (maxBet.Bet.TotalBetCents.InCents <= this.clientState.Balance()) {

			// Log.Debug(this.logGroup, "Max Bet");

			if (maxBetIndex != this.selectedBetIndex.Index) {
				this.SelectBet2(maxBetIndex);
			}
			else {
				// already selected
			}

			this.SpinButton(true);
			this.SpinButton(false);
		}
		else {
			// Log.Debug(this.logGroup, "Not enough money");

			// try selecting max bet that player can play
			if (this.SelectMaxPossibleBet()) {
				this.SpinButton(true);
				this.SpinButton(false);
			}
			else {
				// nothing enough credit for smallest bet?
			}
		}
	}

	public SelectMaxPossibleBet(): boolean {
		let betsCurrentDenom = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == this.selectedBet.Denom.InCents);

		let playerAvailableBets = betsCurrentDenom.filter(b => b.Bet.TotalBetCents.InCents <= this.clientState.Balance());
		let maxPlayerBet = playerAvailableBets.reduce((max, curr) => curr.Bet.TotalBetCents.InCents > max.Bet.TotalBetCents.InCents ? curr : max, this.initData.EnabledBets[this.selectedBetIndex.Index]);
		if (!maxPlayerBet) {
			return false;
		}

		let maxPlayerBetIndex = this.initData.EnabledBets.indexOf(maxPlayerBet);
		if (maxPlayerBetIndex != this.selectedBetIndex.Index) {

			this.SelectBet2(maxPlayerBetIndex);
		}


		return true;
	}

	public AutoplayToggle(): void {
		if (this.stateMachine.State() != SlotGameState.Bonus) {
			if (!this.autoPlay && this.stateMachine.State() == SlotGameState.Idle) {
				this.AutoplayEnable();
			}
			else {
				this.AutoplayDisable();

			}
		}
		else {
			// Log.Debug(this.logGroup, `AutoPlay pressed, state not idle: ${this.stateMachine.State()}`);
		}
	}

	public AutoplayEnable(): void {

		this.autoPlay = true;
		//// Log.Debug("Auto Play", "Starting Auto play");
		if (this.stateMachine.State() == SlotGameState.Idle) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.Spin();
		}

		this.panel?.AutoplayEnable();
	}

	public AutoplayDisable(): void {

		this.autoPlay = false;
		this.autoPlayTimer.Stop();
		this.panel?.AutoplayDisable();
	}

	// public AutoplayDisable(): void
	// {
	// 	this.CancelAutoPlay();
	// 	this.panel.AutoplayDisable();
	// 	this.autoPlay = false;
	// }
	protected showDenomMenu = true;
	public ShowAvailableDenoms(): void {
		if (!this.stateMachine.IsState(SlotGameState.Idle)) {
			return;
		}


		if (!this.showDenomMenu) {
			return;
		}

		this.GameStateChanged?.(GameState.InGame);
		if (Settings.MenuType != MenuType.DummyMenu && this.availableDenoms.length > 1) {
			this.denomMenu.Show();

		}
		else {
			if (Settings.MenuType == MenuType.DummyMenu && this.availableDenoms.length > 1) {
				this.denomMenu.Show();
			}
			else {
				this.denomMenu.AutoDenom();
				//
				this.UpdateDenom?.(this.initData.EnabledBets, this.selectedBet.Denom.InCents);

				if (this.GameStateChanged != null) {
					this.timeoutGameState.Start();
					// setTimeout(() => {							
					// 	this.GameStateChanged(GameState.ReadyToPlay);
					// }, 1000);						
				}
			}
		}
	}


	public GamesMenu(): void {

		Log.Debug(this.logGroup, "GamesMenu()");
		if (Settings.MenuType == MenuType.DummyMenu) {
			Log.Debug(this.logGroup, "Dummy menu, not in use");
			return;
		}

		if (!this.stateMachine.IsState(SlotGameState.Idle)) {
			// not idle, can't go to games menu
			return;
		}

		this.stateMachine.ChangeState(SlotGameState.Exit);
		void service.api?.gameExit();

		if (this.robotPlay.IsEnabled()) {
			this.robotPlay.OnGameExit();
		}
	}


	public Help(): void {
		if (!this.stateMachine.IsState(SlotGameState.Idle)) return
		this.help.Start();
		this.Show(this.help.View());
		this.help.View().style.position = "";
		this.helpResponsiveContainer.style.display = "flex";
		this.popUpMenuAnim.HidePopUp();
	}

	// public Payout(): void {

	// 	//this.payoutMenu.Show();
	// 	if (!this.stateMachine.IsState(SlotGameState.Idle)){
	// 		protocol.Send("Payout", null);
	// 	}
	// 	else {
	// 		// Log.Debug(this.logGroup, "Payout pressed, state not idle");
	// 	}
	// }

	// public SelectLine(lineIndex: number): void 
	// {
	// 	if (this.stateMachine.State() == SlotGameState.Idle || this.stateMachine.State() == SlotGameState.Loading) {


	// 		this.selectedLineIndex = lineIndex;
	// 		//this.lineMessageLeft.Update();
	// 		//this.lineMessageLeft.Update();

	// 		this.UpdatePanel();

	// 	}
	// 	// dot not allow changing line message when not idle
	// 	else
	// 	{
	// 		;
	// 		Log.Error(this.logGroup, "Got SelectLine(), but not in Idle or Loading state");
	// 	}
	// }

	// public GetSelectedLineIndex():number{
	// 	return this.selectedLineIndex;
	// }

	// public SelectDenom(denomIndex: number)
	// {
	// 	//;
	// 	if (!this.stateMachine.IsState(SlotGameState.Idle)){
	// 		this.selectedDenomIndex = denomIndex;
	// 		this.panel.SetDenom(this.moneyFormatter.FormatCurrency(Math.round(this.denoms[this.selectedDenomIndex] * 100)));
	// 		this.moneyFormatter.SetDenom(this.denoms[this.selectedDenomIndex]);
	// 		this.UpdatePanel();

	// 		this.screenProtocol?.Send(new SlotGameMessages.DenomChange(this.moneyFormatter.GetDenom(), this.moneyFormatter.GetLocality()), this.screenProtocolScope);

	// 		this.audio.Play(this.resid.ScopedResourceName("denom"));
	// 		this.denomMenu.Hide();

	// 		this.robotPlay.OnDenomSelected(this.denoms[this.selectedDenomIndex] * 100);
	// 	}
	// }

	// public GetSlectedDenomIndex():number
	// {
	// 	return this.selectedDenomIndex;
	// }

	// public GetSelectedTotalBet(): number
	// {
	// 	let betCredits = this.bets[this.selectedBetIndex];
	// 	//let betCents: number = Math.round(betCredits * this.denoms[this.selectedDenomIndex] * 100);

	// 	let betTotalCredit: number = betCredits * this.lines[this.selectedLineIndex];
	// 	let betTotalCents: number = Math.round(betTotalCredit * this.denoms[this.selectedDenomIndex] * 100);

	// 	return betTotalCents;

	// }


	// public SelectBet(betIndex:number): void{
	// 	if (!this.stateMachine.IsState(SlotGameState.Idle)){
	// 		if(betIndex >= 0 &&  betIndex < this.bets.length)
	// 		{
	// 			this.selectedBetIndex = betIndex;
	// 			this.UpdatePanel();
	// 		}
	// 	}
	// }

	public BetUp() {
		if (!this.stateMachine.IsState(SlotGameState.Idle)) {

			// denom must not change!
			// can select next bet in the same denom!

			let betsThisDenom: BetConfig[] = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == this.selectedBet.Denom.InCents);
			let indexOfBet = betsThisDenom.indexOf(this.selectedBetConfig);

			if (indexOfBet == -1) throw "Current bet not found?";

			if (indexOfBet + 1 >= betsThisDenom.length) {
				// already max bet
				return
			}

			let d_indexOfNextBet = indexOfBet + 1; //(indexOfBet +1) % betsThisDenom.length;


			let nextBet = betsThisDenom[d_indexOfNextBet];
			let indexOfNextBet = this.initData.EnabledBets.indexOf(nextBet);

			this.SelectBet2(indexOfNextBet);
		}
	}

	public BetDown() {
		if (!this.stateMachine.IsState(SlotGameState.Idle)) {

			// denom must not change!
			// can select next bet in the same denom!
			let betsThisDenom = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == this.selectedBet.Denom.InCents);
			let indexOfBet = betsThisDenom.indexOf(this.selectedBetConfig);

			if (indexOfBet == -1) throw "Current bet not found?";

			if (indexOfBet - 1 < 0) {
				// already min bet
				return;
			}

			let d_indexOfNextBet = indexOfBet - 1; //mod(indexOfBet -1, betsThisDenom.length);


			let nextBet = betsThisDenom[d_indexOfNextBet];
			let indexOfNextBet = this.initData.EnabledBets.indexOf(nextBet);

			this.SelectBet2(indexOfNextBet);
		}
	}

	public NextBet() {
		if (!this.stateMachine.IsState(SlotGameState.Idle)) {
			return;
		}

		// denom must not change!
		// can select next bet in the same denom!

		let betsThisDenom = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == this.selectedBet.Denom.InCents);
		let indexOfBet = betsThisDenom.indexOf(this.selectedBetConfig);

		if (indexOfBet == -1) throw "Current bet not found?";

		let d_indexOfNextBet = (indexOfBet + 1) % betsThisDenom.length;


		let nextBet = betsThisDenom[d_indexOfNextBet];

		if (nextBet.BuyBonusEnabled == false && this.selectedBetIndex.Type == BetType.BuyBonus) {
			this.selectedBetIndex = {
				Index: this.selectedBetIndex.Index,
				Type: BetType.Normal
			};
		}

		let indexOfNextBet = this.initData.EnabledBets.indexOf(nextBet);

		this.SelectBet2(indexOfNextBet);
	}

	// return true if bet changed
	public SelectBet2(betIndex: number, force: boolean = false): boolean {
		if (betIndex < 0 || betIndex >= this.initData.EnabledBets.length) {
			throw `Tried to select bet ${betIndex}, can select bets between 0 and ${this.initData.EnabledBets.length}`
		}

		if (!this.stateMachine.IsState(SlotGameState.Idle) &&
			!this.stateMachine.IsState(SlotGameState.Loading) &&
			!this.stateMachine.IsState(SlotGameState.Exit)
		) {
			return false;
		}


		// Log.Debug(this.logGroup, "Changing bet from " + this.selectedBetIndex + " to " + betIndex, this.selectedBet, this.initData.EnabledBets[betIndex]);

		const didBetChange: boolean = this.selectedBetIndex.Index != betIndex;

		this.selectedBetIndex = {
			Index: betIndex,
			Type: BetType.Normal
		};

		service.moneyFormatter.SetDenom(this.selectedBet.Denom.InCents);
		this.UpdatePanel();

		this.robotPlay.OnBetSelected();
		this.denomMenu.Hide();

		// tried to change bet while in game
		this.OnBetSelect?.(this.selectedBet);

		if (didBetChange || force) {
			this.fillingPotFeature?.SetBet(this.selectedBet);
			this.bonusMultiplier?.SetBet(this.selectedBet);
		}

		return didBetChange;
	}

	public CancelTypeChange() {
		this.buyBonusMenu.Hide();
	}

	public BetTypeChange() {
		this.buyBonusMenu.Hide();

		if (this.selectedBetIndex.Type == BetType.Normal) {
			this.selectedBetIndex = {
				Index: this.selectedBetIndex.Index,
				Type: BetType.BuyBonus
			};

			this.UpdatePanel();
		}

		void this.Spin();
	}

	// public VerifyBetTypeChange()
	// {
	// 	if (this.betTypeChangeMenu.Visible())
	// 	{

	// 	}
	// 	else if (this.stateMachine.State() == SlotGameState.Idle)
	// 	{
	// 		if (this.betType == BetType.Normal)
	// 		{
	// 			this.betTypeChangeMenu.Show();
	// 		}
	// 		else
	// 		{
	// 			this.ChangeBetType();
	// 		}
	// 	}
	// }

	public ChangeBetType() {
		if (this.stateMachine.State() == SlotGameState.Idle) {
			if (this.selectedBetConfig.BuyBonusEnabled == null) {
				console.log("Selected bet doesn't have BuyBonus feature.")
				return;
			}

			if (this.selectedBetIndex.Type == BetType.Normal) {
				this.selectedBetIndex = {
					Index: this.selectedBetIndex.Index,
					Type: BetType.BuyBonus
				};
			}

			else if (this.selectedBetIndex.Type == BetType.BuyBonus) {
				this.selectedBetIndex = {
					Index: this.selectedBetIndex.Index,
					Type: BetType.Normal
				};
			}

			this.UpdatePanel();
		}
	}

	public VerifyBetTypeChange() {
		if (this.selectedBetConfig.BuyBonusEnabled == false) {
			return;
		}
		if (this.buyBonusMenu.Visible()) {
			return;
		}
		if (this.stateMachine.State() != SlotGameState.Idle) {
			return;
		}
		// if (this.selectedBet.BuyBonus1 == null) {
		// 	console.log("Selected bet doesn't have BuyBonus feature.")
		// 	return;
		// }
		if (this.selectedBetIndex.Type == BetType.Normal) {
			this.buyBonusMenu.BuyBonusPriceString(service.moneyFormatter.FormatCurrency(this.selectedBet.TotalBetCents), service.moneyFormatter.FormatCurrency(this.selectedBet.BuyBonusCents), service.moneyFormatter.FormatQuantity(this.selectedBet.BuyBonusCredits));
			this.buyBonusMenu.Show();
		}
		else if (this.selectedBetIndex.Type == BetType.BuyBonus) {
			this.selectedBetIndex = {
				Index: this.selectedBetIndex.Index,
				Type: BetType.Normal
			};
		}
		this.UpdatePanel();
	}

	public SelectMinimumBet() {
		// find min denom


		//for (let b of this.initData.EnabledBets)

		let minDenom = 0;
		let minBet = 0;

		for (let i = 1; i < (this.initData.EnabledBets?.length ?? 0); i++) {
			// first by min denom
			if (this.initData.EnabledBets[i].Bet.Denom.InCents < this.initData.EnabledBets[minDenom].Bet.Denom.InCents) {
				minDenom = i;
				minBet = i;
			}

			// second by total bet
			if (this.initData.EnabledBets[i].Bet.TotalBetCredits < this.initData.EnabledBets[minDenom].Bet.TotalBetCredits) {
				minBet = i;
			}
		}

		this.UpdateDenom?.(this.initData.EnabledBets, this.initData.EnabledBets[minBet].Bet.Denom.InCents);
		this.GameStateChanged(GameState.ReadyToPlay);
		this.SelectBet2(minBet, true);
	}

	public override GetMinimumBet(): Money {
		let minimumBet = this.initData.EnabledBets.map(b => b.Bet.TotalBetCents).reduce((prev: Money, curr: Money) => {
			if (!prev || curr.InCents < prev.InCents) return curr;
			return prev;
		}, undefined);

		return minimumBet;
	}

	protected UpdatePanel() {
		let balanceCents = this.clientState.Balance();
		this.panel.SetBalance(service.moneyFormatter.FormatCreditCurrentDenom(balanceCents), service.moneyFormatter.FormatCurrency(balanceCents));
		this.buyBonusMenu.UpdateBalance(balanceCents);
		// this.panel.ChangeBetTypeValueString(this.betType.toString());

		if (!this.stateMachine.IsState(SlotGameState.Idle) &&
			!this.stateMachine.IsState(SlotGameState.Loading) &&
			!this.stateMachine.IsState(SlotGameState.Exit)
		) {
			return;
		}

		this.panel.SetLines(this.selectedBet.Lines);

		const betConfig = this.initData.EnabledBets[this.selectedBetIndex.Index];
		const canBuyBonus = betConfig.BuyBonusEnabled && (this.selectedBet.BuyBonusCents?.InCents ?? 0) > 0;

		if (canBuyBonus) {
			this.buyBonusMenu.Enabled(true);
			this.buyBonusMenu.UpdateBet(betConfig.Bet.BuyBonusCents.InCents);
		}
		else {
			this.buyBonusMenu.Enabled(false);
		}

		//this.panel.SetBet(service.moneyFormatter.FormatCreditCurrentDenom(this.selectedBet.BetPerLineCents), service.moneyFormatter.FormatCurrency(this.selectedBet.BetPerLineCents));
		this.panel.SetDenom(service.moneyFormatter.FormatCurrency(this.selectedBet.Denom));
		//this.panel.ChangeTotalBet(service.moneyFormatter.FormatCreditCurrentDenom(this.selectedBet.TotalBetCents), service.moneyFormatter.FormatCurrency(this.selectedBet.TotalBetCents));
		this.popUpMenuAnim.SetDenom(service.moneyFormatter.FormatCurrency(this.selectedBet.Denom));

		this.panel.ChangeTotalBet(
			service.moneyFormatter.FormatCreditCurrentDenom(this.selectedBet.TotalBetCents),
			service.moneyFormatter.FormatCurrency(this.selectedBet.TotalBetCents),
			this.selectedBet.TotalBetCents
		);

		this.help.UpdateBet(this.selectedBet.TotalBetCents.InCents, this.selectedBet.Denom.InCents, this.selectedBet.Lines);

		let betChangedMessage = new SlotGameMessages.BetChange(this.selectedBet.TotalBetCredits);
		this.helpPaytable?.UpdatePayTable(betChangedMessage);
		this.payTable?.SetBet(betChangedMessage);
		this.screenProtocol?.Send(betChangedMessage, this.screenProtocolScope);

		void service.api?.betChanged(this.selectedBetIndex.Index);
		this.OnBetChanged?.(this.selectedBetIndex.Index);

		//this.scatterRandomAwardFeature.UpdateBet(this.selectedBet.TotalBetCents.InCents);

		this.changeBetUpdateDelay.Restart();



		this.scatterRandomAwardFeature?.UpdateBet(this.selectedBet);

		this.forceSymbolsUpdate = true;
	}


	public GameSelected(): void {

		assertTrue(this.stateMachine.IsState(SlotGameState.Idle) || this.stateMachine.IsState(SlotGameState.Exit), "Game selected, but not in Idle or Exit state");
		if (!(this.stateMachine.IsState(SlotGameState.Idle) || this.stateMachine.IsState(SlotGameState.Exit))) {
			return;
		}

		this.gameSelected = true;
		this.panel.SetMessage(this.clientState.Balance() <= 0 ? this.translator.t.message_insertcredit : this.translator.t.message_pressspin);
		this.panel.SpinButtonLabelChange(this.translator.t.spin);
		this.UpdatePanel();

		// ChangeSpeedFactor(this.speedManager.GetDefaultCelebrationType());	
		// this.symbolCollection.SetSymbolAnimationSpeed(ChangeSpeedSpine(this.speedManager.GetDefaultCelebrationType()));


		this.doubleUpView?.Create();
		//this.bonusList.forEach((bonus) => bonus.GameSelected());

		//if (Settings.fillingPotFeature == FillingPotFeature.Disable){	
		this.gameViewAppPixi?.Create();

		this.ShowGame()

		//SEND INFO FOR ARDUINO
		this.ScreenLedColor(this.ColorLed);
		this.audio.PlayOrContinueLoop(this.resid.ScopedResourceName("background"));
		this.GameStateChanged?.(GameState.InGame);

		//Show denom when you enter game 
		//only show if you have 2 denom for select 
		//if not are some auto select.
		//always need change denom because not are the same for all games 

		if (this.stateMachine.IsState(SlotGameState.Exit)) {
			this.stateMachine.ChangeState(SlotGameState.Idle)
		}

		this.showDenomMenu = true;
		this.ShowAvailableDenoms();
	}

	private ScreenLedColor(RGB: string) {
		//SEND INFO FOR ARDUINO
		//THE COLOR ARE IN RGB
		void service.api?.sendScreenLeds(RGB);
	}

	protected ShowGame(): void {

		//console.log(`GameConfig-${this.gameName}:`,this.gameConfig);	

		if (this.popUpMenuAnim.CheckPopUpVisibility()) {
			this.popUpMenuAnim.HidePopUp();
		}
		this.panel.SetBalance(service.moneyFormatter.FormatCreditCurrentDenom(this.clientState.Balance()), service.moneyFormatter.FormatCurrency(this.clientState.Balance()));
		this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(0), service.moneyFormatter.FormatCurrency(0));
		this.SelectMinimumBet(); // select min bet

		//this.audio.PlayOrContinueLoop(this.resid.ScopedResourceName("background"));

		this.panel.SetMessage(this.clientState.Balance() <= 0 ? this.translator.t.message_insertcredit : this.translator.t.message_pressspin);



		this.panel.Start();

		service.iomanager.EnableAllButtons([
			//{button: Button.ButtonSpin, light: OutputState.Blinking1}
		]);
	}

	public GameExit() {
		this.gameSelected = false;
		this.audio.StopAll();
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.panel.Stop();
		this.GameStateChanged?.(GameState.SelectGame);

		// this.Destroy();

	}

	public override Destroy() {
		// cleanup caches
		//this.symbolCache.Clear();		
		this.gameViewAppPixi?.Destroy();
		// if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
		// 	this.spinnableReels.Destroy();
		// } else {
		// 	this.fillingPotFeature?.Destroy();
		// }
		this.doubleUpView?.Destroy();
		//this.bonusList.forEach((bonus) => bonus.GameExit());
		this.lastSpinResult = null;
		//this.fillingPotFeature?.StopAnim();
		this.symbolCollection?.DestroyAllSymbols();
	}


	/********************
	 *	INTERNAL STATES * 
	 ********************/
	protected updateInterval: IInterval = null;

	public OnIdleBegin() {

		// only start when game is real, not demo
		if (this.multigameParams.loadRequest.IsReal)
		{
			this.updateInterval.Start();
		}

		if (!this.gameSelected) {
			// game not selected yet,
			return;
		}


		globalThis.jackpotDisplayGlobalResponsive?.Resume();
		this.panelWinLabel?.Update();
		//this.lastSpinResult = null;
		this.bonusStartConfig = null;
		//this.symbolsAnimation.Stop();
		this.spinnableReels.StopSymbolsAnim();

		this.selectedBetIndex = {
			Index: this.selectedBetIndex.Index,
			Type: BetType.Normal
		};


		this.UpdatePanel();
		//this.UpdatePanel();


		if (this.turboSpin) {
			this.panel.SpinButtonLabelChange(this.translator.t.turbo);
		}
		else {
			this.panel.SpinButtonLabelChange(this.translator.t.spin);
		}


		this.panel.SetMessage(this.clientState.Balance() <= 0 ? this.translator.t.message_insertcredit : this.translator.t.message_pressspin);
		this.panel.OnIdleBegin();
		// protocol.Send("SpinEnd", null);

		// does callback prevent another spin?
		if (this.GameEndedCallback &&
			!this.GameEndedCallback()) {
			// need to stop autoplay
			this.AutoplayDisable();
		}

		if (this.turboSpin) {
			void this.Spin();
		}

		if (this.autoPlay) {
			this.autoPlayTimer.Restart();
		}

		let canPlayDoubleUp = this.doubleUpView && this.lastSpinResult?.TotalWin.TotalWin.InCents > 0;
		this.robotPlay?.GameFinished(canPlayDoubleUp);
		if (canPlayDoubleUp) {
			service.iomanager.SetLights([
				{ light: Light.LightButtonDoubleUp, state: OutputState.Blinking1 }
			]);
		}

		// if (this.robotPlay.IsEnabled() && this.lastSpinResult.TotalWin.TotalWin.InCents > 0)
		// {
		// 	this.stateMachine.ChangeState(SlotGameState.DoubleState);
		// 	this.robotPlay.onWin();
		// }

		//service.api?.gameFinished();

		// enable all buttons, but make spin button blink
		service.iomanager.EnableAllButtons([
			//{button: Button.ButtonSpin, light: OutputState.Blinking1}
		]);

		//auto play if you jump winLines
		if (this.autoPlaySkipWinLines == true && Settings.autoPlaySkipWinLines == true) {
			this.autoPlaySkipWinLines = false;
			void this.Spin();
		}
	}

	public stopAllGroowSymbolsAnim() {
		//kill all growing symbols
		if (this.symbolAnim != null) {
			for (let index = 0; index < this.symbolAnim.length; index++) {
				this.symbolAnim[index].anim.kill();
			}
			this.symbolAnim = [];
		}
	}

	public OnIdleEnd(): void {
		//commented need impletend for new pixieJS
		this.ZoomOutSymbols();
		// this.updateBalanceInterval.Stop();
		//stop anim for grow symbols 
		//this.stopAllGroowSymbolsAnim()
		this.panel.OnIdleEnd();
		this.StopAllAnimationsRequest();
		this.updateInterval.Stop();
		//PUT SPIN BUTON IN ALWAYS IN ON 
		//service.iomanager.SetAllLights(OutputState.Off);
		service.iomanager.EnableOnlyButtons([
			{ button: Button.ButtonSpin }
		]);
	}

	requestTime: number = 0;
	OnWaitGameStartBegin(): void {
		globalThis.jackpotDisplayGlobalResponsive?.Pause();
		if (this.selectedBetIndex.Type == BetType.Normal) {
			this.clientState.TryGameStart(this.bet.TotalBetCents);
		}
		else if (this.selectedBetIndex.Type == BetType.BuyBonus) {
			this.clientState.TryGameStart(this.bet.BuyBonusCents);
		}
		// this.updateBalanceInterval.Restart();
		this.UpdatePanel();

		this.requestTime = now();
		this.GameStartedCallback?.();
		this.spinAnimation.Start();
	}

	OnWaitGameStartEnd(): void {
		let response = now();
		let duration = response - this.requestTime;
		// this.updateBalanceInterval.Stop();
		//console.log(`spin response time ${duration}ms`);
	}

	// GameStartAllowed(): void
	// {
	// 	if (this.stateMachine.State() == SlotGameState.WaitGameStart)
	// 	{
	// 		// Log.Debug(this.logGroup, "Game start allowed");

	// 		this.gameStartTimeout.Stop();
	// 		this.spinAnimation.Start();

	// 		//this.clientState.GameStart(this.bet.TotalBetCents);
	// 		//this.panel.SetBalance(this.moneyFormatter.FormatCreditCurrentDenom(this.clientState.Balance()), this.moneyFormatter.FormatCurrency(this.clientState.Balance()));

	// 		//this.stateMachine.ChangeState(SlotGameState.Spin);
	// 		this.ActualSpin(this.selectedBetIndex);
	// 	}
	// 	else
	// 	{
	// 		Log.Error(this.logGroup, "Got GameStartAllowed(), but not in WaitGameStart state");
	// 	}
	// }

	// public GameStartDenied(): void
	// {
	// 	if (this.stateMachine.State() == SlotGameState.WaitGameStart)
	// 	{
	// 		Log.Error(this.logGroup, "Game start not allowed");

	// 		this.gameStartTimeout.Stop();

	// 		this.AutoplayDisable();
	// 		this.TurboSpinStop();
	// 		this.stateMachine.ChangeState(SlotGameState.Idle);
	// 	}
	// 	else
	// 	{
	// 		Log.Error(this.logGroup, "Got GameStartDenied(), but not in WaitGameStart state");
	// 	}
	// }



	// CAN HAPPEN AFTER spinResult is received
	protected OnBeforeSpin(): void {

	}

	protected OnSpinBegin(): void {
		globalThis.jackpotDisplayGlobalResponsive?.Resume();
		this.clientState.ResetNewGame();

		this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.clientState.Win), service.moneyFormatter.FormatCurrency(this.clientState.Win));
		this.panelWinLabel.Update();
		this.panel.OnSpinBegin();
		this.panel.SetMessage(this.translator.t.message_goodluck);
	}

	protected OnExitBegin() {
	}



	protected lastSpinAction: BasegameSpinAction;

	public async OnSpinResult(spinResult: SimpleSlotGameState): Promise<void> {

		this.lastSpinAction = spinResult.Actions[0] as BasegameSpinAction
		this.lastSpinResult = spinResult;
		this.SetLastGame(spinResult);

		//console.log("Spin-Data:",(spinResult.Actions));

		//keeps jackpot pause if SequentialProgressiveNonProgressiveWins its not hitted
		if (spinResult.TotalWin.SequentialProgressiveNonProgressiveWins.length > 0) {
			//console.log("Jackpot Was Hitted ");
			this.screenProtocol?.Send(new JackpotValuesPause(), this.screenProtocolScope);
		} else {
			//jackpots resume if not was hitted jackpot 
			//console.log("Jackpot not Was Hitted");
			this.screenProtocol?.Send(new JackpotValuesResume(), this.screenProtocolScope);
		}

		const totalBet = spinResult.Bet.BetType == BetType.BuyBonus ? spinResult.Bet.Bet.BuyBonusCents : spinResult.Bet.Bet.TotalBetCents;
		this.clientState.ConfirmGameStart(spinResult.CreditStart, totalBet);
		this.UpdatePanel();

		await NextTaskAsync(() => this.screenProtocol?.Send(new SlotGameMessages.SpinResult(this.lastSpinResult), this.screenProtocolScope));

		if (this.lastSpinAction.SpinWithFeatures.FeatureResults != null) {
			let scatterData = this.lastSpinAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown as ScatterRandomAwardResults;
			this.scatterRandomAwardFeature?.SetAwards(scatterData.ScattersPositionThisSpin);
			scatterData = null;
		}


		if (this.lastSpinResult.Actions.length >= 2) {
			const bonusWon: SlotBonus[] = []
			const bonuses = this.lastSpinResult.Actions.filter(bonus => bonus.Phase == "Start" && bonus.Depth == 1);

			for (let bonus of bonuses) {
				let newBonus = this.bonusList.get(bonus.Bonus as Bonus);
				if (!newBonus) {
					throw "No such bonus!";
				}

				bonusWon.push(newBonus);
			};

			this.indexSimpleRun = 1;
			//its reverse becuase all time send firts extendend or spin and hold 
			this.runingBonuses = bonusWon.reverse();

			this.currentBonus = this.runingBonuses[this.runingBonuses.length - 1];
			//this.currentBonus.CreateTransitionPixi();
			//this.bonusList.get(this.currentBonus.Name() as Bonus).CreateTransitionPixi();
		}


		//END

		await NextTaskAsync(() => {
			let targets: SpinTargetParams[] = [];
			for (let i = 0; i < this.lastSpinAction.Spin.ReelStops.length; i++) {
				// anticipation can't be on the first reel
				let t: SpinTargetParams = {
					position: this.lastSpinAction.Spin.ReelStops[i],
					firstAnticipationReelIndex: this.lastSpinAction.AnticipationReel,
					anticipation: this.lastSpinAction.AnticipationReel >= 0 && i >= this.lastSpinAction.AnticipationReel
				};

				targets.push(t);
				t = null;
			}

			this.reelSetMapper.SetTargets(targets);
			this.spinAnimation.SetTargets(targets);
			targets = null;
		});




		if (this.turboSpin) {
			this.panel.SpinButtonLabelChange(this.translator.t.turbo);
		}
		else {
			this.panel.SpinButtonLabelChange(this.translator.t.stop);
		}

		//let buttons:AvailableButton[] = this.pressButton.StopReel(); 
		// protocol.Send("StopReel", {buttons});


		this.robotPlay.OnSpinStopAvailable();

		if (this.turboSpin) {
			this.spinAnimation.RequestStop(-1);
		}
		//quit this for dont blink spin button whem state change 
		// service.iomanager.SetLights([
		// 	{light: Light.LightButtonSpin, state: OutputState.On}
		// ]);

		//this.RedrawAllReels();
		this.fillingPotFeature?.UpdateSpin();
	}

	// protected lastGame: SimpleSlotGameState = null;
	private SetLastGame(lastGame: SimpleSlotGameState): void {
		localStorage.setItem(this.gameName, JSON.stringify(lastGame));
	}
	// public GetLastGame(): SimpleSlotGameState {
	// 	return this.lastGame;
	// }

	protected lastReelStoppedTime: number = 0;
	protected lastReelStoppedSymbol: "regular" | "special" = "regular";
	protected OnReelNearStopped(reelIndex: number) {

		this.anticipationAnimation?.HideReelAnimation(reelIndex);
		this.symbolCollection?.PlayAnimationIdleSpineSymbol();

		// clear overlays of any wilds or anything
		this.reelSetMapper?.ClearOverlaysReel(reelIndex);

		// check if bonus symbol on this reels
		// let hasBonusSymbol: boolean = false;
		// let bonusSymbol: string = null;

		// if (this.lastSpinASction?.Triggers) {
		// 	for (let [name, triggerResult] of Object.entries(this.lastSpinASction.Triggers)) {
		// 		if (triggerResult.symbolsTriggered != null) {
		// 			let symbolsTriggered: SymbolPosition[] = triggerResult.symbolsTriggered;
		// 			for (let i = 0; i < symbolsTriggered.length; i++) {
		// 				if (symbolsTriggered[i].Reel == reelIndex) {
		// 					hasBonusSymbol = true;
		// 					bonusSymbol = name;

		// 					break;
		// 				}
		// 			}
		// 			//if(hasBonusSymbol)
		// 			//{
		// 			//	break;
		// 			//}
		// 		}
		// 	}
		// }


		let isScatterOnReel: boolean = !!this.lastSpinAction.Spin.ExpectedSymbols[reelIndex].find(symbolOnReel =>
			this.scatterAndBonusTriggerSymbols.find(s => s == this.symbols.find(s => s.ID == symbolOnReel).Index)
		);
		//let isScatterOnReel: boolean = false;



		// if(bonusSymbol=="FreeGameBonus"){
		// 	this.audio.Play(this.resid.ScopedResourceName("reelstopbonus"));
		// }
		// // else if(bonusSymbol=="PickBonus"){
		// // 	this.audio.Play(this.resid.ScopedResourceName("pickbonus"));
		// // }
		// else if(bonusSymbol == "DiamondSpin"){
		// 	this.audio.Play(this.resid.ScopedResourceName("diamondspin"));
		// }
		// else {

		if (Timing.Timeouted(this.lastReelStoppedTime, 20)) {
			this.lastReelStoppedTime = Timing.Now();

			if (isScatterOnReel) {
				// play sound scatter
				this.audio.Play(this.resid.ScopedResourceName("scatterstop"), true);
			}
			else {
				this.audio.Play(this.resid.ScopedResourceName("reelstop"), true);
			}

			this.lastReelStoppedSymbol = isScatterOnReel ? "special" : "regular";
		}
		else if (this.lastReelStoppedSymbol == "regular" && isScatterOnReel) {
			this.audio.Play(this.resid.ScopedResourceName("scatterstop"), true);
			this.lastReelStoppedSymbol = "special";
		}

		this.fillingPotFeature?.ReelStops(this.lastSpinAction?.SpinWithFeatures?.ExpectedSymbols[reelIndex]);
	}


	protected zoomedInSymbols: TriggerZoomAnim[][] = null;
	protected InitZoomedInSymbols() {
		const symbolSize: Size = this.spinnableReels.GetExtendendWindowSymbolSize();
		this.zoomedInSymbols = [];
		for (let reel = 0; reel < symbolSize.Width; reel++) {
			this.zoomedInSymbols.push([]);
			for (let row = 0; row < symbolSize.Height; row++) {
				this.zoomedInSymbols[reel].push({
					anim: null,
					scale: 1
				});
				//this.symbolsScaleIdleX.push([]);
				//this.symbolsScaleIdleY.push([]);
				//this.symbolsScaleIdleX[reel].push(this.spinnableReels.symbolContainerSprite[reel][row].scale._x);
				//this.symbolsScaleIdleY[reel].push(this.spinnableReels.symbolContainerSprite[reel][row].scale._y);				
			}
		}
	}

	public symbolAnim: TriggerZoomAnim[] = [];
	//protected symbolsScaleIdleX : number [][] = [];
	//protected symbolsScaleIdleY : number [][] = [];
	protected ZoomInSymbols(reelIndex: number) {
		if (this.reelElement?.[reelIndex])
			this.reelElement[reelIndex].mask = null;

		if (this.reelMask?.[reelIndex])
			this.reelMask[reelIndex].visible = false;
		//if (!this.zoomedInSymbols) this.InitZoomedInSymbols();

		let triggerPositions = Object.values(this.lastSpinAction?.Triggers ?? {}) // get all trigger results out from spin result
			.map(tr => tr.symbolsTriggered) // get all symbol positions for each trigger result (creates 2d array SymbolPosition[][])
			//.flat()	// flattens to 1d array SymbolPosition[]
			.reduce((acc, curr) => [...acc, ...curr], [])
			.filter(p => p.Reel == reelIndex); // filter only positions for this reel

		for (let position of triggerPositions) {

			// reverse rows?
			let rowIndex = this.windowSymbolSize.Height - position.Row - 1;
			//console.log(`ZoomInSymbols() reel: ${reelIndex} row: ${row}`); 

			this.symbolCollection.PlayAnimationReelStopSpineSymbol(reelIndex, rowIndex);


			// if (this.reelElement?.[reelIndex])
			// 	this.reelElement[reelIndex].mask = null;

			// if (this.reelMask?.[reelIndex])
			// 	this.reelMask[reelIndex].visible = false;	
		}
		triggerPositions = null;



	}

	protected EnableReelOverflow(reelIndex: number) {
		for (let i = 0; i < this.spinnableReels.numAdditionalRowsTop; i++) {
			this.spinnableReels.symbolContainerSprite[reelIndex][this.spinnableReels.symbolPIXISprite[reelIndex].length - 1].visible = false;
		}
	}

	protected DisableReelOverflow(reelIndex: number) {
		this.spinnableReels.symbolContainerSprite[reelIndex][this.spinnableReels.symbolPIXISprite[reelIndex].length - 1].visible = true;
	}


	protected ZoomOutSymbols(): void {
		for (let reel = 0; reel < this.zoomedInSymbols.length; reel++) {
			for (let row = 0; row < this.zoomedInSymbols[reel].length; row++) {

				if (this.reelElement?.[reel])
					this.reelElement[reel].mask = this.reelMask[reel];

				if (this.reelMask?.[reel])
					this.reelMask[reel].visible = true;
			}
		}
		//this.stopAllGroowSymbolsAnim();			
	}

	protected OnSpinEnd() {
		if (this.lastSpinResult.TotalWin.TotalWin.InCents > 0) {
		}
		else {
			this.audio.Stop(this.resid.ScopedResourceName("collect"));
			//this.audio.Play(this.resid.ScopedResourceName("reellost"));

		}
		this.StartAllAnimationsRequest();

		this.audio.Stop(this.resid.ScopedResourceName("leverpull"));
	}


	protected OnFeaturesBonusMultiplier() {
		let filterTrigger = this.lastSpinAction.Triggers.filter(t => t.Bonus != "FreeGameBonus");
		if (filterTrigger.length > 0) {
			for (let triggerBonus of filterTrigger) {
				//console.log("HitMultiplierBonus:", triggerBonus.Hint);
				if (triggerBonus.Hint == null || triggerBonus.Hint == undefined || triggerBonus.Hint.Multiplier == 1) { this.stateMachine.ChangeState(SlotGameState.FillingPot, null, ChangeStateType.NextTask) }
				else { this.bonusMultiplier?.SetBonusMultiplier(triggerBonus.Hint.Multiplier); }
			}
		} else {
			this.stateMachine.ChangeState(SlotGameState.FillingPot, null, ChangeStateType.NextTask)
		}
	}



	protected OnFeaturesFillingPot() {
		let scatterRandomAward = this.lastSpinAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
		if (scatterRandomAward.ScattersAddedThisSpin > 0 && scatterRandomAward.ScattersAddedThisSpin <= 3 && this.fillingPotFeature) {
			//create bonus win by default only change flag when you Trigger some bonus
			//start interval for filling Pot 
			//this.fillingPotNextTask?.Start();
			this.fillingPotFeature?.StartIncrement({
				BonusWin: false,
				ScatterCordinates: (this.lastSpinAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)?.ScattersPositionThisSpin,
				winSymbols: this.lastSpinAction?.Spin?.ExpectedSymbols,
			});

			scatterRandomAward = null;

			//Set Animation 
			let bonusTriggerSymbols: SymbolPositionToAnimate[] = [];
			let scatterPosition = (this.lastSpinAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)?.ScattersPositionThisSpin;
			scatterPosition.forEach(s => {
				bonusTriggerSymbols.push(new SymbolPositionToAnimate(
					s.Reel,
					//this.windowSymbolSize.height - symbolsTriggered[i].Row -1
					this.windowSymbolSize.Height - s.Row - 1
				));
			})

			let symbols: SlotSymbol[] = [];
			let symbolA = this.lastSpinAction.SpinWithFeatures.ExpectedSymbols.flat().filter(s => s.includes("SRA"));
			let symbolsConverted = this.symbols.filter(s => symbolA.filter(s2 => s2 == s.ID) && s.ID.includes("SRA"));
			//console.log("SRAWin:", symbolA);
			//console.log("SRAWin:", symbolsConverted);
			let bonusData = this.initData.BonusTriggers.find(b => b.RequiredSymbols.find(rS => symbolsConverted.find(s => s.Index == rS)))

			//console.log("SRAWin:", bonusData);

			let bonusReelStops: SlotBonus;
			if (bonusData != null) bonusReelStops = this.bonusList.get(bonusData.BonusName as Bonus);
			// console.log("SRAWin-Bonus:", bonusFind);

			if (this.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
				//this.spinnableReels.StopSymbolsAnim();
				bonusReelStops?.TriggerAnimationStartedSprite(1, 0);
				this.spinnableReels.PlaySymbolsAnim(bonusTriggerSymbols, false);
			}
			else if (this.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
				// bonusReelStops?.TriggerAnimationStartedSpine();
				this.symbolCollection.PlayAnimationWinSymbolSpineSymbol(bonusTriggerSymbols, false);
			}
		}
			this.stateMachine.ChangeState(SlotGameState.Features, null, ChangeStateType.NextTask);
	}


	//protected featuresTimer: number = -1;
	protected currentFeature: SlotFeature = null;
	protected OnFeaturesBegin() {

		//let timeout = 0;
		//let bonus:SlotBonus;

		//prepare first Wild feature 
		this.currentFeature = null;

		if (this.lastSpinAction.SpinWithFeatures.FeatureResults["ExpandingWildBulk"]?.FeatureTriggered && this.lastSpinAction.Win.ResultLines.length > 0) {
			this.currentFeature = this.features.get("ExpandingWildBulk");
			//console.log("WILD:",this.lastSpinASction.SpinWithFeatures.FeatureResults["ExpandingWildBulk"]);
			this.currentFeature.Prepare(this.lastSpinAction.SpinWithFeatures.FeatureResults["ExpandingWildBulk"])
		} else if (this.lastSpinAction.SpinWithFeatures.FeatureResults["ExpandingWildReel"]?.FeatureTriggered && this.lastSpinAction.Win.ResultLines.length > 0) {
			this.currentFeature = this.features.get("ExpandingWildReel");
			//console.log("WILD:",this.lastSpinASction.SpinWithFeatures.FeatureResults["ExpandingWildReel"]);					
			this.currentFeature.Prepare(this.lastSpinAction.SpinWithFeatures.FeatureResults["ExpandingWildReel"]);
		}


		//timeout += 300;

		// prepare scatter feature
		//this.featuresTimer = window.setTimeout(() => {

		if (this.lastSpinAction.Win.ScaterWin.InCents > 0) {

			this.stateMachine.ChangeState(SlotGameState.Scatter);
		} else {
			this.OnScatterWinEnd()
		}
	}

	// protected OnScatterWinBegin()
	// {
	// 	this.stateMachine.ChangeState(SlotGameState.BonusTrigger)
	// }

	protected OnScatterWinBegin() {
		if (this.lastSpinAction.Win.ScaterWin.InCents > 0) {
			// find all symbols positions on screen and symbol index,
			// then filter only scatter symbols
			this.scatterResult = this.lastSpinAction.SpinWithFeatures.FeatureResults["Scatter"] as ScatterResult;

			let timeout = this.scatterResult.Count * 2000;
			this.startkeysIndexScatter = Object.keys(this.scatterResult.PositionsPerSymbol);

			// for (let currentIndexScatter = 0; currentIndexScatter < this.startkeysIndexScatter.length; currentIndexScatter) {
			// 	let scatterBonusTrigger = this.initData.BonusTriggers.find(b => b.SymbolName == this.scatterResult.PositionsPerSymbol[this.startkeysIndexScatter[currentIndexScatter]].SymbolID);
			// 	if (this.lastSpinAction.Triggers.find(b => b.WillTrigger == true && b.Bonus == scatterBonusTrigger.BonusName)) {
			// 		timeout -= 500;
			// 	}
			// }
			this.currentIndex = 0;

			this.PlayNextScatter();
			this.CheckifMoreScatter(this.scatterResult.PositionsPerSymbol[this.startkeysIndexScatter[this.currentIndex + 1]]?.Position);
			this.panel.SetMessage("Scatter pays " + service.moneyFormatter.FormatCreditCurrentDenom(this.lastSpinAction.Win.ScaterWin));

			this.audio.PlayLoop(this.resid.ScopedResourceName("linecount"));

			let lineCountBackground = this.audio.Track(this.resid.ScopedResourceName("lineCountBackground"));
			lineCountBackground.SetVolume(this.audio.GetAudioLevel());
			lineCountBackground.Play();



			// // credit animation
			this.winCreditAnimation = TweenMax.fromTo(this.scatterWinValues,
				timeout / 1000,
				{ win: 0 },
				{
					win: this.lastSpinAction.Win.ScaterWin.InCents, roundProps: "balance,win",
					onUpdate: () => {
						this.bigWinCountAnimation.Display(service.moneyFormatter.CentsToCredit(this.scatterWinValues.win));
						this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.scatterWinValues.win), service.moneyFormatter.FormatCurrency(this.scatterWinValues.win));

					},
					onComplete: () => {
						this.audio.Stop(this.resid.ScopedResourceName("linecount"));
						//this.audio.Play(this.resid.ScopedResourceName("linecountend"));
						this.audio.Stop(this.resid.ScopedResourceName("lineCountBackground"));
						//this.symbolsAnimation.Stop();
						this.EnableCache = true;
						this.OnScatterWinEnd();
						//this.audio.Play(this.resid.ScopedResourceName("collect"));
					}
				}
			);
		}
		else {
			this.OnScatterWinEnd();
		}
	}

	protected OnScatterWinEnd() {

		//this.symbolsAnimation.Stop();
		//this.symbolsAnimation.Update();
		this.spinnableReels.StopSymbolsAnim();
		if (this.currentFeature != null) {
			this.OnWildStart();
		}
		else {
			// no "known" features, continue to next state
			if (this.lastSpinResult.Actions?.length > 1) {

				this.stateMachine.ChangeState(SlotGameState.BonusTrigger);
			} else {
				this.stateMachine.ChangeState(SlotGameState.BigWinBasegame);
			}
		}
	}

	protected OnWildStart() {
		if (this.currentFeature != null) {
			this.currentFeature.Start();
			this.robotPlay.OnSpinStopAvailable();

			this.timeOutRequestFeature.Start();
		}
	}
	// protected OnWildFinished() {
	// 	if (this.currentFeature == null) {
	// 		// no "known" features, continue to next state
	// 		if (this.lastSpinResult.Actions?.length > 1) {
	// 			this.stateMachine.ChangeState(SlotGameState.BonusTrigger);
	// 		} else {
	// 			this.stateMachine.ChangeState(SlotGameState.BigWinBasegame);
	// 		}
	// 	}
	// }

	protected newScatterAnim: Position[] = [];
	protected currentIndex: number = 0;
	protected scatterResult: ScatterResult;
	protected startkeysIndexScatter: string[] = [];

	//Check if are more scatter for anim 
	protected CheckifMoreScatter(newScatterAnim: Position[]): void {
		if (newScatterAnim != null) {
			this.currentIndex++;
			this.nextTimeoutAnimTriggerScatterAnim.Start();
		} else {
			this.stopAnimTriggerScatterAnim.Start();
			this.nextTimeoutAnimTriggerScatterAnim.Stop();
		}
	};

	//play current Scatter Anim 
	protected PlayNextScatter() {

		// TODO FIX BONUS TRIGGERS
		//return;

		const currentSymbol = this.startkeysIndexScatter[this.currentIndex];
		const currentSymbolIndex = this.scatterResult.PositionsPerSymbol[currentSymbol].Symbol;

		// const scatterBonusTrigger = this.initData.BonusTriggers.find(b => b.RequiredSymbols.includes(currentSymbolIndex));

		// if (scatterBonusTrigger &&
		// 	this.lastSpinAction.Triggers.find(b => b.WillTrigger == true && b.Bonus == scatterBonusTrigger.BonusName)) {
		// 	return
		// }




		//if (this.stateMachine.State() == SlotGameState.Scatter) {			

		let position: Position[] = this.scatterResult.PositionsPerSymbol[this.startkeysIndexScatter[this.currentIndex]]?.Position;
		let symbolPositions: SymbolPositionToAnimate[] = [];
		if (position) {
			for (let index = 0; index < position.length; index++) {
				symbolPositions.push(new SymbolPositionToAnimate(position[index].reel, this.windowSymbolSize.Height - 1 - position[index].row));
				//this.symbolsAnimation.Stop();				
			};
			this.EnableCache = false;
			//this.symbolsAnimation.Start(symbolPositions);
			//this.symbolsAnimation.Update();

			if (this.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
				this.spinnableReels.StopSymbolsAnim();
				this.spinnableReels.PlaySymbolsAnim(symbolPositions);
			}
			else if (this.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
				this.symbolCollection.PlayAnimationWinSymbolSpineSymbol(symbolPositions);
			}
			// let bonusTrigger = this.lastSpinAction.Triggers.find(t=>t.WillTrigger == true);
			// this.bonusList.get(bonusTrigger.Bonus as Bonus).TriggerAnimationStarted();					

			symbolPositions = null;

			//console.log('ScatterAnimPosition:',symbolPositions);
			//this.symbolsAnimation.Stop();
			//this.symbolsAnimation.Start(symbolPositions);
			//this.EnableSymbolsAnimation(symbolPositions);

			//this.symbolsAnimation.Update();
		}
	}

	protected symbolsTriggered: SymbolPosition[] = [];

	//Start Bonus Anim 
	protected OnBonusTriggeBegin() {
		if (this.lastSpinAction.Triggers != null) {
			this.currentIndexBonusTrigger = 0;
			this.bonusTrigger = this.lastSpinAction.Triggers.filter(b =>
				b.WillTrigger != false);
			//console.log("BonusTrigger:",this.bonusTrigger);		
			this.PlayNextTriggerBonus();
			this.CheckifMoreTriggerBonus();
		}
	}

	protected bonusTrigger: SimpleTriggerResult[] = [];
	protected currentIndexBonusTrigger: number = 0;

	//Check if are more bonusTrigger for anim 
	protected CheckifMoreTriggerBonus(): void {
		this.currentIndexBonusTrigger++;
		//if (this.stateMachine.State() == SlotGameState.BonusTrigger) {
		if (this.bonusTrigger[this.currentIndexBonusTrigger]?.WillTrigger == true) {
			this.nextAnimTimeoutTriggerBonus.Start();
		} else {
			if (this.currentBonus != null) {
				//stops current Anim for start bonus 
				this.stopAnimTriggerBonusAnim.Start();
			} else {
				//dont won some bonus go to collect 
				this.stateMachine.ChangeState(SlotGameState.WaitCollect);
			}
		}
		//}
	};

	//playCurrentBonusTrigger
	protected PlayNextTriggerBonus() {
		if (this.bonusTrigger[this.currentIndexBonusTrigger]?.WillTrigger == true) {
			this.autoPlaySkipWinLines = false;
			this.fillingPotHitBonues?.Start();


			let bonusTriggerSymbols: SymbolPositionToAnimate[] = [];
			let symbolsTriggered: SymbolPosition[] = this.bonusTrigger[this.currentIndexBonusTrigger]?.symbolsTriggered as SymbolPosition[];
			for (let i = 0; i < symbolsTriggered.length; i++) {
				bonusTriggerSymbols.push(new SymbolPositionToAnimate(
					symbolsTriggered[i].Reel,
					//this.windowSymbolSize.height - symbolsTriggered[i].Row -1
					this.windowSymbolSize.Height - symbolsTriggered[i].Row - 1
				));

				//this.DrawSymbol(bonusTriggerSymbols[i].reel, bonusTriggerSymbols[i].row);
			}
			symbolsTriggered = null
			this.EnableCache = false;


			if (this.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
				this.spinnableReels.StopSymbolsAnim();
				this.currentBonus.TriggerAnimationStartedSprite(3);
				this.spinnableReels.PlaySymbolsAnim(bonusTriggerSymbols, true);
			}
			else if (this.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
				this.currentBonus.TriggerAnimationStartedSpine();
				this.symbolCollection.PlayAnimationWinSymbolSpineSymbol(bonusTriggerSymbols, false);
			}
			bonusTriggerSymbols = null



			//this.EnableSymbolsAnimation(bonusTriggerSymbols);
		}
	}


	// protected OnBonusTriggeEnd() {

	// 	this.bonusTriggerAnimation.Stop();		
	// 	this.symbolsAnimation.Stop();
	// 	this.EnableCache = false;						
	// 	tfhis.stopAnimTriggerBonusAnim.Stop();	
	// }

	protected stopAnimTriggerBonusAnim: ITimeout;
	protected stopAnimTriggerScatterAnim: ITimeout;
	protected nextTimeoutAnimTriggerScatterAnim: ITimeout;
	protected nextAnimTimeoutTriggerBonus: ITimeout;


	protected OnCurrentFeatureEnd() {

	}

	protected OnFeaturesEnd(): void {
		//this.currentFeature = null;
	}

	protected RequestFeatureStop(): void {
		if (this.currentFeature != null) {
			this.currentFeature.RequestStop();
			//this.symbolsAnimation.Update();
			this.currentFeature = null;
		} else {
			//this.symbolsAnimation.Update();
			//this.symbolsAnimation.Stop();			
		}
	}

	protected OnBigWinBasegameBegin(): void {

		if (this.lastSpinAction.Win.ResultLines.length > 0) {
			let winCredit: number = service.moneyFormatter.CentsToCredit(this.lastSpinAction.WinAmounts.TotalWin.InCents);

			if (this.winMessageAnimation.WillTrigger(this.bet, winCredit)) {
				winCredit = null;
				this.TurboSpinStop();

				this.shakeAnimation.Start();
				this.audio.Play(this.resid.ScopedResourceName("bigwin"));

				// run big win for 2 seconds
				this.timeoutBigWinStart.Start();
			}
			else {
				// Log.Debug(this.logGroup, "Big win message will not show");
				this.stateMachine.ChangeState(SlotGameState.Win);
				//this.stateMachine.ChangeState(SlotGameState.Scatter);
			}
		}
		else {
			// Log.Debug(this.logGroup, "Skipping big win, no lines");
			this.stateMachine.ChangeState(SlotGameState.Win);
		}
	}

	protected OnBigWinBasegameEnd() {
		let winCredits: number = service.moneyFormatter.CentsToCredit(this.lastSpinAction.WinAmounts.TotalWin.InCents);
		if (this.winMessageAnimation.WillTrigger(this.bet, winCredits)) {
			this.winMessageAnimation.Start(this.bet, winCredits);
			this.fillingPotFeature?.OnStartBigWinShow();
			winCredits = null;
			//this.winMessageAnimation.View().style.visibility = "visible";
			this.bigWinCountAnimation.ViewPIXIAPP().visible = true;
			this.fountainAnimation.Destroy();
			SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
		}
	}

	protected async OnWinBegin() {
		//if (this.lastSpinResult.TotalWin > 0)
		let animDuration: number;
		if (this.lastSpinAction.Win.ResultLines.length > 0) {
			this.clientState.SetWin(this.lastSpinResult.Actions[0].WinSinceGameStart.TotalWin.InCents, "OnWinBegin");
			if (this.turboSpin) {
				this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.lastSpinResult.Actions[0].WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.lastSpinResult.Actions[0].WinSinceGameStart.TotalWin.InCents));
				this.stateMachine.ChangeState(SlotGameState.BonusTrigger);
			}
			else {
				//let fixedDuration: number;
				let fixedDuration = ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()];
				this.symbolCollection.SetSymbolAnimationSpeed(ChangeSpeedSpine[this.speedManager.GetDefaultCelebrationType()]);

				if (this.needsToUpdateWinLinesAnimation) {
					fixedDuration = this.speedChangeParams.CelebrationFactor;
					//this.symbolCollection.SetSymbolAnimationSpeed(ChangeSpeedSpine(this.speedChangeParams.]))
				}


				let duration: number = 0;
				//console.log("DurationOriginal-LineCount:",this.audio.Track(this.resid.ScopedResourceName("linecount")).Duration());
				if (this.lastSpinAction.Win.ResultLines.length <= 10) {
					//3
					//2501 * 3 
					duration = this.audio.Track(this.resid.ScopedResourceName("linecount")).Duration() * 3 * 1000;
					if (duration == 0) {
						//console.log("LineCount <= 10");
						duration = fixedDuration //* 1000;
					}
				}
				else if (this.lastSpinAction.Win.ResultLines.length >= 11 && this.lastSpinAction.Win.ResultLines.length <= 50) {
					//2
					//2501 * 2 
					duration = this.audio.Track(this.resid.ScopedResourceName("linecount")).Duration() * 2 * 1000;
					if (duration == 0) {
						//console.log("LineCount >= 11 && LineCount <= 50");
						duration = fixedDuration //* 1000;
					}
				}
				else if (this.lastSpinAction.Win.ResultLines.length >= 51) {
					//1
					//2501 * 1 
					duration = this.audio.Track(this.resid.ScopedResourceName("linecount")).Duration() * 1 * 1000;
					if (duration == 0) {
						//console.log("LineCount >= 51");
						duration = fixedDuration //* 1000;
					}
				}

				//duration = Math.max(this.audio.Track(this.resid.ScopedResourceName("linecount")).Duration(), 0.2) * 2 * 1000;

				//TODO
				//missing data or  change interface 							
				this.winLinesAnimation.Start(this.lastSpinAction.Win.ResultLines, duration);

				animDuration = this.winLinesAnimation.GetDuration();
				//fixedDuration*this.lastSpinAction.Win.ResultLines.length
				// if (this.needsToUpdateWinLinesAnimation)
				// {
				// 	animDuration = this.speedChangeParams.CelebrationFactor*this.lastSpinAction.Win.ResultLines.length*duration;

				// }


				//this.symbolsAnimation.Start();

				this.winCreditAnimation = TweenMax.fromTo(this.winValues,
					animDuration / 1000,

					{/*balance: this.clientState.Balance()-this.lastSpinResult.TotalWin, */win: this.lastSpinAction.Win.ScaterWin.InCents },
					{/*balance:this.clientState.Balance(),*/ win: this.lastSpinResult.Actions[0].WinSinceGameStart.TotalWin.InCents, roundProps: "balance,win",
						onUpdate: () => {
							this.bigWinCountAnimation.Display(service.moneyFormatter.CentsToCredit(this.winValues.win));
							this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.winValues.win), service.moneyFormatter.FormatCurrency(this.winValues.win));

						}, ease: Power0.easeNone,
						onComplete: () => {

							this.stateMachine.ChangeState(SlotGameState.BonusTrigger);
						}
					}
				);
			}
		}
		else {
			// delay to slow down the empty game
			//await Delay(300);
			this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig);
		}

		this.robotPlay.OnSpinStopAvailable();
	}

	protected UpdateWinLinesAnimation() {

	}

	protected OnWinEnd() {

		// fast forward win count, if needed
		if (this.winCreditAnimation != null && this.winCreditAnimation.progress() != 1) {
			this.winCreditAnimation.progress(1, false);
		}

		this.winLinesAnimation?.RequestStop();

		//this.symbolsAnimation.Stop();
		this.winMessageAnimation.Stop();
		this.fillingPotFeature?.OnEndBigWinShow();
		this.fountainAnimation.Destroy();
		this.bigWinCountAnimation.ViewPIXIAPP().visible = false;
	}

	protected lastBonus: SlotBonus = null;
	protected async OnBonusFinished(): Promise<void> {
		//this.screenProtocol?.Send(new SlotGameMessages.BonusFinished(this.currentBonus.Name()), this.screenProtocolScope);
		// Log.Debug(this.logGroup, "Current Bonus to hide " + this.currentBonus.Name());
		this.symbolCollection.DestroyAllSymbols();
		this.runingBonuses.pop();
		// Log.Debug(this.logGroup, "Removing bonus");
		this.onSimpleNextBonusAction = null;
		if (this.runingBonuses.length == 0) {
			// await this.fillingPotFeature?.Create(this.gameViewAppPixi.GetAppView());
			this.RedrawAllReels();
			// this.fillingPotFeature?.SetBet(this.selectedBet);
			this.bonusMultiplier?.SetBet(this.selectedBet, true);

			//this.spinnableReels.Create(this.fillingPotFeature?.containerSpinnableReelsSpine);
			// this.fillingPotFeature?.RestartAnim();
			this.stateMachine.ChangeState(SlotGameState.BigWinTotal, { reason: "No more bonuses" });
			// Log.Debug(this.logGroup, "No more bonuses");
			this.lastBonus = null;
		}
		else {
			let nextcurrentBonus = this.runingBonuses[this.runingBonuses.length - 1];
			// Log.Debug(this.logGroup, "New bonus " + this.currentBonus.Name());

			this.robotPlay.BonusStarted(nextcurrentBonus);

			if (this.lastBonus != nextcurrentBonus) {
				//nextcurrentBonus.CreateTransitionPixi();
				//put for create reels or spine 
				//this.currentBonus.GameSelected(); 
				//have another bonus on BaseGame Won its not prepared and displayed 
				//need startConfig Bonus 				
				let currentindexData = this.lastSpinResult.Actions.findIndex((b) => b == this.lastSpinAction);
				this.onSimpleNextBonusAction = this.lastSpinResult.Actions.filter((b, index) => index > currentindexData && b.Bonus == nextcurrentBonus.Name());
				currentindexData = null;
				//this.screenProtocol?.Send(new SlotGameMessages.BonusRunResult(this.onSimpleNextBonusAction), this.screenProtocolScope);				
				this.timeoutWaitBonusStartConfig.Start();
				// setTimeout(() => {
				// 	this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig)
				// }, 1500);
			} else {
				if (this.currentBonus != null) {
					//setTimeout(() => {	
					this.currentBonus.Hide();
					this.currentBonus.GameExit();

					//this.currentBonus.DestroyTransition();
					//this.robotPlay.BonusEnded();
					this.currentBonus = null;

					//this.currentBonus.GameExit();
					//this.currentBonus.DestroyTransition();				
					//},500);
				}
				//you won 2 bonus on base game 
				//firt bonus was displayed and preapre
				//put for create reels or spine 				
				nextcurrentBonus.GameSelected(this.gameViewAppPixi.GetAppView().stage);
				nextcurrentBonus.fillingPotFeature?.SetBet(this.selectedBet);
				nextcurrentBonus.Show();

				nextcurrentBonus.NextBonusEnd();
				this.currentBonus = this.runingBonuses[this.runingBonuses.length - 1];

			}
			this.bonusMultiplier?.SetBet(this.selectedBet);
		}
	}

	protected onSimpleNextBonusAction: ISimpleBonusAction[];
	//use for add bonus into bonus 
	protected OnBonusRunFinish(run: ISimpleBonusAction[]): void {
		this.lastBonus = this.currentBonus;
		this.onSimpleNextBonusAction = run;
		//console.log("ApiResultNextBonus:",this.onSimpleNextBonusAction);
		let indexStartConfig = run.findIndex(b => b.Phase == "Start");
		//this.screenProtocol?.Send(new SlotGameMessages.BonusRunResult(run), this.screenProtocolScope);				
		let bonusName = run[indexStartConfig].Bonus as Bonus
		let b = this.bonusList.get(bonusName);
		this.runingBonuses.push(b);
		//b.CreateTransitionPixi();		
		//this.currentBonus.fillingPotFeature?.SetBet(this.selectedBet);	
		this.bonusMultiplier?.SetBet(this.selectedBet);
		this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig);

	}

	protected OnWaitBonusStartConfigBegin(): void {
		//this.symbolsAnimation.Stop();
		//if (this.runingBonuses.length == 0 || this.bonusStartConfig)
		// if (this.runingBonuses.length == 0){
		// 	this.stateMachine.ChangeState(SlotGameState.Bonus);
		// }		
		if (this.runingBonuses.length != 0) {
			//i need change because this.bonusStartConfig are empty always the protocol its commented 
			if (this.stateMachine.IsState(SlotGameState.WaitBonusStartConfig)) {
				this.currentBonus = this.runingBonuses[this.runingBonuses.length - 1];
				this.currentBonus.CreateTransitionPixi();
				this.stateMachine.ChangeState(SlotGameState.Bonus);
			}
		} else {
			this.stateMachine.ChangeState(SlotGameState.WaitCollect);

			//this.stateMachine.ChangeState(SlotGameState.Collect);
		}
	}

	protected OnBonusBegin() {

		//destroy bonus if you had 2 bonus at the same game 	
		// if(this.currentBonus != null) { 
		// 	this.currentBonus.GameExit();
		// }

		if (this.runingBonuses.length != 0) {
			this.timeoutBonusShowTransition.Start();
			//this.currentBonus = this.runingBonuses[this.runingBonuses.length-1];
			//this.currentBonus.CreateTransitionPixi();

			this.TurboSpinStop();
			this.AutoplayDisable();
			//this.bonusTriggerAnimation.Stop();				
			this.currentBonus = this.runingBonuses[this.runingBonuses.length - 1];
			this.currentBonus.CreateTransitionPixi(this.gameViewAppPixi.GetAppView().stage);


			this.currentBonus.Prepare({
				actions: (this.onSimpleNextBonusAction ?? this.lastSpinResult.Actions) as ISimpleBonusAction[],
				bet: this.bet,
			});

			this.panel.SetMessage(this.translator.t.message_bonustriggered);
		}
		else {
			this.stateMachine.ChangeState(SlotGameState.BigWinTotal);
			//this.stateMachine.ChangeState(SlotGameState.Collect);
		}
	}

	protected OnBonusEnd() {
		//globalThis.__PIXI_APP__ = this.gameViewAppPixi.GetAppView();
		if (this.gameConfig.enabledPuppet) {
			if (this.currentBonus != null) {
				//this.fillingPotFeature?.SaveCurrentIncrement();
				//put for destroy reels or spine 				
				let bonusLeveles = this.currentBonus.fillingPotFeature?.GetCurrentLevels()
				//console.log("Particles-Return BaseGame", bonusLeveles)
				this.fillingPotFeature?.SetCurrentFromBaseGameLevels(bonusLeveles);
				bonusLeveles = null;
			}
		}


		//fix
		// if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
		// this.spinnableReels?.Create(null,this.gameViewAppPixi.GetAppView());
		this.gameViewAppPixi?.Destroy();
		this.gameViewAppPixi?.Create();
		// }

		//this.RedrawAllReels();

		if (this.currentBonus != null) {
			let bonusStoppedWinAnotherBonus = this.bonusList.get(this.currentBonus.Name() as Bonus)

			let timeout = 100;
			if (this.onSimpleNextBonusAction != null) timeout += 2500;
			setTimeout(() => {
				bonusStoppedWinAnotherBonus?.Hide();
				bonusStoppedWinAnotherBonus?.GameExit();
				//bonusStoppedWinAnotherBonus.DestroyTransition();

				//this.currentBonus.GameExit();
				//this.currentBonus.DestroyTransition();				
			}, timeout);
		}


		this.panel.Show();
		this.panel.Start();




		//let totalWin:number = 0;
		//if (this.lastSpinResult) totalWin = this.lastSpinResult.TotalWin;

		if (this.currentBonus) {
			//let bonusWin:number = this.currentBonus.GetBonusWin();
			//totalWin += bonusWin;
			this.robotPlay.BonusEnded();

		}
		// else
		// {
		// 	this.clientState.GameEnd(this.clientState.Win);
		// }


		//this.clientState.GameEnd(this.lastSpinResult.TotalWin.TotalWin.InCents);
		this.basegameElement.style.display = "block";
		//this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.lastSpinResult.TotalWin.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.lastSpinResult.TotalWin.TotalWin.InCents));
		//this.panel.SetBalance(this.moneyFormatter.FormatCreditCurrentDenom(this.clientState.Balance()), this.moneyFormatter.FormatCurrency(this.clientState.Balance()));		

		//this.clientState.UpdateBalance(this.lastSpinResult.CreditEnd.InCents);
		this.currentBonus = null;
	}

	protected bigWinTotalTimeout: ITimeout;
	protected async OnBigWinTotalBegin() {
		this.audio.PlayOrContinueLoop(this.resid.ScopedResourceName("background"));
		//this.clientState.GameEnd(this.lastSpinResult.TotalWin.TotalWin.InCents);
		this.clientState.SetWin(this.lastSpinResult.TotalWin.TotalWin.InCents, "OnSpinResult()");

		//if (this.currentBonus == null)

		// total win is cents
		//let totalWin: number = basegameWin + this.currentBonus.GetTotalWin();

		// we're checking based on credit
		let totalWinCredit: number = service.moneyFormatter.CentsToCredit(this.lastSpinResult.TotalWin.TotalWin.InCents);

		// check if win message could be shown for the won credit
		if (this.winMessageAnimation.WillTrigger(this.bet, totalWinCredit)) {
			// start win message
			this.winMessageAnimation.Start(this.bet, totalWinCredit);
			this.fillingPotFeature?.OnStartBigWinShow();
			totalWinCredit = null;

			// finally start coin fountain
			// SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
			await this.CreateFountain();
			this.bigWinTotalTimeout.Start();
		}
		else {
			// not enough won, skip coin fountain
			//OLD
			//this.stateMachine.ChangeState(SlotGameState.WaitCollect);
			//service.api?.gameFinished();
			this.stateMachine.ChangeState(SlotGameState.WaitCollect);
		}
	}

	//protected canCollectReceived: boolean = false;
	//protected canCollect: boolean = true;
	protected collectAnimation: TweenMax = null;

	protected OnBigWinTotalEnd() {

		// end win message
		this.winMessageAnimation.Stop();
		this.fillingPotFeature?.OnEndBigWinShow();

		// end coin fountain here
		// SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
		this.fountainAnimation.Destroy();
	}

	protected async OnWaitCollectBegin() {
		this.panel.OnSpinEnd();
		let totalWin: number = this.lastSpinResult.TotalWin.TotalWin.InCents;

		if (totalWin > 0) {
			this.panel.SpinButtonLabelChange(this.translator.t.collect);
			this.stateMachine.ChangeState(SlotGameState.Collect);
			totalWin = null;
		}
		else {
			this.stateMachine.ChangeState(SlotGameState.GameFinished);
		}
	}

	protected OnWaitCollectEnd() {
		this.audio.Stop(this.resid.ScopedResourceName("waitcollect"));
	}


	protected OnCollectBegin(): void {
		this.panel.OnSpinEnd();

		if (this.lastSpinResult.CanCollect &&
			this.lastSpinResult.TotalWin.TotalWin.InCents > 0) {
			let betCredit = this.lastSpinResult.Bet.Bet.TotalBetCredits;

			let durationMin = 0.1;
			let creditMin = 10 * betCredit

			let durationMax = 1;
			let creditMax = 100 * betCredit

			let creditWon = service.moneyFormatter.CentsToCredit(this.lastSpinResult.TotalWin.TotalWin.InCents);
			let collectDuration = 0;

			if (creditWon <= creditMin) {
				collectDuration = durationMin;
			}
			else if (creditWon >= creditMax) {
				collectDuration = durationMax;
			}
			else {
				let factor = (creditWon - creditMin) / (creditMax - creditMin);
				collectDuration = durationMin + ((durationMax - durationMin) * factor);
			}

			let startValues: CollectValues =
			{
				balance: this.lastSpinResult.CreditStart.InCents - this.lastSpinResult.Bet.Bet.TotalBetCents.InCents,
				//win: this.lastSpinResult.TotalWin.TotalWin.InCents
			};

			let endValues: CollectValues =
			{
				balance: this.lastSpinResult.CreditEnd.InCents,
				//win: 0
			};

			let denom: Money = this.lastSpinResult.Bet.Bet.Denom;

			let values: CollectValues = { ...startValues };


			this.collectAnimation = TweenMax.fromTo(values,
				collectDuration,

				{ ...startValues },
				{
					...endValues, roundProps: "balance,win",
					onUpdate: () => {
						this.panel.SetBalance(service.moneyFormatter.FormatCreditWithDenom(values.balance, denom), service.moneyFormatter.FormatCurrency(values.balance));
					},
					onComplete: () => {
						this.panel.SetBalance(service.moneyFormatter.FormatCreditWithDenom(values.balance, denom), service.moneyFormatter.FormatCurrency(values.balance));
						this.stateMachine.ChangeState(SlotGameState.GameFinished);
					}
				}
			);
		}
		else {
			this.stateMachine.ChangeState(SlotGameState.GameFinished);
		}



		//this.audio.Play(this.resid.ScopedResourceName("collect"));
	}

	protected OnCollectEnd() {
		if (this.currentBonus) {
			this.currentBonus.Reset();
		}

		// if (this.clientState.Balance() != this.lastSpinResult.CreditEnd.InCents)
		// {
		// 	Log.Error(this.logGroup, "OnCollectBegin(): Current credit does not match! Backend: " + this.lastCanCollect.CurrentCreditTotal.InCents + ", Frontend: " + this.clientState.Balance() + ", updating frontend");
		// 	//;
		// 	this.clientState.UpdateBalance(this.lastCanCollect.CurrentCreditTotal.InCents);
		// 	this.panel.SetBalance(this.moneyFormatter.FormatCreditCurrentDenom(this.clientState.Balance()), this.moneyFormatter.FormatCurrency(this.clientState.Balance()));
		// }

		// report to backent, that game has ended
		//protocol.Send("GameEnd", null);

		// if(getComputedStyle(this.recoveryMessage).display == "flex"){
		// 	this.recoveryMessage.style.display = "none";
		// }
	}

	protected async OnGameFinishedBegin() {

		if (this.lastSpinResult != null) {
			this.clientState.SetWin(this.lastSpinResult.TotalWin.TotalWin.InCents, "OnGameFinishedBegin()");
			this.clientState.GameEnd(this.lastSpinResult.TotalWin.TotalWin.InCents, this.lastSpinResult.CreditEnd.InCents)
			//this.clientState.UpdateBalance(this.lastSpinResult.CreditEnd.InCents);
		}

		// restore balance after replay
		if (this.isReplay) {
			this.clientState.UpdateBalance(this.realBalanceAfterReplay);
			this.UpdatePanel();

			this.replayMessage.Hide();
			this.isReplay = false;
			this.realBalanceAfterReplay = 0;
		}

		this.screenProtocol?.Send(new JackpotValuesResume(), this.screenProtocolScope);

		try {
			await service.api?.gameFinished();
		}
		catch (ex) {
			// could not signal game was finished
			Log.Error(this.logGroup, "Could not signal game finished", ex)
		}


		this.stateMachine.ChangeState(SlotGameState.Idle);
	}

	protected OnGameFinishedEnd() {
		// reset whatever needs resettings
		//this.lastSpinResult = null;
		//this.canCollectReceived = false;
		this.currentBonus = null;
		this.onSimpleNextBonusAction = null;
		this.bonusStartConfig = null;
		this.runingBonuses = [];
		this.lastSpinAction = null;
		this.EnableCache = true;
	}

	protected Hide(element: HTMLElement) {
		element.style.visibility = "hidden";
	}

	protected Show(element: HTMLElement) {
		element.style.visibility = "visible";
	}


	protected forceSymbolsUpdate: boolean = false;
	public Update(): void {

		// update symbols
		/*
		for (let i = 0; i < this.symboSpriteAnims.length; i++) {
			this.symboSpriteAnims[i].Update();
		}
		*/

		// TODO update only in spin
		this.spinAnimation?.Update();

		this.fountainAnimation?.Update();

		globalThis.jackpotDisplayGlobalResponsive?.Update();

		// TODO update only in basegame
		if (this.stateMachine.State() != SlotGameState.Bonus) {
			this.spinnableReels?.Update();
		}

		// TODO update only in features?				
		//this.scatterRandomAwardFeature?.Update()


		if (this.stateMachine.State() == SlotGameState.Bonus) {
			if (this.currentBonus) {
				this.currentBonus.Update();
			}
		}

		// if(this.bonusTriggerAnimation !=null)
		// {
		// 	this.bonusTriggerAnimation.Update();
		// }

		//this.symbolCache?.Update();
		if (this.forceSymbolsUpdate && this.stateMachine.State() != SlotGameState.Bonus) {

			// // check symbol canvases
			// for (let reelIndex = 0; reelIndex < this.spinnableReels?.GetWindowSymbolSize().Width; reelIndex++) {
			// 	this.RedrawReel(reelIndex);
			// }

			this.RedrawAllReels();

			this.forceSymbolsUpdate = false;
		}



		if (this.help?.IsStarted()) {
			this.help.Update()
		}

		this.doubleUpView?.Update();

		if (this.stateMachine.State() != SlotGameState.Bonus) {
			//this.symbolsAnimation.Update();
			this.winMessageAnimation?.Update();
			this.shakeAnimation?.Update();
			this.winLinesAnimation?.Update();


		}
		this.fillingPotFeature?.Update();

		this.gameViewAppPixi?.Update();

	}

	public View(): HTMLElement {
		return this.gameView;
	}

	public OnBonusStartConfig(config: BonusStartConfigMessage): void {
		this.bonusStartConfig = config.StartConfig;

		if (this.stateMachine.IsState(SlotGameState.WaitBonusStartConfig)) {
			this.stateMachine.ChangeState(SlotGameState.Bonus);
		}
	}

	public OnBonusPickElement(element: BonusPickElement): void {
		this.currentBonus.OnBonusPickElement(element);
	}

	public OnBonusPickReveal(pickReveal: BonusPickReveal): void {
		this.currentBonus.OnBonusPickReveal(pickReveal);
	}

	public OnBonusRevealRemaining(revealREmainig: BonusRevealRemaining): void {
		this.currentBonus.OnBonusRevealRemaining(revealREmainig);
	}

	protected runingBonuses: SlotBonus[] = [];
	protected runResult: RunResultMessage//IRunResult;
	protected indexSimpleRun: number = 1;
	public OnNextBonusSimpleResult()//IRunResult):void
	{
		//this.currentBonus.OnBonusRunResult(run);
		let b: SlotBonus = null;
		if (this.lastSpinResult.Actions[this.indexSimpleRun].Action != this.currentBonus.Name()) {
			let bonusName = this.lastSpinResult.Actions[this.indexSimpleRun].Bonus as Bonus
			b = this.bonusList.get(bonusName);
			this.runingBonuses.push(b);
			b = null;
			bonusName = null;
		}
	}

	public OnBonusTotalResult(totalResult: BonusTotalResult): void {
		this.currentBonus.OnBonusTotalResult(totalResult);
	}

	public OnBonusFinish(finish: BonusFinish): void {
		this.currentBonus.OnBonusFinish(finish);
	}



	// bonus
	// public Bonus(): SlotBonus {
	// 	return this.currentBonus;
	// }

	public GetPreview(): HTMLElement {
		return this.previewElement;
	}

	public GetPresentation(): GamePresentation {
		return this.presentation;
	}

	public override OnButtonChanged(button: Button, pressed: boolean) {

		if (this.stateMachine.IsState(SlotGameState.DoubleState)) {
			this.doubleUpView.OnButtonChanged(button, pressed);
			this.panel?.ButtonChanged(button, pressed);
			return;
		}

		if (pressed) {
			if (this.autoPlay || this.turboSpin) {
				this.AutoplayDisable();
				this.TurboSpinStop();
			}
			else if (this.denomMenu.IsLocked()) {
				// need to select denom
			}
			else if (this.help.IsStarted()) {
				this.help.Stop();
			}
			else if (this.buyBonusMenu.Visible()) {
				this.buyBonusMenu.Hide();
			}
			//else if(!this.denomMenu.IsLocked() && !this.help.IsStarted() /*&& !this.payoutMenu.IsLocked()*/ )
			else {
				let betsThisDenom: BetConfig[] = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == this.selectedBet.Denom.InCents);

				// if (!this.AllowSpin)
				// {
				// 	return;
				// }
				if (button == Button.ButtonSpin) {
					this.SpinButton(pressed);
				}
				else if (button == Button.ButtonBet1) {
					if (betsThisDenom.length > 0) {
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[0]);
						if (!this.SelectBet2(betIndex)) {
							this.SpinButton(true);
							this.SpinButton(false);
						}
					}
				}
				else if (button == Button.ButtonBet2) {
					if (betsThisDenom.length > 1) {
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[1]);
						if (!this.SelectBet2(betIndex)) {
							this.SpinButton(true);
							this.SpinButton(false);
						}
					}
				}
				else if (button == Button.ButtonBet3) {
					if (betsThisDenom.length > 2) {
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[2]);
						if (!this.SelectBet2(betIndex)) {
							this.SpinButton(true);
							this.SpinButton(false);
						}
					}
				}
				else if (button == Button.ButtonBet4) {
					if (betsThisDenom.length > 3) {
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[3]);
						if (!this.SelectBet2(betIndex)) {
							this.SpinButton(true);
							this.SpinButton(false);
						}
					}
				}
				else if (button == Button.ButtonBet5) {
					if (betsThisDenom.length > 4) {
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[4]);
						if (!this.SelectBet2(betIndex)) {
							this.SpinButton(true);
							this.SpinButton(false);
						}
					}
				}
				else if (button == Button.ButtonBetNext) {
					this.NextBet();
				}
				else if (button == Button.ButtonBetUp) {
					this.BetUp();
				}
				else if (button == Button.ButtonBetDown) {
					this.BetDown();
				}
				else if (button == Button.ButtonMaxBet) {
					this.MaxBet();
				}
				else if (button == Button.ButtonAutoplay) {
					if (this.popUpMenuAnim.CheckPopUpVisibility()) {
						this.popUpMenuAnim.HidePopUp();
						return
					}
					this.AutoplayToggle();
				}
				else if (button == Button.ButtonGamesMenu) {
					this.GamesMenu();
				}
				else if (button == Button.ButtonHelp) {
					this.Help();
				}
				else if (button == Button.ButtonPayout) {

				}
				else if (button == Button.ButtonVolumeNext) {
					this.audio.NextVolume();
				}
				else if (button == Button.ButtonDenomMenu) {
					this.showDenomMenu = true;
					if (this.popUpMenuAnim.CheckPopUpVisibility()) {
						this.popUpMenuAnim.HidePopUp();
					}

					this.ShowAvailableDenoms();
				}
				else if (button == Button.ButtonSettings) {
					if (!this.popUpMenuAnim.CheckPopUpVisibility() && this.stateMachine.IsState(SlotGameState.Idle)) {
						this.popUpResponsiveContainer.style.display = "flex";
						this.popUpMenuAnim.ShowPopUp();
					}

				}
				else if (button == Button.ButtonCallAttendant) {

				}
				else if (button == Button.ButtonCreditsMoney) {
					this.panel.ToggleCreditMoney();
				}
				else if (button == Button.ButtonDoubleUp) {
					if (this.doubleUpView) {
						if (this.stateMachine.IsState(SlotGameState.Idle) && this.lastSpinResult?.TotalWin.TotalWin.InCents > 0) {
							this.stateMachine.ChangeState(SlotGameState.DoubleState);
						}
					}
				}
				else if (button == Button.ButtonChangeBetType) {

					this.VerifyBetTypeChange();
					// this.ChangeBetType();
				}
				else {
					// Log.Debug(this.logGroup, "Unhandled button " + button);
				}
			}
			/*
			if(this.stateMachine.State() == SlotGameState.Bonus)
			{
				this.currentBonus.Spin();
			}
			*/
		}
		else {
			if (button == Button.ButtonSpin) {
				this.SpinButton(pressed);
			}
		}

		this.panel?.ButtonChanged(button, pressed);
	}

	protected OnCashIn(params: CashInParams): void {
		this.AutoplayDisable();
		this.panel.SetBalance(service.moneyFormatter.FormatCreditCurrentDenom(params.Current), service.moneyFormatter.FormatCurrency(params.Current));
		this.audio.Play(this.resid.ScopedResourceName("cashin"));
	}

	protected OnCashOut(params: CashOutParams): void {
		this.AutoplayDisable();
		this.panel.SetBalance(service.moneyFormatter.FormatCreditCurrentDenom(params.Current), service.moneyFormatter.FormatCurrency(params.Current));
		this.audio.Play(this.resid.ScopedResourceName("cashin"));
	}

	public HistoryView(actionIndex: number, gameState: SimpleSlotGameState): HTMLElement {
		//let gameState: SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState);
		let spinAction: BasegameSpinAction = gameState.Actions[actionIndex] as BasegameSpinAction;
		let triggeredBonus: Bonus = Bonus.None;
		let PayTableDivSize: Size = new Size(170, 164);
		this.Paytablecells = new Size(17, 15);
		this.fontSizePaytableLine = 8.5;
		let bonusList: Bonus[] = [];
		//console.log("Old History: ", gameState)
		//console.log("Current History: ", gameState)

		// for(let i = 0; i < actionIndex; i++)
		// {
		// 	let action: ISimpleBonusAction = (entry2.Actions[i] as ISimpleBonusAction);

		// 	if(action.Bonus == "End")
		// 	{
		// 		bonusList.pop();
		// 	}

		// 	if(action.Bonus != Bonus.None)
		// 	{
		// 		bonusList.push(action.Bonus as Bonus);
		// 	}


		// }
		// triggeredBonus = bonusList[bonusList.length-1];

		if (actionIndex == 0) {

			let lineWinsCount: number = spinAction.Win.ResultLines.length;
			let lines: LineWin[] = spinAction.Win.ResultLines;
			// let leftSideLines: number = lineWinsCount / 2;
			//let rightSideLines: number = lineWinsCount / 2;

			let baseGameView: HTMLElement = CreateElement("div", {
				classes: ["baseGameView"],
				style:
				{
					height: Scale.Hpx(975),
					//width: Scale.Wpx(900),
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
				}
			});

			// left side lines display
			// {
			// 	let linesLeft: HTMLElement = CreateElement("div", {
			// 		classes: ["linesLeft", this.resid.Add("History").Scope()], parentToAppend: baseGameView,
			// 		style:
			// 		{
			// 			width: Scale.Wpx(131),
			// 			height: Scale.Hpx(975),
			// 			display: "flex",
			// 			flexDirection: "column",
			// 			justifyContent: "center",
			// 		}
			// 	});

			// 	for (let i = 0; i < leftSideLines; i++) {
			// 		let line = CreateElement("div", {
			// 			classes: ["line", "" + i], parentToAppend: linesLeft,
			// 			style:
			// 			{
			// 				width: Scale.Wpx(131),
			// 				display: "flex",
			// 				flexDirection: "row",
			// 				//marginBottom:"5px",
			// 			}
			// 		});

			// 		let lineLayout: HTMLElement = CreateElement("div", {
			// 			classes: ["lineLayout"], parentToAppend: line, innerHTML: this.CreatePlayLines([this.initData.Playlines[lines[i].LineIndex]], this.windowSymbolSize, lines[i].LineIndex, PayTableDivSize),
			// 			style:
			// 			{
			// 				display: "flex",
			// 				justifyContent: "center",
			// 				width: Scale.Hpx(78.59),
			// 			}
			// 		});
			// 		let lineStats = CreateElement("div", {
			// 			classes: ["lineStats"], parentToAppend: line, innerHTML: "" + lines[i].SymbolCount + " X " + lines[i].SymbolID + " " + this.moneyFormatter.FormatCurrency(lines[i].Win),
			// 			style:
			// 			{
			// 				fontSize: Scale.fhpx(10),
			// 				color: "white",
			// 				textAlign: "center",
			// 				width: Scale.Wpx(52.38),
			// 				display: "flex",
			// 				justifyContent: "flex-start",
			// 			}
			// 		});
			// 	}
			// }

			let reelView: HTMLElement = null;
			//reel view
			{
				let gameView: HTMLElement = CreateElement("div", {
					classes: ["gameBackground"], parentToAppend: baseGameView,
					style:
					{
						width: Scale.Wpx(770),
						height: Scale.Hpx(700),
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						backgroundPosition: "center",
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						alignItems: "center",
						backgroundImage: this.gameBackground?.CssBackground(),
					}
				});

				// reel view
				reelView = CreateElement("div", {
					classes: ["reelView"], parentToAppend: gameView,
					style:
					{
						width: Scale.Wpx(770),
						height: Scale.Hpx(500),
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}
				});
			}

			// all lines display
			{
				let allLines: HTMLElement = CreateElement("div", {
					classes: ["allLines", this.resid.Add("History").Scope()], parentToAppend: baseGameView,
					style:
					{
						width: "100%",
						height: Scale.Hpx(975),
						display: "flex",
						flexDirection: "row",
						flexWrap: "wrap",
						justifyContent: "center",
					}
				});

				for (let i = 0; i < gameState.Bet.Bet.Lines; i++) {
					let line = CreateElement("div", {
						classes: ["line", "" + i], parentToAppend: allLines,
						style:
						{
							width: Scale.Wpx(131),
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							//marginBottom: Scale.Ypx(5),

						}
					});
					let currentWinLine = spinAction.Win.ResultLines.find(a => a.LineIndex == i);
					let lineLayout: HTMLElement = CreateElement("div", {
						classes: ["lineLayout"], parentToAppend: line, innerHTML: this.CreatePlayLines([this.initData.Playlines[i]], Size.FromPlayWindow(this.initData.PlayWindow), i, PayTableDivSize, false),
						style:
						{
							display: "flex",
							justifyContent: "center",
							width: Scale.Hpx(78.59),
							filter: currentWinLine ? "" : "brightness(50%)",
						}
					});
					let pays: string = "&nbsp";
					if (currentWinLine) {
						pays = "" + currentWinLine.SymbolCount + "×" + currentWinLine.SymbolID + " pays " + service.moneyFormatter.FormatCurrency(currentWinLine.Win);
					}
					let lineStats = CreateElement("div", {
						classes: ["lineStats"], parentToAppend: line, innerHTML: pays,
						style:
						{
							fontSize: Scale.fhpx(14),
							lineHeight: Scale.fhpx(13),
							color: "white",
							textAlign: "center",
							width: "100%",
							//display: "flex",
							//justifyContent: "flex-start",
							margin: Scale.fhpx(3),
						}
					});
				}
			}


			let symbolSize = this.historySpinableReels.GetSymbolSize();

			for (let i = 0; i < spinAction.Spin.ExpectedSymbols.length; i++) {
				for (let j = 0; j < spinAction.Spin.ExpectedSymbols[i].length; j++) {


					const symbolContainer = this.historySpinableReels.symbolsContainer[i][spinAction.Spin.ExpectedSymbols[i].length - 1 - j]
					// remove all child nodes in this.historySpinableReels.symbolsContainer[i][j]
					while (symbolContainer.firstChild) {
						symbolContainer.removeChild(symbolContainer.firstChild);
					}

					// remove canvases from symbols container
					this.historySpinableReels.canvas[i][j].view.style.display = "none"

					let containerSymbolScatter = CreateElement("div", {
						parentToAppend: symbolContainer,
						style: {
							display: "flex",
							justifyContent: "center",
							alignContent: "center",
							alignItems: "center",
							width: "100%",
							height: "100%",
						}
					})

					let symbol = this.symbolCollection.symbolCollectionMap.get("Symbol_" + spinAction.Spin.ExpectedSymbols[i][j]).imgResource.cloneNode() as HTMLElement;
					//if (this.historySpinableReels.symbolsContainer[i][j].childElementCount >=2) this.historySpinableReels.symbolsContainer[i][j].replaceChild(this.historySpinableReels.symbolsContainer[i][j].lastElementChild,symbol)
					//let symbolSize =  this.historySpinableReels.GetSymbolSize();
					symbol.style.width = symbolSize.Width + "px";
					symbol.style.height = "auto";
					symbol.style.position = "absolute";

					containerSymbolScatter.appendChild(symbol);

					//ADD SRA VALUE 
					if (spinAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"]) {

						//console.log("Symbols Expected", )
						const scatterPosition: AwardOptionPosition = (spinAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => i == s.Col && j == s.Row);

						if (scatterPosition != null) {

							const textHTML = CreateElement("div", {
								style: {
									fontSize: Scale.fhpx(20),
									textAlign: "center",
									justifyContent: "center",
									fontFamily: "NotoSansDisplay-Bold",
									alignContent: "center",
									zIndex: ZIndex.BonusWin + "",
									color: "white",
									textShadow: `${Scale.fhpx(1)} ${Scale.fhpx(1)}  ${Scale.fhpx(1)} black , ${Scale.fhpx(2)} ${Scale.fhpx(2)}  ${Scale.fhpx(2)} black  `
								}
							});

							this.scatterRandomAwardFeature?.GetHistoryValue({
								bet: gameState.Bet.Bet,
								scatterPosition: scatterPosition,
								parentElement: textHTML,
								multiplier: 1
							});

							containerSymbolScatter.appendChild(textHTML);
						}
					}
				}
			}



			reelView.appendChild(this.historySpinableReels.GetView());

			return baseGameView;
		}

		let bonus: SlotBonus = this.bonusList.get(spinAction.Bonus as Bonus);
		if (bonus) {
			return bonus.HistoryView(actionIndex, gameState);
		}

		let baseGameView: HTMLElement = CreateElement("div", {
			classes: ["baseGameView"],
			style:
			{
				lineHeight: Scale.fhpx(50),
				fontSize: Scale.fhpx(50),
				width: "100%",
				height: "100%",
				color: "white",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			},
			innerHTML: `Action can't be displayed. <br /><br /><b>${spinAction.Bonus}</b><br />not loaded in this math.`,
		});

		return baseGameView;
	}

	public HistoryStats2(actionIndex: number, gameState: SimpleSlotGameState): ActionStats {
		//let gameState : SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState); 
		let spinAction: BasegameSpinAction = gameState.Actions[actionIndex] as BasegameSpinAction;
		let triggeredBonus: Bonus = Bonus.None;

		//let bonusList: Bonus[] = [];

		// for(let i = 0; i < actionIndex; i++)
		// {
		// 	let action: ISimpleBonusAction = (gameState.Actions[i] as ISimpleBonusAction);
		// 	if(action.Phase == "Start")
		// 	{
		// 		if(action.Bonus != Bonus.None){
		// 			bonusList.push(action.Bonus as Bonus);

		// 		}
		// 	}


		// }
		// console.log("Bonus Won:",bonusList);
		// triggeredBonus = bonusList[bonusList.length-1];

		if (actionIndex == 0) {
			let actionStats: HTMLElement = CreateElement("div", {
				style:
				{
					width: "100%",
					height: "100%",
					fontSize: Scale.fhpx(50),
				}
			});



			let action = spinAction;

			return {
				Bonus: action.Bonus,
				Action: action.Action,
				Stats: [
					{ key: "Bet lines", value: service.moneyFormatter.FormatQuantity(gameState.Bet.Bet.Lines) },
					{ key: "Bet denom", value: service.moneyFormatter.FormatCurrency(gameState.Bet.Bet.Denom) },
					{ key: "Bet total", value: service.moneyFormatter.FormatCurrency(gameState.Bet.Bet.TotalBetCents) },
					//{key: "Bonus triggered", value: action.TriggeredBonus},
					{ key: "Lines win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.PaytableWin) },
					{ key: "Scatter win", value: service.moneyFormatter.FormatCurrency(action.Win.ScaterWin.InCents) },
					{ key: "Basegame win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin) },
					{ key: "Reel stops", value: action.SpinWithFeatures.ReelStops.join("-") }
				]
			}
		}
		else {

			let bonus: SlotBonus = this.bonusList.get(spinAction.Bonus as Bonus);
			return bonus.HistoryStats2(actionIndex, gameState);
		}

		return null;

	}

	public startDoubleUpGame(unfinishedGameState: DoubleUpGameState = null) {

		// not active, skip
		if (!this.doubleUpView) {
			this.stateMachine.ChangeState(SlotGameState.Idle);
			return;
		}

		this.doubleUpView.Start(unfinishedGameState);
	}

	protected finishDoubleUpGame() {
		this.lastSpinResult = null;
	}


	public CreatePlayLines(lines: number[][], slotSize: Size, lineIndex: number, PayTableDivSize: Size, displayNumber: boolean = true): string {
		let colors: Color[] = [];
		let linesContent = "";

		colors = MakeColorGradient(2.4, 2.4, 2.4, 0, 2, 4, 128, 127, 50, 1);

		for (let li = 0; li < lines.length; li++) {
			let color: Color; // = colors[li % colors.length];
			if (lineIndex != -1) {
				color = colors[lineIndex % colors.length];
			}
			else {
				color = colors[li % colors.length]
			}


			if (lineIndex != -1) {
				linesContent += this.CreateOnePlayLine(lineIndex, lines[li], color, slotSize, PayTableDivSize, displayNumber).innerHTML;
			}
			else {
				linesContent += this.CreateOnePlayLine(li, lines[li], color, slotSize, PayTableDivSize, displayNumber).innerHTML;
			}

			/* += `<div class="lines-line" id="linesline">
							<div class="lines-number" id="linesnumber">${lineNumber}</div>
							<div class="lines-window" id="lineswindow">`; 

			for (let ri = 0; ri < lines[li].length; ri++) 
			{
				linesContent += `<div class="lines-reel" id="linesreel">`;
				for (let si = 0; si < slotSize.height; si++) 
				{
					if (si == lines[li][ri])
					{
						//linesContent += `<div class="lines-symbol mark" style="background-color:rgba (${color.r, color.g, color.b, color.a})"></div>`;
						linesContent += `<div class="lines-symbol mark" style="background:rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})"></div>`;
					}
					else
					{
						linesContent += `<div class="lines-symbol"></div>`;
					}
				}
				linesContent += `</div>`;
			}
			linesContent += `</div></div>`; */
		}

		//this.pageContent = this.view.querySelector(".page-content");
		//this.pageContent.innerHTML = linesContent;
		return linesContent;
	}

	protected Paytablecells: Size = new Size(15, 16);
	protected fontSizePaytableLine: number = 15;
	protected CreateOnePlayLine(lineIndex: number, line: number[], color: Color, slotSize: Size, PayTableDivSize: Size, displayNumber: boolean = true): HTMLElement {
		let linesContent = "";
		let lineNumber = lineIndex + 1;




		let LinesLineContainer = CreateElement("div", {
			classes: ["lines-line-container"],
			style: {
				width: Scale.Wpx(PayTableDivSize.Width),
				display: "flex",
				justifyContent: "space-between",
				//marginBottom:Scale.Ypx(20),

			}
		});

		let LinesLine = CreateElement("div", {
			classes: ["lines-line"],
			parentToAppend: LinesLineContainer,
			style: {
				width: Scale.Wpx(PayTableDivSize.Width),
				display: "flex",
				justifyContent: "space-between",
				//marginBottom:Scale.Ypx(20),
				flexFlow: "column",
				margin: "auto 5px",

			}
		});
		if (displayNumber) {
			let LinesNumber = CreateElement("div", {
				classes: ["lines-number"],
				parentToAppend: LinesLine,
				style: {
					textAlign: "center",
					color: "yellow",
					fontSize: Scale.fhpx(this.fontSizePaytableLine),
					lineHeight: Scale.fhpx(this.fontSizePaytableLine * 1.2)
				}
			});

			LinesNumber.innerHTML = lineNumber.toString();
		}
		let LinesWindow = CreateElement("div", {
			classes: ["lines-window"],
			parentToAppend: LinesLine,
			style: {
				display: "flex",
				flexDirection: "row",
				margin: Scale.XYpx(1),
				justifyContent: "center",
			}
		});

		// linesContent += `<div class="lines-line" id="linesline">
		// 				<div class="lines-number" id="linesnumber">${lineNumber}</div>
		// 				<div class="lines-window" id="lineswindow">`; 


		for (let ri = 0; ri < line.length; ri++) {
			//linesContent += `<div class="lines-reel" id="linesreel">`;
			let LinesReel = CreateElement("div", {
				classes: ["lines-reel"],
				parentToAppend: LinesWindow,
				style: {
					display: "flex",
					flexDirection: "column",
					flexGrow: "0",
					flexShrink: "0",
					boxSizing: "border-box",
					//border: Scale.XY(1) + "px solid red",

				}
			});


			for (let si = 0; si < slotSize.Height; si++) {
				if (si == line[ri]) {
					//linesContent += `<div class="lines-symbol mark" style="background-color:rgba (${color.r, color.g, color.b, color.a})"></div>`;

					let LinesSymbol = CreateElement("div", {
						classes: ["lines-symbol", "mark"],
						parentToAppend: LinesReel,
						style: {
							width: Scale.Wpx(this.Paytablecells.Width),
							height: Scale.Hpx(this.Paytablecells.Height),
							backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
							boxSizing: "border-box",
							//border: Scale.XY(1) + "px solid darkgray",

						}
					});


				}
				else {
					//linesContent += `<div class="lines-symbol"></div>`;
					let LinesSymbol = CreateElement("div", {
						classes: ["lines-symbol"],
						parentToAppend: LinesReel,
						style: {
							width: Scale.Wpx(this.Paytablecells.Width),
							height: Scale.Hpx(this.Paytablecells.Height),
							backgroundColor: `lightgray`,
							boxSizing: "border-box",
							border: Scale.XY(1) + "px solid darkgray",

						}
					});

				}
			}
			//linesContent += `</div>`;

		}
		//linesContent += `</div></div>`;
		//LinesWindow.innerHTML+=linesContent;

		return LinesLineContainer;
	}

	public CallAttendant(): void {
		this.panel?.CallAttendant();
	}

	public CancelCallAttendant(): void {
		this.panel?.CancelCallAttendant();
	}

	//Autoplay
	// public AutoPlayStart(): void
	// {
	// 	this.panel?.AutoPlay();
	// }

	// public CancelAutoPlay(): void
	// {
	// 	this.panel?.CancelAutoPlay();
	// }


	public Payout(): void {
		// request payout
	}

	public CancelPayout(): void {
		// cancel payout
	}

	public IsIdle(): boolean {
		return this.stateMachine.State() == SlotGameState.Idle && // is idle
			!this.autoPlay && // is not autoplay
			!this.turboSpin; // is not turbo
	}

	public ReelsRestored() {
		this.reelElement = this.spinnableReels.ReelElements;
		this.reelMask = this.spinnableReels.ReelWindowMask;

		if (this.stateMachine.State() == SlotGameState.Bonus) {
			// not redrawing basegame  in bonus
			return;
		}



		this.RedrawAllReels(true);
		this.symbolCollection.CreateSymbolAnimationAllReels();
		this.RedrawAllReels();
	}

	public override FillingPotDebuggerAnims(command: string, potIndex?: number) {
		if (this.fillingPotFeature?.IsCreated() == true) {
			if (command == "level") this.fillingPotFeature?.LevelDebuggerTest();
			else if (command == "particles") this.fillingPotFeature?.ParticlesDebugger();
			else if (command == "pathsra") this.fillingPotFeature?.PathDebuggerTest("pathsra");
			else if (command == "pathsraall") this.fillingPotFeature?.PathDebuggerTest("pathsraall");
			else if (command == "bonusfilling") this.fillingPotFeature?.StartBonusWin(BonusWillUpdateFillingPotFeature.random());
			else if (command == "anticipation") {
				this.fillingPotFeature?.StartAnticipationBegin();
				for (let index = 0; index < this.initData.PlayWindow.Width; index++) {
					this.anticipationAnimation.ShowReelAnimation(index);
					setTimeout(() => {
						this.anticipationAnimation.HideReelAnimation(index);
					}, 1000);
				}
			}
			else if (command.includes("skin")) {
				this.fillingPotFeature?.SetSkinDebugg(command);
			}
			else if (command.match(/ra([0-9]{1,2})/)) {
				let regex = /[-+]?\d{1,2}/;
				let numberAnimToPlay = command.match(regex);
				this.fillingPotFeature.FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay[0]);
			}
			else if (potIndex == 0) {
				let level = parseInt(command)
				this.fillingPotFeature?.LevelDebuggerTest(level, potIndex);
			}
			else if (potIndex == 1) {
				let level = parseInt(command)
				this.fillingPotFeature?.LevelDebuggerTest(level, potIndex);
			}
			else if (potIndex == 2) {
				let level = parseInt(command)
				this.fillingPotFeature?.LevelDebuggerTest(level, potIndex);
			}
			else {
				let level = parseInt(command)
				this.fillingPotFeature?.LevelDebuggerTest(level);
			}
		}
		else if (this.currentBonus) {
			if (command == "level") this.currentBonus?.fillingPotFeature?.LevelDebuggerTest();
			else if (command == "particles") this.currentBonus.fillingPotFeature?.ParticlesDebugger();
			else if (command == "pathsra") this.currentBonus?.fillingPotFeature?.PathDebuggerTest("pathsra");
			else if (command == "pathsraall") this.currentBonus?.fillingPotFeature?.PathDebuggerTest("pathsraall");
			else if (command == "bonusfilling") this.currentBonus?.fillingPotFeature?.StartBonusWin(BonusWillUpdateFillingPotFeature.random());
			else if (command == "anticipation") this.currentBonus.fillingPotFeature?.StartAnticipationBegin();
			else if (command == "skin") {
				this.currentBonus?.fillingPotFeature?.SetSkinDebugg("3-Purple");
			}
			else if (command.match(/ra([0-9]{1,2})enter/)) {
				this.fillingPotFeature.FillingPotDebuggerRAAnimationDebugger(command);
			} else {
				let level = parseInt(command)
				this.currentBonus.fillingPotFeature?.LevelDebuggerTest(level);
			}
		}
	}

	public StartBigWinBaseGame(): void {
		this.shakeAnimation.Start();
		this.audio.Play(this.resid.ScopedResourceName("bigwin"));

		setTimeout(() => {
			this.shakeAnimation.Update();
			this.shakeAnimation.Stop();
			this.audio.Stop(this.resid.ScopedResourceName("bigwin"));
		}, 1000);

	}


	public OnJackpotValues(data: JackpotValue2[]) {
		globalThis.jackpotDisplayGlobalResponsive.UpdateValues(data);
	}

	protected lineCountBackground: ITrack = null;
	protected GetAudioLevelTrackWinLines() {
		//let track = this.audio.Track(this.resid.ScopedResourceName("lineCountBackground"));
		this.lineCountBackground.SetVolumeAnalog(this.audio.GetAudioLevel());
		this.winlnestoAnimateFadeOut.volume = this.audio.GetAudioLevel();
		//console.log("WinLinesComplete",this.audio.GetAudioLevel())
	}


	public override SharedJackpotWin(win: SharedJackpotWin) {
		if (this.stateMachine.State() == SlotGameState.Bonus) {
			this.currentBonus?.SharedJackpotWin(win);
		}
		else {
			this.jackpotSharedShow?.ShowShared(win);
		}
	}

	public override BonusMultiplierDebugger() {
		let levels = [2, 3];
		this.bonusMultiplier?.SetBonusMultiplier(levels.random(), true);
		levels = null;
	}

	// received shared jackpot game state, pretend like playing a game. Update win, report game ended
	public override async SharedJackpotUpdate(sharedJackpotGameState: SharedJackpotGameState): Promise<void> {
		// pretend like its part of previous game
		const addedWin = this.clientState.Win + sharedJackpotGameState.WinAmount.InCents;

		// this.clientState.TryGameStart(sharedJackpotGameState.BetCents);
		// this.clientState.ConfirmGameStart(sharedJackpotGameState.CreditStart, sharedJackpotGameState.BetCents)
		// this.clientState.SetWin(sharedJackpotGameState.WinAmount.InCents, "SharedJackpotUpdate");
		// this.clientState.GameEnd(sharedJackpotGameState.WinAmount.InCents, sharedJackpotGameState.CreditEnd.InCents);


		this.clientState.UpdateBalance(sharedJackpotGameState.CreditEnd.InCents)
		this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(addedWin), service.moneyFormatter.FormatCurrency(addedWin));

		try {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			await service.api?.gameFinished();
		}
		catch (ex) {
			// could not signal game was finished
			Log.Error(this.logGroup, "Could not signal game finished", ex)
		}
	}

	public override RamclearFillingPot() {
		this.fillingPotFeature?.RamclearFillingPot(this.selectedBet)
	}

	public async StopFountain() {
		this.fountainAnimation.Stop();
	}

	public destroyFountain() {
		this.fountainAnimation?.Destroy();
		// this.fountainAnimation = null;

	}
	lastOrientation: Orientation = null;

	public async OnResize(w: number, h: number, orientation: Orientation) {

		await Delay(100);

		this.gameViewAppPixi?.OnResize();
		this.denomMenu?.onResize();
		this.currentBonus?.OnResize();

		if (this.fillingPotFeature) {
			this.fillingPotFeature.OnResize();
		}

		if (this.payTable) {
			this.payTable.OnResize();
		}
		// this.bonusMultiplier?.OnResize();
		this.fountainAnimation?.OnResize();

		// this.buyBonusMenu?.OnResize();

		// this.BuyBonusPopUp.OnResize();

		// this.bonusMultiplierResponsive?.Destroy();
		// this.CreateBonusMultiplier();

		// if (orientation == Orientation.Landscape)
		// {
		// 	if (this.initData.JackpotEnabled)
		// 	{
		// 		// switch jackpot to landscape
		// 	}
		// 	else
		// 	{
		// 		// remove paytable
		// 		// this.responsiveJackpot.style.display = "none";
		// 	}
		// }
		// else
		// {
		// 	if (this.initData.JackpotEnabled)
		// 	{
		// 		// switch jackpot to landscape
		// 	}
		// 	else
		// 	{
		// 		// remove paytable
		// 		// this.responsiveJackpot.style.display = "flex";
		// 	}
		// }

		// let reelsRatio = 0;
		// let jackpotRatio = 0;

		if (globalThis.jackpotDisplayGlobalResponsive) {
			await Delay(100);
			// if (orientation == Orientation.Landscape)
			// {	
			// 	// this.responsiveJackpot.style.flexGrow = "0.5";
			// }
			// else
			// {
			// 	// this.responsiveJackpot.style.flexGrow = "1";
			// }
			await globalThis.jackpotDisplayGlobalResponsive.OnResize();
		}

		if (orientation != this.lastOrientation) {


			// globalThis.jackpotDisplayGlobalResponsive.OnResize(w, h, orientation);


			// if (orientation != Orientation.Portrait)
			// {
			// 	jackpotWidth = Scale.W(2400);
			// 	jackpotHeight = Scale.H(1080 * 0.5);
			// }
			// else
			// {
			// 	jackpotWidth  = Scale.W(1920);
			// 	jackpotHeight = Scale.H(1080);
			// }



			// // const r = this.responsiveJackpot.getBoundingClientRect();
			// console.log("responsiveJackpot: ", r.width, r.height);
			// console.log("jackpotDisplay: ", jackpotWidth, jackpotHeight);

			// const parentRect = new Rect(0, 0, r.width, r.height);
			// const childRect = new Rect(0, 0, jackpotWidth, jackpotHeight);

			// let fitRect = Geometry.FitRect(childRect, parentRect);
			// this.responsiveReelsFit.style.width = fitRect.width + "px";
			// this.responsiveReelsFit.style.height = fitRect.height + "px";

			// let fitRatio = Geometry.FitRectRatio(childRect, parentRect);

			// globalThis.jackpotDisplayGlobalResponsive.View().style.transform = `scale(${fitRatio})`;
			// globalThis.jackpotDisplayGlobalResponsive.View().style.transformOrigin = `center`;

		}
		// globalThis.jackpotDisplayGlobalResponsive.OnResize(w, h, orientation);


		// reels
		// {
		// 	const r = this.responsiveReels.getBoundingClientRect();
		// 	const parentRect = new Rect(0, 0, r.width, r.height);
		// 	const childRect = new Rect(0, 0, Settings.ScreenWidth, Settings.ScreenHeight);

		// 	let fitRect = Geometry.FitRect(childRect, parentRect);
		// 	this.responsiveReelsFit.style.width = fitRect.width + "px";
		// 	this.responsiveReelsFit.style.height = fitRect.height + "px";

		// 	let fitRatio = Geometry.FitRectRatio(childRect, parentRect);

		// 	if (orientation == Orientation.Landscape)
		// 		fitRatio *= 1.2;

		// 	this.view.style.transform = `scale(${fitRatio})`;
		// 	this.view.style.transformOrigin = `center`;

		// 	this.denomResponsiveContainerFit.style.transform = `scale(${fitRatio})`;
		// 	this.denomResponsiveContainerFit.style.transformOrigin = 'center'
		// }
		// panel
		{
			(this.panel as PanelOnlineResponsive).OnResize(w, h, orientation);
			const r = this.responsivePanel.getBoundingClientRect();
			const parentRect = new Rect(0, 0, r.width, r.height);

			// 1575 is design width of panel
			// 160 is design height of panel
			const childRect = new Rect(0, 0, Scale.W(1575), Scale.H(200));

			// let fitRect = Geometry.FitRect(childRect, parentRect);
			// this.responsiveReelsFit.style.width = fitRect.width + "px";
			// this.responsiveReelsFit.style.height = fitRect.height + "px";

			let fitRatio = Geometry.FitRectRatio(childRect, parentRect);

			// this.responsivePanelFit.style.height = (Scale.H(160) * (fitRatio > 1.05 ? 1.05 : fitRatio)) + "px";

			this.panel.View().style.transform = `scale(${ this.lastOrientation == Orientation.Landscape ? fitRatio * 0.9 : fitRatio})`;
			this.panel.View().style.transformOrigin = `bottom`;
			this.panel.OnResize(w, h, orientation);

			if (this.PopUpMenuAnimView) {
				this.PopUpMenuAnimView.style.transform = `scale(${fitRatio})`;
				this.PopUpMenuAnimView.style.transformOrigin = 'center';
			}

			const helpParent = new Rect(0, 0, window.innerWidth, window.innerHeight);

			const childRectHelp = new Rect(0, 0, Scale.W(1920), Scale.H(1080));
			const helpRatio = Geometry.FitRectRatio(childRectHelp, helpParent);



			this.help.View().style.transform = `scale(${helpRatio})`;
			this.help.View().style.transformOrigin = 'center';
		}

		this.lastOrientation = orientation;

		// console.log(`reels ratio: ${reelsRatio}, jackpot ratio: ${jackpotRatio}`);
	}
}

export type ShowPopUpFreeRoundsCallback = (freeRoundsStats: FreeRoundsStats) => void;
